// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const integratedFinanceClientIdRequiredErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(403),
  error: z.object({
    message: z.string(),
    code: z.enum(['INTEGRATED_FINANCE.CLIENT_ID_REQUIRED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const upstreamBadRequestErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['UPSTREAM.BAD_REQUEST']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const upstreamConflictErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['UPSTREAM.CONFLICT']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const upstreamNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['UPSTREAM.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const upstreamRateLimitedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(429),
  error: z.object({
    message: z.string(),
    code: z.enum(['UPSTREAM.RATE_LIMITED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const upstreamServiceErrorErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(500),
  error: z.object({
    message: z.string(),
    code: z.enum(['UPSTREAM.SERVICE_ERROR']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const listAccountStatementsResponseDto = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
  data: z
    .array(
      z
        .object({
          accountId: z
            .uuid()
            .regex(
              /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
            )
            .optional(),
          transactionNumber: z.string().optional(),
          transactionType: z.string().optional(),
          entryType: z.string().optional(),
          entryDateTime: z.string().optional(),
          direction: z.enum(['debit', 'credit']).optional(),
          amount: z.number().optional(),
          balance: z.number().optional(),
          currency: z.string().optional(),
          narrative: z.string().nullish(),
        })
        .readonly(),
    )
    .readonly(),
});

export const accountSameCurrencyLimitReachedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(403),
  error: z.object({
    message: z.string(),
    code: z.enum(['ACCOUNT.SAME_CURRENCY_LIMIT_REACHED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const idempotencyKeyNotProvidedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['IDEMPOTENCY.KEY_NOT_PROVIDED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const genericUnauthorizedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(401),
  error: z.object({
    message: z.string(),
    code: z.enum(['GENERIC.UNAUTHORIZED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const genericPendingLivenessCheckErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['GENERIC.PENDING_LIVENESS_CHECK']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const userConflictEmailNotVerifiedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['USER.CONFLICT.EMAIL_NOT_VERIFIED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const userConflictPhoneNumberNotVerifiedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['USER.CONFLICT.PHONE_NUMBER_NOT_VERIFIED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const createAccountRequestDto = z.object({
  alias: z.string().max(30).optional(),
  currency: z.enum(['EUR']),
});

export const createAccountResponseDtoOutput = z.object({
  data: z.object({
    account: z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .readonly(),
      clientId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      status: z
        .enum(['pending', 'active', 'inactive', 'suspended', 'closed', 'declined'])
        .optional(),
      country: z.string().length(2).readonly(),
      currency: z.string().length(3),
      alias: z.string().max(30).optional(),
      routingCodes: z.record(z.string(), z.unknown()).readonly(),
      iban: z
        .string()
        .min(15)
        .max(31)
        .regex(
          /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{4}([a-zA-Z0-9]?){3,19}$|^[A-Z]{2}\d{5}[0-9A-Z]{13}$/,
        )
        .readonly()
        .nullish(),
      accountNumber: z
        .string()
        .min(8)
        .max(20)
        .regex(/^[0-9]{8,20}$/)
        .readonly()
        .nullish(),
      accountHolderName: z.string().optional(),
      ledgerNumber: z
        .string()
        .length(8)
        .regex(/^[0-9]{8,8}$/)
        .readonly(),
      availableBalance: z.number().readonly().optional(),
      receivableBalance: z.number().readonly().optional(),
      payableBalance: z.number().readonly().optional(),
      accountHolderIdentityType: z.enum(['corporate', 'individual']),
      connection: z
        .object({
          id: z.string().optional(),
          serviceProvider: z.string().optional(),
          reference: z.string().optional(),
          state: z
            .enum([
              'pending',
              'creation-in-progress',
              'update-in-progress',
              'dependency-completed',
              'completed-up-to-date',
              'completed-outdated',
              'dependency-failed',
              'creation-failed',
            ])
            .optional(),
          status: z.enum(['active', 'inactive', 'closed']).optional(),
          method: z.enum(['built-in', 'plug-in']).optional(),
          error: z
            .object({
              category: z.enum(['functional', 'technical']).optional(),
              origin: z.enum(['customer', 'platform', 'provider']).optional(),
              code: z.string().optional(),
              message: z.string().optional(),
              attributes: z.record(z.string(), z.string()).optional(),
            })
            .optional(),
        })
        .readonly()
        .optional(),
      serviceProvider: z.string().readonly(),
      mainAccountId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .readonly()
        .nullable(),
      attributes: z.record(z.string(), z.unknown()).optional(),
      createdAt: z.string().nullable(),
    }),
  }),
});

export const listAccountsResponseDtoOutput = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
  data: z
    .array(
      z.object({
        id: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .readonly(),
        clientId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        status: z
          .enum(['pending', 'active', 'inactive', 'suspended', 'closed', 'declined'])
          .optional(),
        country: z.string().length(2).readonly(),
        currency: z.string().length(3),
        alias: z.string().max(30).optional(),
        routingCodes: z.record(z.string(), z.unknown()).readonly(),
        iban: z
          .string()
          .min(15)
          .max(31)
          .regex(
            /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{4}([a-zA-Z0-9]?){3,19}$|^[A-Z]{2}\d{5}[0-9A-Z]{13}$/,
          )
          .readonly()
          .nullish(),
        accountNumber: z
          .string()
          .min(8)
          .max(20)
          .regex(/^[0-9]{8,20}$/)
          .readonly()
          .nullish(),
        accountHolderName: z.string().optional(),
        ledgerNumber: z
          .string()
          .length(8)
          .regex(/^[0-9]{8,8}$/)
          .readonly(),
        availableBalance: z.number().readonly().optional(),
        receivableBalance: z.number().readonly().optional(),
        payableBalance: z.number().readonly().optional(),
        accountHolderIdentityType: z.enum(['corporate', 'individual']),
        connection: z
          .object({
            id: z.string().optional(),
            serviceProvider: z.string().optional(),
            reference: z.string().optional(),
            state: z
              .enum([
                'pending',
                'creation-in-progress',
                'update-in-progress',
                'dependency-completed',
                'completed-up-to-date',
                'completed-outdated',
                'dependency-failed',
                'creation-failed',
              ])
              .optional(),
            status: z.enum(['active', 'inactive', 'closed']).optional(),
            method: z.enum(['built-in', 'plug-in']).optional(),
            error: z
              .object({
                category: z.enum(['functional', 'technical']).optional(),
                origin: z.enum(['customer', 'platform', 'provider']).optional(),
                code: z.string().optional(),
                message: z.string().optional(),
                attributes: z.record(z.string(), z.string()).optional(),
              })
              .optional(),
          })
          .readonly()
          .optional(),
        serviceProvider: z.string().readonly(),
        mainAccountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .readonly()
          .nullable(),
        attributes: z.record(z.string(), z.unknown()).optional(),
        createdAt: z.string().nullable(),
      }),
    )
    .readonly(),
});

export const accountNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['ACCOUNT.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const listAccountStatementsResponseDtoOutput = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
  data: z
    .array(
      z
        .object({
          accountId: z
            .uuid()
            .regex(
              /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
            )
            .optional(),
          transactionNumber: z.string().optional(),
          transactionType: z.string().optional(),
          entryType: z.string().optional(),
          entryDateTime: z.string().optional(),
          direction: z.enum(['debit', 'credit']).optional(),
          amount: z.number().optional(),
          balance: z.number().optional(),
          currency: z.string().optional(),
          narrative: z.string().nullish(),
        })
        .readonly(),
    )
    .readonly(),
});

/**
 * Generic deposit information structure for any payment rail.
 */
export const getAccountDepositInformationResponseDtoOutputSchema0 = z.object({
  accountHolderName: z.string().nullish(),
  country: z
    .string()
    .length(2)
    .regex(/^[A-Z]{2}$/),
  currency: z.string().length(3),
  routingCodes: z.union([
    z.object({
      bic: z.string(),
    }),
    z.object({
      'sort-code': z.string(),
    }),
    z.record(z.string(), z.unknown()),
  ]),
  accountNumber: z
    .string()
    .min(8)
    .max(20)
    .regex(/^[0-9]{8,20}$/)
    .nullish(),
  iban: z
    .string()
    .min(15)
    .max(31)
    .regex(
      /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{4}([a-zA-Z0-9]?){3,19}$|^[A-Z]{2}\d{5}[0-9A-Z]{13}$/,
    )
    .nullish(),
  ledgerNumber: z
    .string()
    .length(8)
    .regex(/^[0-9]{8}$/)
    .nullish(),
  reference: z.string().nullish(),
  bankName: z.string().nullish(),
  bankAddress: z.string().nullish(),
  intermediaryAccount: z
    .lazy((): any => getAccountDepositInformationResponseDtoOutputSchema0)
    .nullish(),
});

/**
 * Map of deposit information per transfer scheme
 */
export const getAccountDepositInformationResponseDtoOutput = z.object({
  'sepa-instant': getAccountDepositInformationResponseDtoOutputSchema0,
  sepa: getAccountDepositInformationResponseDtoOutputSchema0,
  'sepa-target-2': getAccountDepositInformationResponseDtoOutputSchema0,
  internal: getAccountDepositInformationResponseDtoOutputSchema0,
  swift: getAccountDepositInformationResponseDtoOutputSchema0.optional(),
});

export const accountStatementPeriodTooLongErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['ACCOUNT.STATEMENT.PERIOD_TOO_LONG']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const accountStatementTransferLimitExceededErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['ACCOUNT.STATEMENT.TRANSFER_LIMIT_EXCEEDED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const accountStatementDateFromBeforeAccountCreationErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['ACCOUNT.STATEMENT.DATE_FROM_BEFORE_ACCOUNT_CREATION']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const generateStatementRequestDto = z.object({
  dateFrom: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  dateTo: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});

export const accountIsClosedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['ACCOUNT.IS_CLOSED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const setAccountAliasRequestDto = z.object({
  alias: z.string().max(30),
});

export const updateAccountResponseDtoOutput = z.object({
  data: z.object({
    account: z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .readonly()
        .optional(),
      clientId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .readonly()
        .optional(),
      status: z
        .enum(['pending', 'active', 'inactive', 'suspended', 'closed', 'declined'])
        .optional(),
      country: z.string().length(2).readonly().optional(),
      currency: z.string().length(3).readonly().optional(),
      alias: z.string().max(30).optional(),
      routingCodes: z.record(z.string(), z.unknown()).optional(),
      iban: z
        .string()
        .min(15)
        .max(31)
        .regex(
          /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{4}([a-zA-Z0-9]?){3,19}$|^[A-Z]{2}\d{5}[0-9A-Z]{13}$/,
        )
        .nullish(),
      accountNumber: z
        .string()
        .min(8)
        .max(20)
        .regex(/^[0-9]{8,20}$/)
        .nullish(),
      accountHolderName: z.string().readonly().optional(),
      ledgerNumber: z
        .string()
        .length(8)
        .regex(/^[0-9]{8,8}$/)
        .readonly()
        .optional(),
      availableBalance: z.number().readonly().optional(),
      receivableBalance: z.number().readonly().optional(),
      payableBalance: z.number().readonly().optional(),
      accountHolderIdentityType: z.enum(['corporate', 'individual']).optional(),
      connection: z
        .object({
          id: z.string().optional(),
          serviceProvider: z.string().optional(),
          reference: z.string().optional(),
          state: z
            .enum([
              'pending',
              'creation-in-progress',
              'update-in-progress',
              'dependency-completed',
              'completed-up-to-date',
              'completed-outdated',
              'dependency-failed',
              'creation-failed',
            ])
            .optional(),
          status: z.enum(['active', 'inactive', 'closed']).optional(),
          method: z.enum(['built-in', 'plug-in']).optional(),
          error: z
            .object({
              category: z.enum(['functional', 'technical']).optional(),
              origin: z.enum(['customer', 'platform', 'provider']).optional(),
              code: z.string().optional(),
              message: z.string().optional(),
              attributes: z.record(z.string(), z.string()).optional(),
            })
            .optional(),
        })
        .readonly()
        .optional(),
      serviceProvider: z.string().readonly().optional(),
      mainAccountId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .readonly()
        .nullish(),
      attributes: z.record(z.string(), z.unknown()).optional(),
      createdAt: z.string().nullable(),
    }),
  }),
});

export const accountNotActiveErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['ACCOUNT.NOT_ACTIVE']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const accountNotInactiveErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['ACCOUNT.NOT_INACTIVE']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const setAccountStatusRequestDto = z.object({
  status: z.enum(['active', 'inactive', 'suspended', 'closed']),
});

export const listBeneficiariesResponseDtoOutput = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
  data: z
    .array(
      z.object({
        id: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        address: z
          .object({
            country: z
              .string()
              .length(2)
              .regex(/^[A-Z]{2}$/),
            region: z.string().optional(),
            postalCode: z.string().optional(),
            city: z.string(),
            street: z.string(),
            houseNumber: z.string().optional(),
            refinement: z.string().optional(),
          })
          .nullish(),
        title: z.string().optional(),
        fullName: z.string().optional(),
      }),
    )
    .readonly(),
});

export const createIndividualBeneficiaryRequestDto = z.object({
  identity: z.object({
    firstName: z.string().min(1),
    lastName: z.string().min(1),
  }),
  address: z
    .object({
      country: z.enum([
        'AD',
        'AE',
        'AF',
        'AG',
        'AI',
        'AL',
        'AM',
        'AO',
        'AQ',
        'AR',
        'AS',
        'AT',
        'AU',
        'AW',
        'AX',
        'AZ',
        'BA',
        'BB',
        'BD',
        'BE',
        'BF',
        'BG',
        'BH',
        'BI',
        'BJ',
        'BL',
        'BM',
        'BN',
        'BO',
        'BQ',
        'BR',
        'BS',
        'BT',
        'BV',
        'BW',
        'BY',
        'BZ',
        'CA',
        'CC',
        'CD',
        'CF',
        'CG',
        'CH',
        'CI',
        'CK',
        'CL',
        'CM',
        'CN',
        'CO',
        'CR',
        'CU',
        'CV',
        'CW',
        'CX',
        'CY',
        'CZ',
        'DE',
        'DJ',
        'DK',
        'DM',
        'DO',
        'DZ',
        'EC',
        'EE',
        'EG',
        'EH',
        'ER',
        'ES',
        'ET',
        'FI',
        'FJ',
        'FK',
        'FM',
        'FO',
        'FR',
        'GA',
        'GB',
        'GD',
        'GE',
        'GF',
        'GG',
        'GH',
        'GI',
        'GL',
        'GM',
        'GN',
        'GP',
        'GQ',
        'GR',
        'GS',
        'GT',
        'GU',
        'GW',
        'GY',
        'HK',
        'HM',
        'HN',
        'HR',
        'HT',
        'HU',
        'ID',
        'IE',
        'IL',
        'IM',
        'IN',
        'IO',
        'IQ',
        'IR',
        'IS',
        'IT',
        'JE',
        'JM',
        'JO',
        'JP',
        'KE',
        'KG',
        'KH',
        'KI',
        'KM',
        'KN',
        'KP',
        'KR',
        'KW',
        'KY',
        'KZ',
        'LA',
        'LB',
        'LC',
        'LI',
        'LK',
        'LR',
        'LS',
        'LT',
        'LU',
        'LV',
        'LY',
        'MA',
        'MC',
        'MD',
        'ME',
        'MF',
        'MG',
        'MH',
        'MK',
        'ML',
        'MM',
        'MN',
        'MO',
        'MP',
        'MQ',
        'MR',
        'MS',
        'MT',
        'MU',
        'MV',
        'MW',
        'MX',
        'MY',
        'MZ',
        'NA',
        'NC',
        'NE',
        'NF',
        'NG',
        'NI',
        'NL',
        'NO',
        'NP',
        'NR',
        'NU',
        'NZ',
        'OM',
        'PA',
        'PE',
        'PF',
        'PG',
        'PH',
        'PK',
        'PL',
        'PM',
        'PN',
        'PR',
        'PS',
        'PT',
        'PW',
        'PY',
        'QA',
        'RE',
        'RO',
        'RS',
        'RU',
        'RW',
        'SA',
        'SB',
        'SC',
        'SD',
        'SE',
        'SG',
        'SH',
        'SI',
        'SJ',
        'SK',
        'SL',
        'SM',
        'SN',
        'SO',
        'SR',
        'SS',
        'ST',
        'SV',
        'SX',
        'SY',
        'SZ',
        'TC',
        'TD',
        'TF',
        'TG',
        'TH',
        'TJ',
        'TK',
        'TL',
        'TM',
        'TN',
        'TO',
        'TR',
        'TT',
        'TV',
        'TW',
        'TZ',
        'UA',
        'UG',
        'UM',
        'US',
        'UY',
        'UZ',
        'VA',
        'VC',
        'VE',
        'VG',
        'VI',
        'VN',
        'VU',
        'WF',
        'WS',
        'XK',
        'YE',
        'YT',
        'ZA',
        'ZM',
        'ZW',
      ]),
      city: z.string().min(1),
      street: z.string().min(1),
    })
    .optional(),
  bankAccounts: z
    .array(
      z.object({
        country: z.enum([
          'AD',
          'AE',
          'AF',
          'AG',
          'AI',
          'AL',
          'AM',
          'AO',
          'AQ',
          'AR',
          'AS',
          'AT',
          'AU',
          'AW',
          'AX',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BF',
          'BG',
          'BH',
          'BI',
          'BJ',
          'BL',
          'BM',
          'BN',
          'BO',
          'BQ',
          'BR',
          'BS',
          'BT',
          'BV',
          'BW',
          'BY',
          'BZ',
          'CA',
          'CC',
          'CD',
          'CF',
          'CG',
          'CH',
          'CI',
          'CK',
          'CL',
          'CM',
          'CN',
          'CO',
          'CR',
          'CU',
          'CV',
          'CW',
          'CX',
          'CY',
          'CZ',
          'DE',
          'DJ',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'EH',
          'ER',
          'ES',
          'ET',
          'FI',
          'FJ',
          'FK',
          'FM',
          'FO',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GF',
          'GG',
          'GH',
          'GI',
          'GL',
          'GM',
          'GN',
          'GP',
          'GQ',
          'GR',
          'GS',
          'GT',
          'GU',
          'GW',
          'GY',
          'HK',
          'HM',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IM',
          'IN',
          'IO',
          'IQ',
          'IR',
          'IS',
          'IT',
          'JE',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KP',
          'KR',
          'KW',
          'KY',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'LY',
          'MA',
          'MC',
          'MD',
          'ME',
          'MF',
          'MG',
          'MH',
          'MK',
          'ML',
          'MM',
          'MN',
          'MO',
          'MP',
          'MQ',
          'MR',
          'MS',
          'MT',
          'MU',
          'MV',
          'MW',
          'MX',
          'MY',
          'MZ',
          'NA',
          'NC',
          'NE',
          'NF',
          'NG',
          'NI',
          'NL',
          'NO',
          'NP',
          'NR',
          'NU',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PF',
          'PG',
          'PH',
          'PK',
          'PL',
          'PM',
          'PN',
          'PR',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RE',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SD',
          'SE',
          'SG',
          'SH',
          'SI',
          'SJ',
          'SK',
          'SL',
          'SM',
          'SN',
          'SO',
          'SR',
          'SS',
          'ST',
          'SV',
          'SX',
          'SY',
          'SZ',
          'TC',
          'TD',
          'TF',
          'TG',
          'TH',
          'TJ',
          'TK',
          'TL',
          'TM',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'UM',
          'US',
          'UY',
          'UZ',
          'VA',
          'VC',
          'VE',
          'VG',
          'VI',
          'VN',
          'VU',
          'WF',
          'WS',
          'XK',
          'YE',
          'YT',
          'ZA',
          'ZM',
          'ZW',
        ]),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        accountNumber: z.string().optional(),
        iban: z.string().optional(),
        routingCodes: z.record(z.string(), z.unknown()),
        paymentRail: z.enum(['sepa', 'sepa-instant', 'swift']).optional(),
      }),
    )
    .min(1)
    .max(3),
});

export const createBeneficiaryResponseDtoOutput = z.object({
  data: z.object({
    beneficiary: z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      fullName: z.string().optional(),
      address: z
        .object({
          country: z
            .string()
            .length(2)
            .regex(/^[A-Z]{2}$/),
          region: z.string().optional(),
          postalCode: z.string().optional(),
          city: z.string(),
          street: z.string(),
          houseNumber: z.string().optional(),
          refinement: z.string().optional(),
        })
        .nullish(),
    }),
  }),
});

export const createCorporateBeneficiaryRequestDto = z.object({
  identity: z.object({
    legalName: z.string().min(1),
  }),
  address: z
    .object({
      country: z.enum([
        'AD',
        'AE',
        'AF',
        'AG',
        'AI',
        'AL',
        'AM',
        'AO',
        'AQ',
        'AR',
        'AS',
        'AT',
        'AU',
        'AW',
        'AX',
        'AZ',
        'BA',
        'BB',
        'BD',
        'BE',
        'BF',
        'BG',
        'BH',
        'BI',
        'BJ',
        'BL',
        'BM',
        'BN',
        'BO',
        'BQ',
        'BR',
        'BS',
        'BT',
        'BV',
        'BW',
        'BY',
        'BZ',
        'CA',
        'CC',
        'CD',
        'CF',
        'CG',
        'CH',
        'CI',
        'CK',
        'CL',
        'CM',
        'CN',
        'CO',
        'CR',
        'CU',
        'CV',
        'CW',
        'CX',
        'CY',
        'CZ',
        'DE',
        'DJ',
        'DK',
        'DM',
        'DO',
        'DZ',
        'EC',
        'EE',
        'EG',
        'EH',
        'ER',
        'ES',
        'ET',
        'FI',
        'FJ',
        'FK',
        'FM',
        'FO',
        'FR',
        'GA',
        'GB',
        'GD',
        'GE',
        'GF',
        'GG',
        'GH',
        'GI',
        'GL',
        'GM',
        'GN',
        'GP',
        'GQ',
        'GR',
        'GS',
        'GT',
        'GU',
        'GW',
        'GY',
        'HK',
        'HM',
        'HN',
        'HR',
        'HT',
        'HU',
        'ID',
        'IE',
        'IL',
        'IM',
        'IN',
        'IO',
        'IQ',
        'IR',
        'IS',
        'IT',
        'JE',
        'JM',
        'JO',
        'JP',
        'KE',
        'KG',
        'KH',
        'KI',
        'KM',
        'KN',
        'KP',
        'KR',
        'KW',
        'KY',
        'KZ',
        'LA',
        'LB',
        'LC',
        'LI',
        'LK',
        'LR',
        'LS',
        'LT',
        'LU',
        'LV',
        'LY',
        'MA',
        'MC',
        'MD',
        'ME',
        'MF',
        'MG',
        'MH',
        'MK',
        'ML',
        'MM',
        'MN',
        'MO',
        'MP',
        'MQ',
        'MR',
        'MS',
        'MT',
        'MU',
        'MV',
        'MW',
        'MX',
        'MY',
        'MZ',
        'NA',
        'NC',
        'NE',
        'NF',
        'NG',
        'NI',
        'NL',
        'NO',
        'NP',
        'NR',
        'NU',
        'NZ',
        'OM',
        'PA',
        'PE',
        'PF',
        'PG',
        'PH',
        'PK',
        'PL',
        'PM',
        'PN',
        'PR',
        'PS',
        'PT',
        'PW',
        'PY',
        'QA',
        'RE',
        'RO',
        'RS',
        'RU',
        'RW',
        'SA',
        'SB',
        'SC',
        'SD',
        'SE',
        'SG',
        'SH',
        'SI',
        'SJ',
        'SK',
        'SL',
        'SM',
        'SN',
        'SO',
        'SR',
        'SS',
        'ST',
        'SV',
        'SX',
        'SY',
        'SZ',
        'TC',
        'TD',
        'TF',
        'TG',
        'TH',
        'TJ',
        'TK',
        'TL',
        'TM',
        'TN',
        'TO',
        'TR',
        'TT',
        'TV',
        'TW',
        'TZ',
        'UA',
        'UG',
        'UM',
        'US',
        'UY',
        'UZ',
        'VA',
        'VC',
        'VE',
        'VG',
        'VI',
        'VN',
        'VU',
        'WF',
        'WS',
        'XK',
        'YE',
        'YT',
        'ZA',
        'ZM',
        'ZW',
      ]),
      postalCode: z.string().min(1).optional(),
      city: z.string().min(1),
      street: z.string().min(1),
    })
    .optional(),
  bankAccounts: z
    .array(
      z.object({
        country: z.enum([
          'AD',
          'AE',
          'AF',
          'AG',
          'AI',
          'AL',
          'AM',
          'AO',
          'AQ',
          'AR',
          'AS',
          'AT',
          'AU',
          'AW',
          'AX',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BF',
          'BG',
          'BH',
          'BI',
          'BJ',
          'BL',
          'BM',
          'BN',
          'BO',
          'BQ',
          'BR',
          'BS',
          'BT',
          'BV',
          'BW',
          'BY',
          'BZ',
          'CA',
          'CC',
          'CD',
          'CF',
          'CG',
          'CH',
          'CI',
          'CK',
          'CL',
          'CM',
          'CN',
          'CO',
          'CR',
          'CU',
          'CV',
          'CW',
          'CX',
          'CY',
          'CZ',
          'DE',
          'DJ',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'EH',
          'ER',
          'ES',
          'ET',
          'FI',
          'FJ',
          'FK',
          'FM',
          'FO',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GF',
          'GG',
          'GH',
          'GI',
          'GL',
          'GM',
          'GN',
          'GP',
          'GQ',
          'GR',
          'GS',
          'GT',
          'GU',
          'GW',
          'GY',
          'HK',
          'HM',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IM',
          'IN',
          'IO',
          'IQ',
          'IR',
          'IS',
          'IT',
          'JE',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KP',
          'KR',
          'KW',
          'KY',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'LY',
          'MA',
          'MC',
          'MD',
          'ME',
          'MF',
          'MG',
          'MH',
          'MK',
          'ML',
          'MM',
          'MN',
          'MO',
          'MP',
          'MQ',
          'MR',
          'MS',
          'MT',
          'MU',
          'MV',
          'MW',
          'MX',
          'MY',
          'MZ',
          'NA',
          'NC',
          'NE',
          'NF',
          'NG',
          'NI',
          'NL',
          'NO',
          'NP',
          'NR',
          'NU',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PF',
          'PG',
          'PH',
          'PK',
          'PL',
          'PM',
          'PN',
          'PR',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RE',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SD',
          'SE',
          'SG',
          'SH',
          'SI',
          'SJ',
          'SK',
          'SL',
          'SM',
          'SN',
          'SO',
          'SR',
          'SS',
          'ST',
          'SV',
          'SX',
          'SY',
          'SZ',
          'TC',
          'TD',
          'TF',
          'TG',
          'TH',
          'TJ',
          'TK',
          'TL',
          'TM',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'UM',
          'US',
          'UY',
          'UZ',
          'VA',
          'VC',
          'VE',
          'VG',
          'VI',
          'VN',
          'VU',
          'WF',
          'WS',
          'XK',
          'YE',
          'YT',
          'ZA',
          'ZM',
          'ZW',
        ]),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        accountNumber: z.string().optional(),
        iban: z.string().optional(),
        routingCodes: z.record(z.string(), z.unknown()),
        paymentRail: z.enum(['sepa', 'sepa-instant', 'swift']).optional(),
      }),
    )
    .min(1)
    .max(3),
});

export const verifyBeneficiaryDataRequestDto = z.object({
  identity: z.union([
    z.object({
      type: z.enum(['individual']),
      givenName: z.string(),
      familyName: z.string(),
      country: z.string().optional(),
      birthDate: z.string().optional(),
      identifications: z
        .array(
          z.object({
            type: z
              .enum([
                'registration-number',
                'passport',
                'identity-card',
                'driving-licence',
                'foreign-identity-card',
                'tax-number',
              ])
              .optional(),
            identificationNumber: z.string().optional(),
            issuingCountry: z.string().nullish(),
          }),
        )
        .optional(),
    }),
    z.object({
      type: z.enum(['corporate']),
      legalName: z.string(),
      country: z.string().optional(),
      corporationType: z.string().optional(),
      incorporationDate: z.string().optional(),
      identifications: z
        .array(
          z.object({
            type: z
              .enum([
                'registration-number',
                'passport',
                'identity-card',
                'driving-licence',
                'foreign-identity-card',
                'tax-number',
              ])
              .optional(),
            identificationNumber: z.string().optional(),
            issuingCountry: z.string().nullish(),
          }),
        )
        .optional(),
    }),
  ]),
  bankAccount: z.object({
    iban: z.string().optional(),
    accountNumber: z.string().optional(),
    country: z.string().optional(),
    routingCodes: z.record(z.string(), z.unknown()).optional(),
  }),
});

export const verifyBeneficiaryDataResponseDtoOutput = z.object({
  data: z.object({
    matched: z.boolean(),
    reason: z.enum(['match', 'close-match', 'not-matched', 'not-applicable']),
    accountHolderName: z.string().nullable(),
  }),
});

export const getBeneficiaryBankAccountRequirementsResponseDtoOutput = z.object({
  data: z.object({
    beneficiaryBankAccount: z.object({
      requirements: z
        .object({
          beneficiaryAddress: z.enum(['none', 'optional', 'required']).optional(),
        })
        .optional(),
      iban: z
        .object({
          regex: z.string().optional(),
          requirement: z.enum(['none', 'optional', 'required']),
        })
        .optional(),
      accountNumber: z
        .object({
          regex: z.string().optional(),
          requirement: z.enum(['none', 'optional', 'required']),
        })
        .optional(),
      bankName: z
        .object({
          regex: z.string().optional(),
          requirement: z.enum(['none', 'optional', 'required']),
        })
        .optional(),
      routingCodes: z
        .record(
          z.string(),
          z.object({
            regex: z.string().optional(),
            requirement: z.enum(['none', 'optional', 'required']),
          }),
        )
        .optional(),
    }),
    beneficiaryAddress: z
      .object({
        country: z
          .object({
            regex: z.string().optional(),
            requirement: z.enum(['none', 'optional', 'required']),
          })
          .optional(),
        region: z
          .object({
            regex: z.string().optional(),
            requirement: z.enum(['none', 'optional', 'required']),
          })
          .optional(),
        city: z
          .object({
            regex: z.string().optional(),
            requirement: z.enum(['none', 'optional', 'required']),
          })
          .optional(),
        street: z
          .object({
            regex: z.string().optional(),
            requirement: z.enum(['none', 'optional', 'required']),
          })
          .optional(),
        houseNumber: z
          .object({
            regex: z.string().optional(),
            requirement: z.enum(['none', 'optional', 'required']),
          })
          .optional(),
        postalCode: z
          .object({
            regex: z.string().optional(),
            requirement: z.enum(['none', 'optional', 'required']),
          })
          .optional(),
        refinement: z
          .object({
            regex: z.string().optional(),
            requirement: z.enum(['none', 'optional', 'required']),
          })
          .optional(),
      })
      .optional(),
  }),
});

export const beneficiaryNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['BENEFICIARY.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const listBeneficiaryBankAccountsResponseDtoOutput = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
  data: z
    .array(
      z.object({
        id: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        beneficiaryId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        country: z.enum([
          'AD',
          'AE',
          'AF',
          'AG',
          'AI',
          'AL',
          'AM',
          'AO',
          'AQ',
          'AR',
          'AS',
          'AT',
          'AU',
          'AW',
          'AX',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BF',
          'BG',
          'BH',
          'BI',
          'BJ',
          'BL',
          'BM',
          'BN',
          'BO',
          'BQ',
          'BR',
          'BS',
          'BT',
          'BV',
          'BW',
          'BY',
          'BZ',
          'CA',
          'CC',
          'CD',
          'CF',
          'CG',
          'CH',
          'CI',
          'CK',
          'CL',
          'CM',
          'CN',
          'CO',
          'CR',
          'CU',
          'CV',
          'CW',
          'CX',
          'CY',
          'CZ',
          'DE',
          'DJ',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'EH',
          'ER',
          'ES',
          'ET',
          'FI',
          'FJ',
          'FK',
          'FM',
          'FO',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GF',
          'GG',
          'GH',
          'GI',
          'GL',
          'GM',
          'GN',
          'GP',
          'GQ',
          'GR',
          'GS',
          'GT',
          'GU',
          'GW',
          'GY',
          'HK',
          'HM',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IM',
          'IN',
          'IO',
          'IQ',
          'IR',
          'IS',
          'IT',
          'JE',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KP',
          'KR',
          'KW',
          'KY',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'LY',
          'MA',
          'MC',
          'MD',
          'ME',
          'MF',
          'MG',
          'MH',
          'MK',
          'ML',
          'MM',
          'MN',
          'MO',
          'MP',
          'MQ',
          'MR',
          'MS',
          'MT',
          'MU',
          'MV',
          'MW',
          'MX',
          'MY',
          'MZ',
          'NA',
          'NC',
          'NE',
          'NF',
          'NG',
          'NI',
          'NL',
          'NO',
          'NP',
          'NR',
          'NU',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PF',
          'PG',
          'PH',
          'PK',
          'PL',
          'PM',
          'PN',
          'PR',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RE',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SD',
          'SE',
          'SG',
          'SH',
          'SI',
          'SJ',
          'SK',
          'SL',
          'SM',
          'SN',
          'SO',
          'SR',
          'SS',
          'ST',
          'SV',
          'SX',
          'SY',
          'SZ',
          'TC',
          'TD',
          'TF',
          'TG',
          'TH',
          'TJ',
          'TK',
          'TL',
          'TM',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'UM',
          'US',
          'UY',
          'UZ',
          'VA',
          'VC',
          'VE',
          'VG',
          'VI',
          'VN',
          'VU',
          'WF',
          'WS',
          'XK',
          'YE',
          'YT',
          'ZA',
          'ZM',
          'ZW',
        ]),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        accountHolderType: z.enum(['individual', 'corporate']).optional(),
        iban: z.string().optional(),
        accountNumber: z.string().optional(),
        bankName: z.string().optional(),
        routingCodes: z.record(z.string(), z.unknown()).optional(),
        paymentRail: z.enum(['sepa', 'sepa-instant', 'swift']),
      }),
    )
    .readonly(),
});

export const beneficiaryNotActiveErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['BENEFICIARY.NOT_ACTIVE']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const createBeneficiaryBankAccountRequestDto = z.object({
  country: z.enum([
    'AD',
    'AE',
    'AF',
    'AG',
    'AI',
    'AL',
    'AM',
    'AO',
    'AQ',
    'AR',
    'AS',
    'AT',
    'AU',
    'AW',
    'AX',
    'AZ',
    'BA',
    'BB',
    'BD',
    'BE',
    'BF',
    'BG',
    'BH',
    'BI',
    'BJ',
    'BL',
    'BM',
    'BN',
    'BO',
    'BQ',
    'BR',
    'BS',
    'BT',
    'BV',
    'BW',
    'BY',
    'BZ',
    'CA',
    'CC',
    'CD',
    'CF',
    'CG',
    'CH',
    'CI',
    'CK',
    'CL',
    'CM',
    'CN',
    'CO',
    'CR',
    'CU',
    'CV',
    'CW',
    'CX',
    'CY',
    'CZ',
    'DE',
    'DJ',
    'DK',
    'DM',
    'DO',
    'DZ',
    'EC',
    'EE',
    'EG',
    'EH',
    'ER',
    'ES',
    'ET',
    'FI',
    'FJ',
    'FK',
    'FM',
    'FO',
    'FR',
    'GA',
    'GB',
    'GD',
    'GE',
    'GF',
    'GG',
    'GH',
    'GI',
    'GL',
    'GM',
    'GN',
    'GP',
    'GQ',
    'GR',
    'GS',
    'GT',
    'GU',
    'GW',
    'GY',
    'HK',
    'HM',
    'HN',
    'HR',
    'HT',
    'HU',
    'ID',
    'IE',
    'IL',
    'IM',
    'IN',
    'IO',
    'IQ',
    'IR',
    'IS',
    'IT',
    'JE',
    'JM',
    'JO',
    'JP',
    'KE',
    'KG',
    'KH',
    'KI',
    'KM',
    'KN',
    'KP',
    'KR',
    'KW',
    'KY',
    'KZ',
    'LA',
    'LB',
    'LC',
    'LI',
    'LK',
    'LR',
    'LS',
    'LT',
    'LU',
    'LV',
    'LY',
    'MA',
    'MC',
    'MD',
    'ME',
    'MF',
    'MG',
    'MH',
    'MK',
    'ML',
    'MM',
    'MN',
    'MO',
    'MP',
    'MQ',
    'MR',
    'MS',
    'MT',
    'MU',
    'MV',
    'MW',
    'MX',
    'MY',
    'MZ',
    'NA',
    'NC',
    'NE',
    'NF',
    'NG',
    'NI',
    'NL',
    'NO',
    'NP',
    'NR',
    'NU',
    'NZ',
    'OM',
    'PA',
    'PE',
    'PF',
    'PG',
    'PH',
    'PK',
    'PL',
    'PM',
    'PN',
    'PR',
    'PS',
    'PT',
    'PW',
    'PY',
    'QA',
    'RE',
    'RO',
    'RS',
    'RU',
    'RW',
    'SA',
    'SB',
    'SC',
    'SD',
    'SE',
    'SG',
    'SH',
    'SI',
    'SJ',
    'SK',
    'SL',
    'SM',
    'SN',
    'SO',
    'SR',
    'SS',
    'ST',
    'SV',
    'SX',
    'SY',
    'SZ',
    'TC',
    'TD',
    'TF',
    'TG',
    'TH',
    'TJ',
    'TK',
    'TL',
    'TM',
    'TN',
    'TO',
    'TR',
    'TT',
    'TV',
    'TW',
    'TZ',
    'UA',
    'UG',
    'UM',
    'US',
    'UY',
    'UZ',
    'VA',
    'VC',
    'VE',
    'VG',
    'VI',
    'VN',
    'VU',
    'WF',
    'WS',
    'XK',
    'YE',
    'YT',
    'ZA',
    'ZM',
    'ZW',
  ]),
  currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
  iban: z.string(),
  accountHolderType: z.enum(['individual', 'corporate']),
  routingCodes: z.record(z.string(), z.unknown()),
  paymentRail: z.enum(['sepa', 'sepa-instant', 'swift']).optional(),
});

export const createBeneficiaryBankAccountResponseDtoOutput = z.object({
  data: z.object({
    bankAccount: z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .readonly()
        .optional(),
      routingCodes: z.record(z.string(), z.unknown()).optional(),
      iban: z.string().optional(),
      currency: z.string(),
      country: z.string(),
      beneficiaryId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      accountHolderType: z.enum(['corporate', 'individual']).optional(),
      paymentRail: z.enum(['sepa', 'sepa-instant', 'swift']),
    }),
  }),
});

export const beneficiaryIdentityMismatchErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['BENEFICIARY.IDENTITY_MISMATCH']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const updateBeneficiaryDetailsRequestDto = z.object({
  identity: z
    .union([
      z.object({
        type: z.enum(['individual']),
        firstName: z.string().min(1).optional(),
        lastName: z.string().min(1).optional(),
      }),
      z.object({
        type: z.enum(['corporate']),
        legalName: z.string().min(1).optional(),
      }),
    ])
    .optional(),
  address: z
    .object({
      country: z.enum([
        'AD',
        'AE',
        'AF',
        'AG',
        'AI',
        'AL',
        'AM',
        'AO',
        'AQ',
        'AR',
        'AS',
        'AT',
        'AU',
        'AW',
        'AX',
        'AZ',
        'BA',
        'BB',
        'BD',
        'BE',
        'BF',
        'BG',
        'BH',
        'BI',
        'BJ',
        'BL',
        'BM',
        'BN',
        'BO',
        'BQ',
        'BR',
        'BS',
        'BT',
        'BV',
        'BW',
        'BY',
        'BZ',
        'CA',
        'CC',
        'CD',
        'CF',
        'CG',
        'CH',
        'CI',
        'CK',
        'CL',
        'CM',
        'CN',
        'CO',
        'CR',
        'CU',
        'CV',
        'CW',
        'CX',
        'CY',
        'CZ',
        'DE',
        'DJ',
        'DK',
        'DM',
        'DO',
        'DZ',
        'EC',
        'EE',
        'EG',
        'EH',
        'ER',
        'ES',
        'ET',
        'FI',
        'FJ',
        'FK',
        'FM',
        'FO',
        'FR',
        'GA',
        'GB',
        'GD',
        'GE',
        'GF',
        'GG',
        'GH',
        'GI',
        'GL',
        'GM',
        'GN',
        'GP',
        'GQ',
        'GR',
        'GS',
        'GT',
        'GU',
        'GW',
        'GY',
        'HK',
        'HM',
        'HN',
        'HR',
        'HT',
        'HU',
        'ID',
        'IE',
        'IL',
        'IM',
        'IN',
        'IO',
        'IQ',
        'IR',
        'IS',
        'IT',
        'JE',
        'JM',
        'JO',
        'JP',
        'KE',
        'KG',
        'KH',
        'KI',
        'KM',
        'KN',
        'KP',
        'KR',
        'KW',
        'KY',
        'KZ',
        'LA',
        'LB',
        'LC',
        'LI',
        'LK',
        'LR',
        'LS',
        'LT',
        'LU',
        'LV',
        'LY',
        'MA',
        'MC',
        'MD',
        'ME',
        'MF',
        'MG',
        'MH',
        'MK',
        'ML',
        'MM',
        'MN',
        'MO',
        'MP',
        'MQ',
        'MR',
        'MS',
        'MT',
        'MU',
        'MV',
        'MW',
        'MX',
        'MY',
        'MZ',
        'NA',
        'NC',
        'NE',
        'NF',
        'NG',
        'NI',
        'NL',
        'NO',
        'NP',
        'NR',
        'NU',
        'NZ',
        'OM',
        'PA',
        'PE',
        'PF',
        'PG',
        'PH',
        'PK',
        'PL',
        'PM',
        'PN',
        'PR',
        'PS',
        'PT',
        'PW',
        'PY',
        'QA',
        'RE',
        'RO',
        'RS',
        'RU',
        'RW',
        'SA',
        'SB',
        'SC',
        'SD',
        'SE',
        'SG',
        'SH',
        'SI',
        'SJ',
        'SK',
        'SL',
        'SM',
        'SN',
        'SO',
        'SR',
        'SS',
        'ST',
        'SV',
        'SX',
        'SY',
        'SZ',
        'TC',
        'TD',
        'TF',
        'TG',
        'TH',
        'TJ',
        'TK',
        'TL',
        'TM',
        'TN',
        'TO',
        'TR',
        'TT',
        'TV',
        'TW',
        'TZ',
        'UA',
        'UG',
        'UM',
        'US',
        'UY',
        'UZ',
        'VA',
        'VC',
        'VE',
        'VG',
        'VI',
        'VN',
        'VU',
        'WF',
        'WS',
        'XK',
        'YE',
        'YT',
        'ZA',
        'ZM',
        'ZW',
      ]),
      city: z.string().min(1),
      street: z.string().min(1),
      postalCode: z.string().min(1).optional(),
    })
    .optional(),
});

export const updateBeneficiaryResponseDtoOutput = z.object({
  data: z.object({
    beneficiary: z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      fullName: z.string().optional(),
      address: z
        .object({
          country: z
            .string()
            .length(2)
            .regex(/^[A-Z]{2}$/),
          region: z.string().optional(),
          postalCode: z.string().optional(),
          city: z.string(),
          street: z.string(),
          houseNumber: z.string().optional(),
          refinement: z.string().optional(),
        })
        .nullish(),
    }),
  }),
});

export const beneficiaryTransferInProgressErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['BENEFICIARY.TRANSFER_IN_PROGRESS']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const beneficiaryBankAccountNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['BENEFICIARY_BANK_ACCOUNT.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const beneficiaryBankAccountUpdateLockedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['BENEFICIARY_BANK_ACCOUNT.UPDATE_LOCKED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const integratedFinanceInvalidCountryForBankAccountErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['INTEGRATED_FINANCE.INVALID_COUNTRY_FOR_BANK_ACCOUNT']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const updateBeneficiaryBankAccountRequestDto = z.object({
  iban: z.string().optional(),
  routingCodes: z.record(z.string(), z.unknown()).optional(),
  paymentRail: z.enum(['sepa', 'sepa-instant', 'swift']).optional(),
});

export const updateBeneficiaryBankAccountResponseDtoOutput = z.object({
  data: z.object({
    bankAccount: z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .readonly()
        .optional(),
      routingCodes: z.record(z.string(), z.unknown()).optional(),
      iban: z.string().optional(),
      currency: z.string(),
      country: z.string(),
      beneficiaryId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      accountHolderType: z.enum(['corporate', 'individual']).optional(),
      paymentRail: z.enum(['sepa', 'sepa-instant', 'swift']),
    }),
  }),
});

export const documentEntityNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['DOCUMENT_ENTITY.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const listDocumentsResponseDtoOutput = z.object({
  data: z.array(
    z.object({
      name: z.string(),
      createdAt: z.iso
        .datetime()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
        ),
      url: z.url(),
    }),
  ),
});

export const uploadDocumentResponseDtoOutput = z.object({
  data: z.object({
    url: z.url(),
    fields: z.record(z.string(), z.string()),
  }),
});

export const getChallengeResponseDtoOutput = z.object({
  data: z.object({
    id: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    status: z.enum(['pending', 'approved', 'denied', 'expired']),
    channel: z.enum(['ciba']),
    expiresAt: z.number(),
    createdAt: z.number(),
  }),
});

export const challengesEmailChangeAlreadyInUseErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.EMAIL_CHANGE_ALREADY_IN_USE']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const initiateEmailChangeChallengeRequestDto = z.object({
  email: z
    .email()
    .regex(
      /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/,
    ),
});

export const challengesEmailChangeNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.EMAIL_CHANGE_NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const challengesEmailChangeInvalidOtpErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.EMAIL_CHANGE_INVALID_OTP']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const verifyEmailChangeChallengeRequestDto = z.object({
  otp: z
    .string()
    .length(6)
    .regex(/^\d{6}$/),
});

export const challengesEmailAlreadyVerifiedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.EMAIL_ALREADY_VERIFIED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const genericRequestLockedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['GENERIC.REQUEST_LOCKED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const challengesEmailSendFailedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(500),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.EMAIL_SEND_FAILED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const resendEmailChallengeResponseDtoOutput = z.object({
  data: z.object({
    status: z.enum(['pending']),
  }),
});

export const kycApplicantNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['KYC.APPLICANT_NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const livenessApplicantNotOnboardedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['LIVENESS.APPLICANT_NOT_ONBOARDED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const startLivenessChallengeRequestDto = z.object({
  sdk: z.enum(['hosted_web']),
});

export const startLivenessChallengeResponseDtoOutput = z.object({
  data: z.object({
    challengeId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    url: z.string(),
  }),
});

export const getLivenessChallengeResponseDtoOutput = z.object({
  data: z.object({
    id: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    status: z.enum(['pending', 'approved', 'denied']),
    createdAt: z.number(),
    expiresAt: z.number(),
  }),
});

export const challengesPhoneInvalidPhoneNumberErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.PHONE_INVALID_PHONE_NUMBER']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const challengesPhoneUnsupportedRegionErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.PHONE_UNSUPPORTED_REGION']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const challengesPhoneMaxAttemptsExceededErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(429),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.PHONE_MAX_ATTEMPTS_EXCEEDED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const challengesPhoneAlreadyVerifiedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.PHONE_ALREADY_VERIFIED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const challengesPhoneTwilioVerificationFailedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(500),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.PHONE_TWILIO_VERIFICATION_FAILED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const initiatePhoneChallengeRequestDto = z.object({
  phoneNumber: z.string().regex(/^\+[1-9]\d{6,14}$/),
});

export const initiatePhoneChallengeResponseDtoOutput = z.object({
  data: z.object({
    challengeId: z.string(),
    status: z.enum(['pending']),
    phoneNumber: z.string(),
  }),
});

export const challengesNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const challengesPhoneInvalidOtpErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.PHONE_INVALID_OTP']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const challengesPhoneNumberAlreadyExistsErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.PHONE_NUMBER_ALREADY_EXISTS']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const verifyPhoneChallengeRequestDto = z.object({
  challengeId: z.string().min(1),
  code: z.string().length(6),
});

export const verifyPhoneChallengeResponseDtoOutput = z.object({
  data: z.object({
    status: z.enum(['approved']),
    phoneNumber: z.string(),
  }),
});

export const clientsIdMismatchErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(403),
  error: z.object({
    message: z.string(),
    code: z.enum(['CLIENTS.ID_MISMATCH']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const getClientResponseDtoOutput = z.object({
  data: z.object({
    attributes: z.record(z.string(), z.unknown()).optional(),
    id: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    clientNumber: z.string(),
    fullName: z.string().optional(),
    status: z.enum(['active', 'inactive']),
    identity: z.union([
      z.object({
        type: z.enum(['corporate', 'individual']).optional(),
        country: z.string().optional(),
        identifications: z
          .array(
            z.object({
              type: z
                .enum([
                  'registration-number',
                  'passport',
                  'identity-card',
                  'driving-licence',
                  'foreign-identity-card',
                  'tax-number',
                ])
                .optional(),
              identificationNumber: z.string().optional(),
              issuingCountry: z.string().nullish(),
              issueDate: z.string().nullish(),
              expirationDate: z.string().nullish(),
            }),
          )
          .optional(),
        legalName: z.string(),
        tradingName: z.string().optional(),
        incorporationDate: z.string().optional(),
        corporationType: z.enum(['ltd', 'plc', 'llp', 'lp', 'gp', 'st', 'other']).optional(),
      }),
      z.object({
        type: z.enum(['corporate', 'individual']).optional(),
        country: z.string().optional(),
        identifications: z
          .array(
            z.object({
              type: z
                .enum([
                  'registration-number',
                  'passport',
                  'identity-card',
                  'driving-licence',
                  'foreign-identity-card',
                  'tax-number',
                ])
                .optional(),
              identificationNumber: z.string().optional(),
              issuingCountry: z.string().nullish(),
              issueDate: z.string().nullish(),
              expirationDate: z.string().nullish(),
            }),
          )
          .optional(),
        givenName: z.string(),
        familyName: z.string(),
        birthDate: z.string().optional(),
      }),
    ]),
    profile: z
      .object({
        identityType: z.string().optional(),
        phone: z.string().optional(),
        email: z.string().optional(),
        primaryAddress: z
          .object({
            country: z.string(),
            region: z.string().optional(),
            postalCode: z.string().optional(),
            city: z.string(),
            street: z.string(),
            houseNumber: z.string().optional(),
            refinement: z.string().optional(),
          })
          .optional(),
        registrationAddress: z
          .object({
            country: z.string(),
            region: z.string().optional(),
            postalCode: z.string().optional(),
            city: z.string(),
            street: z.string(),
            houseNumber: z.string().optional(),
            refinement: z.string().optional(),
          })
          .optional(),
        residentialAddress: z
          .object({
            country: z.string(),
            region: z.string().optional(),
            postalCode: z.string().optional(),
            city: z.string(),
            street: z.string(),
            houseNumber: z.string().optional(),
            refinement: z.string().optional(),
          })
          .optional(),
      })
      .optional(),
    relations: z
      .array(
        z.object({
          id: z
            .uuid()
            .regex(
              /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
            ),
          clientId: z
            .uuid()
            .regex(
              /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
            ),
          relation: z.enum([
            'director',
            'shareholder',
            'director-and-shareholder',
            'authorized-person',
          ]),
          identity: z.union([
            z.object({
              type: z.enum(['corporate', 'individual']).optional(),
              country: z.string().optional(),
              identifications: z
                .array(
                  z.object({
                    type: z
                      .enum([
                        'registration-number',
                        'passport',
                        'identity-card',
                        'driving-licence',
                        'foreign-identity-card',
                        'tax-number',
                      ])
                      .optional(),
                    identificationNumber: z.string().optional(),
                    issuingCountry: z.string().nullish(),
                    issueDate: z.string().nullish(),
                    expirationDate: z.string().nullish(),
                  }),
                )
                .optional(),
              legalName: z.string(),
              tradingName: z.string().optional(),
              incorporationDate: z.string().optional(),
              corporationType: z.enum(['ltd', 'plc', 'llp', 'lp', 'gp', 'st', 'other']).optional(),
            }),
            z.object({
              type: z.enum(['corporate', 'individual']).optional(),
              country: z.string().optional(),
              identifications: z
                .array(
                  z.object({
                    type: z
                      .enum([
                        'registration-number',
                        'passport',
                        'identity-card',
                        'driving-licence',
                        'foreign-identity-card',
                        'tax-number',
                      ])
                      .optional(),
                    identificationNumber: z.string().optional(),
                    issuingCountry: z.string().nullish(),
                    issueDate: z.string().nullish(),
                    expirationDate: z.string().nullish(),
                  }),
                )
                .optional(),
              givenName: z.string(),
              familyName: z.string(),
              birthDate: z.string().optional(),
            }),
          ]),
          percentageOfOwnership: z.number().optional(),
          profile: z
            .object({
              identityType: z.string().optional(),
              phone: z.string().optional(),
              email: z.string().optional(),
              primaryAddress: z
                .object({
                  country: z.string(),
                  region: z.string().optional(),
                  postalCode: z.string().optional(),
                  city: z.string(),
                  street: z.string(),
                  houseNumber: z.string().optional(),
                  refinement: z.string().optional(),
                })
                .optional(),
              registrationAddress: z
                .object({
                  country: z.string(),
                  region: z.string().optional(),
                  postalCode: z.string().optional(),
                  city: z.string(),
                  street: z.string(),
                  houseNumber: z.string().optional(),
                  refinement: z.string().optional(),
                })
                .optional(),
              residentialAddress: z
                .object({
                  country: z.string(),
                  region: z.string().optional(),
                  postalCode: z.string().optional(),
                  city: z.string(),
                  street: z.string(),
                  houseNumber: z.string().optional(),
                  refinement: z.string().optional(),
                })
                .optional(),
            })
            .optional(),
        }),
      )
      .optional(),
  }),
});

export const listClientRelationsResponseDtoOutput = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
  data: z
    .array(
      z.object({
        id: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        clientId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        relation: z.enum([
          'director',
          'shareholder',
          'director-and-shareholder',
          'authorized-person',
        ]),
        identity: z.union([
          z.object({
            type: z.enum(['corporate', 'individual']).optional(),
            country: z.string().optional(),
            identifications: z
              .array(
                z.object({
                  type: z
                    .enum([
                      'registration-number',
                      'passport',
                      'identity-card',
                      'driving-licence',
                      'foreign-identity-card',
                      'tax-number',
                    ])
                    .optional(),
                  identificationNumber: z.string().optional(),
                  issuingCountry: z.string().nullish(),
                  issueDate: z.string().nullish(),
                  expirationDate: z.string().nullish(),
                }),
              )
              .optional(),
            legalName: z.string(),
            tradingName: z.string().optional(),
            incorporationDate: z.string().optional(),
            corporationType: z.enum(['ltd', 'plc', 'llp', 'lp', 'gp', 'st', 'other']).optional(),
          }),
          z.object({
            type: z.enum(['corporate', 'individual']).optional(),
            country: z.string().optional(),
            identifications: z
              .array(
                z.object({
                  type: z
                    .enum([
                      'registration-number',
                      'passport',
                      'identity-card',
                      'driving-licence',
                      'foreign-identity-card',
                      'tax-number',
                    ])
                    .optional(),
                  identificationNumber: z.string().optional(),
                  issuingCountry: z.string().nullish(),
                  issueDate: z.string().nullish(),
                  expirationDate: z.string().nullish(),
                }),
              )
              .optional(),
            givenName: z.string(),
            familyName: z.string(),
            birthDate: z.string().optional(),
          }),
        ]),
        percentageOfOwnership: z.number().optional(),
        profile: z
          .object({
            identityType: z.string().optional(),
            phone: z.string().optional(),
            email: z.string().optional(),
            primaryAddress: z
              .object({
                country: z.string(),
                region: z.string().optional(),
                postalCode: z.string().optional(),
                city: z.string(),
                street: z.string(),
                houseNumber: z.string().optional(),
                refinement: z.string().optional(),
              })
              .optional(),
            registrationAddress: z
              .object({
                country: z.string(),
                region: z.string().optional(),
                postalCode: z.string().optional(),
                city: z.string(),
                street: z.string(),
                houseNumber: z.string().optional(),
                refinement: z.string().optional(),
              })
              .optional(),
            residentialAddress: z
              .object({
                country: z.string(),
                region: z.string().optional(),
                postalCode: z.string().optional(),
                city: z.string(),
                street: z.string(),
                houseNumber: z.string().optional(),
                refinement: z.string().optional(),
              })
              .optional(),
          })
          .optional(),
      }),
    )
    .readonly(),
});

export const exchangesAccountNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['EXCHANGES.ACCOUNT_NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const exchangesSameCurrencyErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['EXCHANGES.SAME_CURRENCY']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const createExchangeQuoteRequestDto = z.object({
  fixedSide: z.enum(['buy', 'sell']),
  amount: z.number(),
  buyAccountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  sellAccountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

export const exchangeQuoteResponseDtoOutput = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    )
    .optional(),
  rate: z.number().optional(),
  fixedSide: z.enum(['buy', 'sell']),
  buyAmount: z.number().optional(),
  buyCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
  sellAmount: z.number().optional(),
  sellCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
  feeAmount: z.number().optional(),
  feeCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']).optional(),
  debitAmount: z.number().optional(),
  creditAmount: z.number().optional(),
  expiryDateTime: z.iso
    .datetime()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
    )
    .optional(),
  settlementDate: z.iso
    .date()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
    )
    .optional(),
});

export const refreshExchangeQuoteRequestDto = z.object({
  fixedSide: z.enum(['buy', 'sell']),
  amount: z.number(),
  buyAccountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  sellAccountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

export const exchangesInsufficientFundsErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['EXCHANGES.INSUFFICIENT_FUNDS']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const createExchangeTransactionRequestDto = z.object({
  quoteId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

export const exchangeTransactionResponseDtoOutput = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    )
    .optional(),
  quoteId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  transactionNumber: z.string().optional(),
  status: z.enum(['pending', 'completed', 'cancelled', 'failed']).optional(),
  fixedSide: z.enum(['buy', 'sell']),
  rate: z.number().optional(),
  buyAmount: z.number().optional(),
  buyCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
  sellAmount: z.number().optional(),
  sellCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
  feeAmount: z.number().optional(),
  feeCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']).optional(),
  debitAmount: z.number().optional(),
  creditAmount: z.number().optional(),
  exchangeDate: z.iso
    .date()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
    )
    .optional(),
  settlementDate: z.iso
    .date()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
    )
    .optional(),
});

export const getGenericTransactionResponseDto = z.object({
  data: z.object({
    genericTransaction: z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      type: z.string().optional(),
      clientId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      accountId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      transactionNumber: z.string().optional(),
      amount: z.number().optional(),
      currency: z.string().optional(),
      status: z.enum(['completed']).optional(),
      attributes: z.record(z.string(), z.unknown()).optional(),
      creationDateTime: z.string().optional(),
      narrative: z.string().optional(),
    }),
  }),
});

export const listGenericTransactionsResponseDtoOutput = z.object({
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
  data: z
    .array(
      z.object({
        id: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        type: z.string().optional(),
        clientId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        accountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        transactionNumber: z.string().optional(),
        amount: z.number().optional(),
        currency: z.string().optional(),
        status: z.enum(['completed']).optional(),
        attributes: z.record(z.string(), z.unknown()).optional(),
        creationDateTime: z.string().optional(),
        narrative: z.string().optional(),
      }),
    )
    .readonly(),
});

export const integratedFinanceNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['INTEGRATED_FINANCE.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const getGenericTransactionResponseDtoOutput = z.object({
  data: z.object({
    genericTransaction: z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      type: z.string().optional(),
      clientId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      accountId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      transactionNumber: z.string().optional(),
      amount: z.number().optional(),
      currency: z.string().optional(),
      status: z.enum(['completed']).optional(),
      attributes: z.record(z.string(), z.unknown()).optional(),
      creationDateTime: z.string().optional(),
      narrative: z.string().optional(),
    }),
  }),
});

export const getIncomingTransferResponseDto = z.object({
  data: z.object({
    incomingTransfer: z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      clientId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      accountId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      transactionNumber: z.string().optional(),
      status: z.enum(['pending', 'on-hold', 'completed', 'failed']).optional(),
      currency: z.string().length(3).optional(),
      amount: z.number().optional(),
      feeAmount: z.number().optional(),
      feeCurrency: z.string().length(3).optional(),
      outgoingTransferId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .nullish(),
      serviceProviderId: z.string().nullish(),
      serviceProviderReference: z.string().nullish(),
      senderInformation: z.string().nullish(),
      senderName: z.string().optional(),
      transferDate: z.iso
        .date()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
        )
        .nullish(),
      totalAmount: z.number().optional(),
      provisionedAccountCreditId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      serviceProvider: z.string().optional(),
      receiverAccount: z
        .object({
          bankName: z.string().nullish(),
          accountHolderName: z.string().optional(),
          alias: z.string().max(30).nullish(),
          country: z.string().length(2).nullish(),
          currency: z.string().length(3).optional(),
          routingCodes: z.record(z.string(), z.unknown()).optional(),
          accountNumber: z
            .string()
            .min(8)
            .max(20)
            .regex(/^[0-9]{8,20}$/)
            .nullish(),
          iban: z
            .string()
            .min(15)
            .max(31)
            .regex(
              /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{4}([a-zA-Z0-9]?){3,19}$|^[A-Z]{2}\d{5}[0-9A-Z]{13}$/,
            )
            .nullish(),
          ledgerNumber: z
            .string()
            .length(8)
            .regex(/^[0-9]{8,8}$/)
            .nullish(),
        })
        .optional(),
      senderAccount: z
        .object({
          bankName: z.string().nullish(),
          accountHolderName: z.string().optional(),
          alias: z.string().max(30).nullish(),
          country: z.string().length(2).nullish(),
          currency: z.string().length(3).optional(),
          routingCodes: z.record(z.string(), z.unknown()).optional(),
          accountNumber: z
            .string()
            .min(8)
            .max(20)
            .regex(/^[0-9]{8,20}$/)
            .nullish(),
          iban: z
            .string()
            .min(15)
            .max(31)
            .regex(
              /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{4}([a-zA-Z0-9]?){3,19}$|^[A-Z]{2}\d{5}[0-9A-Z]{13}$/,
            )
            .nullish(),
          ledgerNumber: z
            .string()
            .length(8)
            .regex(/^[0-9]{8,8}$/)
            .nullish(),
        })
        .optional(),
      scope: z.enum(['internal', 'external']).optional(),
      scheme: z
        .enum([
          'swift',
          'local',
          'sepa',
          'sepa-instant',
          'sepa-direct-debit',
          'sepa-target-2',
          'sepa-target-2-pacs009',
          'chaps',
          'bacs',
          'faster-payments',
          'faster-payments-poo',
          'ach',
          'wire',
          'eft',
        ])
        .nullish(),
      owner: z.enum(['organization', 'client']).optional(),
      relatedTransaction: z
        .object({
          nature: z.enum(['actual', 'virtual']).nullish(),
          id: z
            .uuid()
            .regex(
              /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
            )
            .nullish(),
        })
        .optional(),
    }),
  }),
});

export const listIncomingTransfersResponseDtoOutput = z.object({
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
  data: z
    .array(
      z.object({
        id: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        clientId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        accountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        transactionNumber: z.string().optional(),
        status: z.enum(['pending', 'on-hold', 'completed', 'failed']).optional(),
        currency: z.string().length(3).optional(),
        amount: z.number().optional(),
        feeAmount: z.number().optional(),
        feeCurrency: z.string().length(3).optional(),
        outgoingTransferId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .nullish(),
        serviceProviderId: z.string().nullish(),
        serviceProviderReference: z.string().nullish(),
        senderInformation: z.string().nullish(),
        senderName: z.string().optional(),
        transferDate: z.iso
          .date()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
          )
          .nullish(),
        totalAmount: z.number().optional(),
        provisionedAccountCreditId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        serviceProvider: z.string().optional(),
        receiverAccount: z
          .object({
            bankName: z.string().nullish(),
            accountHolderName: z.string().optional(),
            alias: z.string().max(30).nullish(),
            country: z.string().length(2).nullish(),
            currency: z.string().length(3).optional(),
            routingCodes: z.record(z.string(), z.unknown()).optional(),
            accountNumber: z
              .string()
              .min(8)
              .max(20)
              .regex(/^[0-9]{8,20}$/)
              .nullish(),
            iban: z
              .string()
              .min(15)
              .max(31)
              .regex(
                /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{4}([a-zA-Z0-9]?){3,19}$|^[A-Z]{2}\d{5}[0-9A-Z]{13}$/,
              )
              .nullish(),
            ledgerNumber: z
              .string()
              .length(8)
              .regex(/^[0-9]{8,8}$/)
              .nullish(),
          })
          .optional(),
        senderAccount: z
          .object({
            bankName: z.string().nullish(),
            accountHolderName: z.string().optional(),
            alias: z.string().max(30).nullish(),
            country: z.string().length(2).nullish(),
            currency: z.string().length(3).optional(),
            routingCodes: z.record(z.string(), z.unknown()).optional(),
            accountNumber: z
              .string()
              .min(8)
              .max(20)
              .regex(/^[0-9]{8,20}$/)
              .nullish(),
            iban: z
              .string()
              .min(15)
              .max(31)
              .regex(
                /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{4}([a-zA-Z0-9]?){3,19}$|^[A-Z]{2}\d{5}[0-9A-Z]{13}$/,
              )
              .nullish(),
            ledgerNumber: z
              .string()
              .length(8)
              .regex(/^[0-9]{8,8}$/)
              .nullish(),
          })
          .optional(),
        scope: z.enum(['internal', 'external']).optional(),
        scheme: z
          .enum([
            'swift',
            'local',
            'sepa',
            'sepa-instant',
            'sepa-direct-debit',
            'sepa-target-2',
            'sepa-target-2-pacs009',
            'chaps',
            'bacs',
            'faster-payments',
            'faster-payments-poo',
            'ach',
            'wire',
            'eft',
          ])
          .nullish(),
        owner: z.enum(['organization', 'client']).optional(),
        relatedTransaction: z
          .object({
            nature: z.enum(['actual', 'virtual']).nullish(),
            id: z
              .uuid()
              .regex(
                /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
              )
              .nullish(),
          })
          .optional(),
      }),
    )
    .readonly(),
});

export const incomingTransferNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['INCOMING_TRANSFER.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const getIncomingTransferResponseDtoOutput = z.object({
  data: z.object({
    incomingTransfer: z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      clientId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      accountId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      transactionNumber: z.string().optional(),
      status: z.enum(['pending', 'on-hold', 'completed', 'failed']).optional(),
      currency: z.string().length(3).optional(),
      amount: z.number().optional(),
      feeAmount: z.number().optional(),
      feeCurrency: z.string().length(3).optional(),
      outgoingTransferId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .nullish(),
      serviceProviderId: z.string().nullish(),
      serviceProviderReference: z.string().nullish(),
      senderInformation: z.string().nullish(),
      senderName: z.string().optional(),
      transferDate: z.iso
        .date()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
        )
        .nullish(),
      totalAmount: z.number().optional(),
      provisionedAccountCreditId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      serviceProvider: z.string().optional(),
      receiverAccount: z
        .object({
          bankName: z.string().nullish(),
          accountHolderName: z.string().optional(),
          alias: z.string().max(30).nullish(),
          country: z.string().length(2).nullish(),
          currency: z.string().length(3).optional(),
          routingCodes: z.record(z.string(), z.unknown()).optional(),
          accountNumber: z
            .string()
            .min(8)
            .max(20)
            .regex(/^[0-9]{8,20}$/)
            .nullish(),
          iban: z
            .string()
            .min(15)
            .max(31)
            .regex(
              /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{4}([a-zA-Z0-9]?){3,19}$|^[A-Z]{2}\d{5}[0-9A-Z]{13}$/,
            )
            .nullish(),
          ledgerNumber: z
            .string()
            .length(8)
            .regex(/^[0-9]{8,8}$/)
            .nullish(),
        })
        .optional(),
      senderAccount: z
        .object({
          bankName: z.string().nullish(),
          accountHolderName: z.string().optional(),
          alias: z.string().max(30).nullish(),
          country: z.string().length(2).nullish(),
          currency: z.string().length(3).optional(),
          routingCodes: z.record(z.string(), z.unknown()).optional(),
          accountNumber: z
            .string()
            .min(8)
            .max(20)
            .regex(/^[0-9]{8,20}$/)
            .nullish(),
          iban: z
            .string()
            .min(15)
            .max(31)
            .regex(
              /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{4}([a-zA-Z0-9]?){3,19}$|^[A-Z]{2}\d{5}[0-9A-Z]{13}$/,
            )
            .nullish(),
          ledgerNumber: z
            .string()
            .length(8)
            .regex(/^[0-9]{8,8}$/)
            .nullish(),
        })
        .optional(),
      scope: z.enum(['internal', 'external']).optional(),
      scheme: z
        .enum([
          'swift',
          'local',
          'sepa',
          'sepa-instant',
          'sepa-direct-debit',
          'sepa-target-2',
          'sepa-target-2-pacs009',
          'chaps',
          'bacs',
          'faster-payments',
          'faster-payments-poo',
          'ach',
          'wire',
          'eft',
        ])
        .nullish(),
      owner: z.enum(['organization', 'client']).optional(),
      relatedTransaction: z
        .object({
          nature: z.enum(['actual', 'virtual']).nullish(),
          id: z
            .uuid()
            .regex(
              /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
            )
            .nullish(),
        })
        .optional(),
    }),
  }),
});

export const guardianStatusResponseDtoOutput = z.object({
  data: z.object({
    isConnected: z.boolean(),
    deviceName: z.string().nullable(),
    connectedSince: z.string().nullable(),
    lastUsed: z.string().nullable(),
  }),
});

export const bootstrapResponseDtoOutput = z.object({
  applicationIdentifier: z.string(),
  subscriberId: z.string(),
  subscriberHash: z.string().optional(),
  apiUrl: z.url(),
  socketUrl: z.url(),
});

export const novuSubscriberErrorErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(500),
  error: z.object({
    message: z.string(),
    code: z.enum(['NOVU.SUBSCRIBER.ERROR']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const identifySubscriberRequestDto = z.object({
  subscriberId: z.string(),
  email: z
    .email()
    .regex(
      /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/,
    )
    .optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phone: z.string().optional(),
  avatar: z.url().optional(),
  locale: z.string().optional(),
  data: z.record(z.string(), z.unknown()).optional(),
});

export const subscriberResponseDtoOutput = z.object({
  subscriberId: z.string(),
  email: z
    .email()
    .regex(
      /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/,
    )
    .optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phone: z.string().optional(),
  avatar: z.url().optional(),
  locale: z.string().optional(),
  data: z.record(z.string(), z.unknown()).optional(),
  _id: z.string().optional(),
  createdAt: z.iso
    .datetime()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
    )
    .optional(),
  updatedAt: z.iso
    .datetime()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
    )
    .optional(),
});

export const subscriberPreferencesResponseDtoOutput = z.object({
  workflows: z.array(
    z.object({
      enabled: z.boolean(),
      channels: z.object({
        email: z.boolean().optional(),
        sms: z.boolean().optional(),
        inApp: z.boolean().optional(),
        push: z.boolean().optional(),
        chat: z.boolean().optional(),
      }),
      workflow: z.object({
        slug: z.string(),
        identifier: z.string(),
        name: z.string(),
        updatedAt: z.iso
          .datetime()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
          ),
      }),
      overrides: z.array(
        z.object({
          channel: z.string(),
          source: z.string(),
        }),
      ),
    }),
  ),
  globalPreferences: z.object({
    enabled: z.boolean(),
    channels: z.object({
      email: z.boolean().optional(),
      sms: z.boolean().optional(),
      inApp: z.boolean().optional(),
      push: z.boolean().optional(),
      chat: z.boolean().optional(),
    }),
    schedule: z
      .object({
        isEnabled: z.boolean(),
        weeklySchedule: z
          .object({
            monday: z
              .object({
                isEnabled: z.boolean(),
                hours: z
                  .array(
                    z.object({
                      start: z.string(),
                      end: z.string(),
                    }),
                  )
                  .optional(),
              })
              .optional(),
            tuesday: z
              .object({
                isEnabled: z.boolean(),
                hours: z
                  .array(
                    z.object({
                      start: z.string(),
                      end: z.string(),
                    }),
                  )
                  .optional(),
              })
              .optional(),
            wednesday: z
              .object({
                isEnabled: z.boolean(),
                hours: z
                  .array(
                    z.object({
                      start: z.string(),
                      end: z.string(),
                    }),
                  )
                  .optional(),
              })
              .optional(),
            thursday: z
              .object({
                isEnabled: z.boolean(),
                hours: z
                  .array(
                    z.object({
                      start: z.string(),
                      end: z.string(),
                    }),
                  )
                  .optional(),
              })
              .optional(),
            friday: z
              .object({
                isEnabled: z.boolean(),
                hours: z
                  .array(
                    z.object({
                      start: z.string(),
                      end: z.string(),
                    }),
                  )
                  .optional(),
              })
              .optional(),
            saturday: z
              .object({
                isEnabled: z.boolean(),
                hours: z
                  .array(
                    z.object({
                      start: z.string(),
                      end: z.string(),
                    }),
                  )
                  .optional(),
              })
              .optional(),
            sunday: z
              .object({
                isEnabled: z.boolean(),
                hours: z
                  .array(
                    z.object({
                      start: z.string(),
                      end: z.string(),
                    }),
                  )
                  .optional(),
              })
              .optional(),
          })
          .optional(),
      })
      .optional(),
  }),
});

export const updateSubscriberPreferencesRequestDto = z.object({
  workflowId: z.string().optional(),
  channels: z
    .object({
      email: z.boolean().optional().default(true),
      sms: z.boolean().optional().default(true),
      inApp: z.boolean().optional().default(true),
      push: z.boolean().optional().default(true),
      chat: z.boolean().optional().default(true),
    })
    .optional(),
  schedule: z
    .object({
      isEnabled: z.boolean(),
      weeklySchedule: z
        .object({
          monday: z
            .object({
              isEnabled: z.boolean(),
              hours: z
                .array(
                  z.object({
                    start: z.string(),
                    end: z.string(),
                  }),
                )
                .optional(),
            })
            .optional(),
          tuesday: z
            .object({
              isEnabled: z.boolean(),
              hours: z
                .array(
                  z.object({
                    start: z.string(),
                    end: z.string(),
                  }),
                )
                .optional(),
            })
            .optional(),
          wednesday: z
            .object({
              isEnabled: z.boolean(),
              hours: z
                .array(
                  z.object({
                    start: z.string(),
                    end: z.string(),
                  }),
                )
                .optional(),
            })
            .optional(),
          thursday: z
            .object({
              isEnabled: z.boolean(),
              hours: z
                .array(
                  z.object({
                    start: z.string(),
                    end: z.string(),
                  }),
                )
                .optional(),
            })
            .optional(),
          friday: z
            .object({
              isEnabled: z.boolean(),
              hours: z
                .array(
                  z.object({
                    start: z.string(),
                    end: z.string(),
                  }),
                )
                .optional(),
            })
            .optional(),
          saturday: z
            .object({
              isEnabled: z.boolean(),
              hours: z
                .array(
                  z.object({
                    start: z.string(),
                    end: z.string(),
                  }),
                )
                .optional(),
            })
            .optional(),
          sunday: z
            .object({
              isEnabled: z.boolean(),
              hours: z
                .array(
                  z.object({
                    start: z.string(),
                    end: z.string(),
                  }),
                )
                .optional(),
            })
            .optional(),
        })
        .optional(),
    })
    .optional(),
});

export const deviceTokenRequestDto = z.object({
  deviceToken: z.string().min(1),
  platform: z.enum(['ios', 'android']),
});

export const removeDeviceTokenRequestDto = z.object({
  deviceToken: z.string().min(1),
  platform: z.enum(['ios', 'android']),
});

export const novuTriggerErrorErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(500),
  error: z.object({
    message: z.string(),
    code: z.enum(['NOVU.TRIGGER.ERROR']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const triggerNotificationRequestDto = z.object({
  to: z.union([
    z.object({
      type: z.enum(['subscriber']),
      subscriberId: z.string(),
      email: z
        .email()
        .regex(
          /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/,
        )
        .optional(),
    }),
    z.object({
      type: z.enum(['topic']),
      topicKey: z.string(),
    }),
  ]),
  idempotencyKey: z.string(),
  actor: z
    .object({
      subscriberId: z.string(),
    })
    .optional(),
  workflow: z.union([
    z.object({
      workflowId: z.enum(['kyc-completed-success']),
      payload: z.object({
        customExtraText: z.string(),
      }),
    }),
    z.object({
      workflowId: z.enum(['kyc-verification-completed']),
      payload: z.record(z.string(), z.unknown()),
    }),
    z.object({
      workflowId: z.enum(['kyc-verification-in-review']),
      payload: z.record(z.string(), z.unknown()),
    }),
    z.object({
      workflowId: z.enum(['kyc-verification-retry']),
      payload: z.record(z.string(), z.unknown()),
    }),
    z.object({
      workflowId: z.enum(['kyb-verification-completed']),
      payload: z.object({
        companyName: z.string().min(1),
      }),
    }),
    z.object({
      workflowId: z.enum(['kyb-verification-in-review']),
      payload: z.object({
        companyName: z.string().min(1),
      }),
    }),
    z.object({
      workflowId: z.enum(['kyb-verification-retry']),
      payload: z.object({
        companyName: z.string().min(1),
      }),
    }),
    z.object({
      workflowId: z.enum(['kyb-verification-rejected-permanently']),
      payload: z.object({
        companyName: z.string().min(1),
      }),
    }),
    z.object({
      workflowId: z.enum(['incoming-transfer']),
      payload: z.object({
        transferSourceName: z.string(),
        transferSourceAmount: z.string().regex(/^\d{1,3}(?:\.\d{3})*,\d{2}[€$£¥₹]$/),
        transferType: z.enum(['SEPA', 'SWIFT']),
        transferId: z.string(),
      }),
    }),
    z.object({
      workflowId: z.enum(['incoming-transfer-completed']),
      payload: z.object({
        amount: z.number(),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        senderName: z.string(),
      }),
    }),
    z.object({
      workflowId: z.enum(['outgoing-transfer-completed']),
      payload: z.object({
        amount: z.number(),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        recipientFullName: z.string(),
      }),
    }),
    z.object({
      workflowId: z.enum(['outgoing-transfer-cancelled']),
      payload: z.object({
        amount: z.number(),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        recipientFullName: z.string(),
      }),
    }),
    z.object({
      workflowId: z.enum(['outgoing-transfer-failed']),
      payload: z.object({
        amount: z.number(),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        recipientFullName: z.string(),
      }),
    }),
    z.object({
      workflowId: z.enum(['outgoing-transfer-returned']),
      payload: z.object({
        amount: z.number(),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        recipientFullName: z.string(),
      }),
    }),
    z.object({
      workflowId: z.enum(['transaction-account-activated']),
      payload: z.object({
        iban: z.string(),
        accountCurrencies: z.string(),
      }),
    }),
    z.object({
      workflowId: z.enum(['transaction-account-inactivated']),
      payload: z.object({
        iban: z.string(),
        accountCurrencies: z.string(),
      }),
    }),
    z.object({
      workflowId: z.enum(['exchange-transfer-completed']),
      payload: z.object({
        fromAmount: z.number(),
        fromCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        toAmount: z.number(),
        toCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
      }),
    }),
    z.object({
      workflowId: z.enum(['exchange-transfer-failed']),
      payload: z.object({
        fromAmount: z.number(),
        fromCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        toAmount: z.number(),
        toCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
      }),
    }),
    z.object({
      workflowId: z.enum(['exchange-transfer-cancelled']),
      payload: z.object({
        fromAmount: z.number(),
        fromCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        toAmount: z.number(),
        toCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
      }),
    }),
    z.object({
      workflowId: z.enum(['welcome-to-the-app-emaill-verified']),
      payload: z.record(z.string(), z.unknown()),
    }),
    z.object({
      workflowId: z.enum(['email-change-otp']),
      payload: z.object({
        otp: z.string(),
      }),
    }),
    z.object({
      workflowId: z.enum(['email-change-completed']),
      payload: z.object({
        firstName: z.string().optional(),
        oldEmail: z.string(),
      }),
    }),
    z.object({
      workflowId: z.enum(['iban-fee-collected-successfully']),
      payload: z.object({
        clientId: z.string(),
        companyName: z.string(),
        billingPeriod: z.string(),
        billingPeriodLabel: z.string(),
        currency: z.string(),
        total: z.number(),
        status: z.string(),
        lineItems: z.array(
          z.object({
            accountLabel: z.string(),
            feeLabel: z.string(),
            amount: z.number(),
          }),
        ),
        breakdownHtml: z.string(),
        breakdownText: z.string(),
        debitAccountId: z.string().optional(),
        debitAccountIban: z.string().optional(),
        debitAccountAlias: z.string().optional(),
      }),
    }),
    z.object({
      workflowId: z.enum(['iban-fee-collected-failed']),
      payload: z.object({
        clientId: z.string(),
        companyName: z.string(),
        billingPeriod: z.string(),
        billingPeriodLabel: z.string(),
        currency: z.string(),
        total: z.number(),
        status: z.string(),
        lineItems: z.array(
          z.object({
            accountLabel: z.string(),
            feeLabel: z.string(),
            amount: z.number(),
          }),
        ),
        breakdownHtml: z.string(),
        breakdownText: z.string(),
        reason: z.enum(['insufficient_funds', 'account_closed', 'error']),
      }),
    }),
    z.object({
      workflowId: z.enum(['liquidity-low-balance-alert']),
      payload: z.object({
        severity: z.enum(['WARNING', 'CRITICAL']),
        alertType: z.enum([
          'RECOMMENDED_TOTAL_MINIMUM_BREACHED',
          'ABSOLUTE_TOTAL_MINIMUM_BREACHED',
          'SCT_MINIMUM_BREACHED_NO_TRANSFER',
          'INST_MINIMUM_BREACHED_NO_TRANSFER',
        ]),
        ibans: z.array(z.string()),
        minimumBalance: z.number(),
        currentBalance: z.number(),
      }),
    }),
    z.object({
      workflowId: z.enum(['sepa-direct-debit-batch-submitted']),
      payload: z.object({
        batchId: z.string(),
        name: z.string().nullable(),
        reference: z.string().nullable(),
        settlementDate: z.string().nullable(),
        total: z.string(),
        submitted: z.string(),
        failed: z.string(),
      }),
    }),
    z.object({
      workflowId: z.enum(['sdd-creditor-identifier-approved']),
      payload: z.object({
        companyName: z.string().min(1),
      }),
    }),
    z.object({
      workflowId: z.enum(['sdd-creditor-identifier-retry']),
      payload: z.object({
        companyName: z.string().min(1),
      }),
    }),
    z.object({
      workflowId: z.enum(['sdd-creditor-identifier-failed']),
      payload: z.object({
        companyName: z.string().min(1),
      }),
    }),
  ]),
});

export const triggerNotificationResponseDtoOutput = z.object({
  transactionId: z.string().optional(),
  acknowledged: z.boolean(),
  status: z.enum([
    'error',
    'trigger_not_active',
    'no_workflow_active_steps_defined',
    'no_workflow_steps_defined',
    'processed',
    'no_tenant_found',
    'invalid_recipients',
  ]),
  error: z.array(z.string()).optional(),
});

export const createOrganizationRequestDto = z.object({
  name: z
    .string()
    .min(1)
    .max(45)
    .regex(/^[a-z0-9-]+$/),
  displayName: z
    .string()
    .min(1)
    .max(35)
    .regex(/^[a-zA-Z0-9\/\-?:().'+ ]+$/),
  companyType: z.enum([
    'LIMITED_COMPANY',
    'PUBLIC_COMPANY',
    'TRUST_OR_FOUNDATION',
    'SOLE_TRADER',
    'OTHER',
  ]),
  customCompanyType: z.string().min(1).optional(),
  registrationCountry: z.enum([
    'AD',
    'AE',
    'AF',
    'AG',
    'AI',
    'AL',
    'AM',
    'AO',
    'AQ',
    'AR',
    'AS',
    'AT',
    'AU',
    'AW',
    'AX',
    'AZ',
    'BA',
    'BB',
    'BD',
    'BE',
    'BF',
    'BG',
    'BH',
    'BI',
    'BJ',
    'BL',
    'BM',
    'BN',
    'BO',
    'BQ',
    'BR',
    'BS',
    'BT',
    'BV',
    'BW',
    'BY',
    'BZ',
    'CA',
    'CC',
    'CD',
    'CF',
    'CG',
    'CH',
    'CI',
    'CK',
    'CL',
    'CM',
    'CN',
    'CO',
    'CR',
    'CU',
    'CV',
    'CW',
    'CX',
    'CY',
    'CZ',
    'DE',
    'DJ',
    'DK',
    'DM',
    'DO',
    'DZ',
    'EC',
    'EE',
    'EG',
    'EH',
    'ER',
    'ES',
    'ET',
    'FI',
    'FJ',
    'FK',
    'FM',
    'FO',
    'FR',
    'GA',
    'GB',
    'GD',
    'GE',
    'GF',
    'GG',
    'GH',
    'GI',
    'GL',
    'GM',
    'GN',
    'GP',
    'GQ',
    'GR',
    'GS',
    'GT',
    'GU',
    'GW',
    'GY',
    'HK',
    'HM',
    'HN',
    'HR',
    'HT',
    'HU',
    'ID',
    'IE',
    'IL',
    'IM',
    'IN',
    'IO',
    'IQ',
    'IR',
    'IS',
    'IT',
    'JE',
    'JM',
    'JO',
    'JP',
    'KE',
    'KG',
    'KH',
    'KI',
    'KM',
    'KN',
    'KP',
    'KR',
    'KW',
    'KY',
    'KZ',
    'LA',
    'LB',
    'LC',
    'LI',
    'LK',
    'LR',
    'LS',
    'LT',
    'LU',
    'LV',
    'LY',
    'MA',
    'MC',
    'MD',
    'ME',
    'MF',
    'MG',
    'MH',
    'MK',
    'ML',
    'MM',
    'MN',
    'MO',
    'MP',
    'MQ',
    'MR',
    'MS',
    'MT',
    'MU',
    'MV',
    'MW',
    'MX',
    'MY',
    'MZ',
    'NA',
    'NC',
    'NE',
    'NF',
    'NG',
    'NI',
    'NL',
    'NO',
    'NP',
    'NR',
    'NU',
    'NZ',
    'OM',
    'PA',
    'PE',
    'PF',
    'PG',
    'PH',
    'PK',
    'PL',
    'PM',
    'PN',
    'PR',
    'PS',
    'PT',
    'PW',
    'PY',
    'QA',
    'RE',
    'RO',
    'RS',
    'RU',
    'RW',
    'SA',
    'SB',
    'SC',
    'SD',
    'SE',
    'SG',
    'SH',
    'SI',
    'SJ',
    'SK',
    'SL',
    'SM',
    'SN',
    'SO',
    'SR',
    'SS',
    'ST',
    'SV',
    'SX',
    'SY',
    'SZ',
    'TC',
    'TD',
    'TF',
    'TG',
    'TH',
    'TJ',
    'TK',
    'TL',
    'TM',
    'TN',
    'TO',
    'TR',
    'TT',
    'TV',
    'TW',
    'TZ',
    'UA',
    'UG',
    'UM',
    'US',
    'UY',
    'UZ',
    'VA',
    'VC',
    'VE',
    'VG',
    'VI',
    'VN',
    'VU',
    'WF',
    'WS',
    'XK',
    'YE',
    'YT',
    'ZA',
    'ZM',
    'ZW',
  ]),
  userRelation: z.array(z.enum(['AUT_REP', 'DIR', 'SHH', 'UBO'])).min(1),
});

export const createOrganizationResponseDtoOutput = z.object({
  data: z.object({
    id: z.string(),
    name: z.string().optional(),
    displayName: z.string().optional(),
    branding: z
      .object({
        logoUrl: z.string().optional(),
        colors: z
          .object({
            primary: z.string().optional(),
            pageBackground: z.string().optional(),
          })
          .optional(),
      })
      .optional(),
  }),
});

export const organizationsIdMismatchErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(403),
  error: z.object({
    message: z.string(),
    code: z.enum(['ORGANIZATIONS.ID_MISMATCH']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const genericOrganizationIdRequiredErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(403),
  error: z.object({
    message: z.string(),
    code: z.enum(['GENERIC.ORGANIZATION_ID_REQUIRED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const listOrganizationMembersResponseDtoOutput = z.object({
  data: z.array(
    z.object({
      userId: z.string().nullable(),
      invitationId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .nullable(),
      email: z.string().nullable(),
      name: z.string().nullable(),
      picture: z.string().nullable(),
      status: z.enum(['active', 'invited', 'invite_expired']),
      invitedByUserId: z.string().nullable(),
      invitedAt: z.string().nullable(),
      inviteExpiresAt: z.string().nullable(),
    }),
  ),
});

export const organizationsOnlyOwnerCanDeactivateErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(403),
  error: z.object({
    message: z.string(),
    code: z.enum(['ORGANIZATIONS.ONLY_OWNER_CAN_DEACTIVATE']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const organizationsCannotDeactivateSelfErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['ORGANIZATIONS.CANNOT_DEACTIVATE_SELF']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const organizationsCannotDeactivateOwnerErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['ORGANIZATIONS.CANNOT_DEACTIVATE_OWNER']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const organizationsCannotDeactivateLastMemberErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['ORGANIZATIONS.CANNOT_DEACTIVATE_LAST_MEMBER']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const organizationsKybNotApprovedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['ORGANIZATIONS.KYB_NOT_APPROVED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const organizationsAlreadyMemberErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['ORGANIZATIONS.ALREADY_MEMBER']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const organizationsInvitationAlreadyPendingErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['ORGANIZATIONS.INVITATION_ALREADY_PENDING']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const inviteOrganizationMemberRequestDto = z.object({
  email: z
    .email()
    .regex(
      /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/,
    ),
});

export const organizationInvitationResponseDtoOutput = z.object({
  data: z.object({
    id: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    organizationId: z.string(),
    inviteeEmail: z.string(),
    inviterUserId: z.string(),
    status: z.enum(['pending', 'accepted', 'revoked', 'expired']),
    expiresAt: z.string(),
    acceptedAt: z.string().nullable(),
    revokedAt: z.string().nullable(),
    createdAt: z.string(),
  }),
});

export const organizationsInvitationNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['ORGANIZATIONS.INVITATION_NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const organizationsInvitationNotPendingErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['ORGANIZATIONS.INVITATION_NOT_PENDING']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const createReportRequestDto = z.object({
  type: z.enum(['ACCOUNT_TRANSACTIONS_CSV']),
  accountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  dateFrom: z.iso
    .date()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
    ),
  dateTo: z.iso
    .date()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
    ),
});

export const reportResponseDto = z.object({
  data: z.object({
    id: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    type: z.enum(['ACCOUNT_TRANSACTIONS_CSV']),
    status: z.enum(['PENDING', 'RUNNING', 'COMPLETED', 'FAILED']),
    accountId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      )
      .nullable(),
    params: z.object({
      dateFrom: z.iso
        .date()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
        ),
      dateTo: z.iso
        .date()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
        ),
    }),
    fileName: z.string().nullable(),
    rowCount: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
    byteSize: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
    errorCode: z.enum(['UPSTREAM_UNAVAILABLE', 'INCOMPLETE_BUFFER', 'UNKNOWN']),
    createdAt: z.iso
      .datetime()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
      ),
    completedAt: z.iso
      .datetime()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
      )
      .nullable(),
  }),
});

export const reportResponseDtoOutput = z.object({
  data: z.object({
    id: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    type: z.enum(['ACCOUNT_TRANSACTIONS_CSV']),
    status: z.enum(['PENDING', 'RUNNING', 'COMPLETED', 'FAILED']),
    accountId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      )
      .nullable(),
    params: z.object({
      dateFrom: z.iso
        .date()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
        ),
      dateTo: z.iso
        .date()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
        ),
    }),
    fileName: z.string().nullable(),
    rowCount: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
    byteSize: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
    errorCode: z.enum(['UPSTREAM_UNAVAILABLE', 'INCOMPLETE_BUFFER', 'UNKNOWN']),
    createdAt: z.iso
      .datetime()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
      ),
    completedAt: z.iso
      .datetime()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
      )
      .nullable(),
  }),
});

export const listReportsResponseDtoOutput = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
  data: z.array(
    z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      type: z.enum(['ACCOUNT_TRANSACTIONS_CSV']),
      status: z.enum(['PENDING', 'RUNNING', 'COMPLETED', 'FAILED']),
      accountId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .nullable(),
      params: z.object({
        dateFrom: z.iso
          .date()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
          ),
        dateTo: z.iso
          .date()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
          ),
      }),
      fileName: z.string().nullable(),
      rowCount: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
      byteSize: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
      errorCode: z.enum(['UPSTREAM_UNAVAILABLE', 'INCOMPLETE_BUFFER', 'UNKNOWN']),
      createdAt: z.iso
        .datetime()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
        ),
      completedAt: z.iso
        .datetime()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
        )
        .nullable(),
    }),
  ),
});

export const reportNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['REPORT.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const downloadReportResponseDtoOutput = z.object({
  data: z.object({
    url: z.url(),
    expiresAt: z.iso
      .datetime()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
      ),
  }),
});

export const inventiWebhookEnvelopeDto = z.object({
  trx_id: z.int().gte(-9007199254740991).lte(9007199254740991),
  direction: z.enum(['INBOUND', 'OUTBOUND']).optional(),
  status: z.string().optional(),
  type: z.string().optional(),
  amount: z.number().optional(),
  currency: z.string().optional(),
  end_to_end_id: z.string().optional(),
  updated_at: z.string().optional(),
  debtor_iban: z.string().optional(),
  creditor_iban: z.string().optional(),
  method: z.string().optional(),
});

export const apiOkResponseDtoOutput = z.object({
  ok: z.literal(true),
});

export const apiOkResponseDto = z.object({
  ok: z.literal(true),
});

export const inventiLiquidityWebhookDto = z.object({
  alertType: z.enum([
    'RECOMMENDED_TOTAL_MINIMUM_BREACHED',
    'ABSOLUTE_TOTAL_MINIMUM_BREACHED',
    'SCT_MINIMUM_BREACHED_NO_TRANSFER',
    'INST_MINIMUM_BREACHED_NO_TRANSFER',
  ]),
  ibans: z.array(z.string()).min(1),
  minimumBalance: z.number(),
  currentBalance: z.number(),
});

export const outgoingTransferSourceAccountNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFER.SOURCE_ACCOUNT.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const getTransferLimitsResponseDtoOutput = z.object({
  data: z.array(
    z.object({
      type: z.enum(['sepa-instant', 'sepa', 'swift', 'internal']),
      day: z.object({
        amount: z.number().nullable(),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        scope: z.enum(['client', 'account']),
        used: z.number(),
        remaining: z.number().nullable(),
      }),
      singleTransfer: z.object({
        amount: z.number().nullable(),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        scope: z.enum(['client', 'account']),
      }),
    }),
  ),
});

export const setTransferLimitRequestDto = z.object({
  type: z.enum(['sepa-instant', 'sepa']),
  singleTransferLimit: z.object({
    amount: z.number().lte(999999999999.99).nullable(),
    currency: z.enum(['EUR']),
  }),
  dailyLimit: z.object({
    amount: z.number().lte(999999999999.99).nullable(),
    currency: z.enum(['EUR']),
  }),
  accountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    )
    .nullish(),
});

export const setTransferLimitResponseDtoOutput = z.object({
  data: z.object({
    challengeId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    status: z.enum(['pending', 'approved', 'denied', 'expired']),
    channel: z.enum(['ciba']),
    expiresAt: z.number(),
  }),
});

export const getOutgoingTransferResponseDto = z.object({
  data: z.object({
    id: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      )
      .readonly()
      .nullish(),
    transactionNumber: z.string().readonly().nullish(),
    amount: z.number().optional(),
    currency: z.string().length(3).optional(),
    status: z
      .enum(['pending', 'on-hold', 'processing', 'released', 'completed', 'cancelled', 'failed'])
      .nullish(),
    transferDate: z.iso
      .date()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
      )
      .optional(),
    originalTransferDate: z.iso
      .date()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
      )
      .readonly()
      .nullish(),
    beneficiary: z
      .object({
        fullName: z.string().optional(),
        identity: z
          .object({
            type: z.enum(['individual', 'corporate']),
            givenName: z.string().optional(),
            familyName: z.string().optional(),
            legalName: z.string().optional(),
          })
          .optional(),
        address: z
          .object({
            country: z
              .string()
              .length(2)
              .regex(/^[A-Z]{2}$/),
            region: z.string().optional(),
            postalCode: z.string().optional(),
            city: z.string(),
            street: z.string(),
            houseNumber: z.string().optional(),
            refinement: z.string().optional(),
          })
          .nullish(),
        account: z
          .object({
            accountHolderName: z.string().nullish(),
            bankName: z.string().nullish(),
            country: z.string().nullish(),
            currency: z.string().optional(),
            routingCodes: z.record(z.string(), z.unknown()).nullish(),
            accountNumber: z.string().nullish(),
            iban: z.string().nullish(),
            ledgerNumber: z.string().nullish(),
            alias: z.string().nullish(),
          })
          .optional(),
      })
      .optional(),
    description: z.string().nullish(),
    source: z
      .object({
        type: z.enum(['client-account', 'transaction-account']),
        accountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
      })
      .optional(),
    destination: z
      .object({
        type: z.enum(['client-account', 'transaction-account', 'beneficiary-bank-account']),
        accountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        beneficiaryBankAccountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        beneficiaryId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
      })
      .optional(),
    feeAmount: z.number().readonly().optional(),
    feeCurrency: z.string().length(3).readonly().optional(),
    totalAmount: z.number().readonly().optional(),
    transferReasonId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      )
      .nullish(),
    transferCustomReason: z.string().nullish(),
    scheme: z
      .enum([
        'swift',
        'local',
        'sepa',
        'sepa-instant',
        'sepa-target-2',
        'sepa-target-2-pacs009',
        'chaps',
        'bacs',
        'faster-payments',
        'faster-payments-poo',
        'ach',
        'wire',
        'eft',
      ])
      .nullish(),
    scope: z.enum(['internal', 'external']).optional(),
    returned: z.boolean().readonly().nullish(),
    initiatedBy: z
      .object({
        userId: z.string(),
        firstName: z.string().nullable(),
        lastName: z.string().nullable(),
      })
      .nullable(),
  }),
});

export const listOutgoingTransfersResponseDtoOutput = z.object({
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
  data: z
    .array(
      z.object({
        id: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .readonly()
          .nullish(),
        transactionNumber: z.string().readonly().nullish(),
        amount: z.number().optional(),
        currency: z.string().length(3).optional(),
        status: z
          .enum([
            'pending',
            'on-hold',
            'processing',
            'released',
            'completed',
            'cancelled',
            'failed',
          ])
          .optional(),
        transferDate: z.iso
          .date()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
          )
          .optional(),
        beneficiary: z
          .object({
            fullName: z.string().optional(),
            identity: z
              .object({
                type: z.enum(['individual', 'corporate']),
                givenName: z.string().optional(),
                familyName: z.string().optional(),
                legalName: z.string().optional(),
              })
              .optional(),
            address: z
              .object({
                country: z
                  .string()
                  .length(2)
                  .regex(/^[A-Z]{2}$/),
                region: z.string().optional(),
                postalCode: z.string().optional(),
                city: z.string(),
                street: z.string(),
                houseNumber: z.string().optional(),
                refinement: z.string().optional(),
              })
              .nullish(),
            account: z
              .object({
                accountHolderName: z.string().nullish(),
                bankName: z.string().nullish(),
                country: z.string().nullish(),
                currency: z.string().optional(),
                routingCodes: z.record(z.string(), z.unknown()).nullish(),
                accountNumber: z.string().nullish(),
                iban: z.string().nullish(),
                ledgerNumber: z.string().nullish(),
                alias: z.string().nullish(),
              })
              .optional(),
          })
          .optional(),
        description: z.string().nullish(),
        initiatedBy: z
          .object({
            userId: z.string(),
            firstName: z.string().nullable(),
            lastName: z.string().nullable(),
          })
          .nullable(),
      }),
    )
    .readonly(),
});

export const listTransferReasonsResponseDtoOutput = z.object({
  data: z.array(
    z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      description: z.string(),
    }),
  ),
});

export const outgoingTransfersSchemeNotAllowedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFERS.SCHEME.NOT_ALLOWED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const getOutgoingTransferDateMetadataResponseDtoOutput = z.object({
  data: z.object({
    nextAvailableDate: z.iso
      .date()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
      )
      .readonly()
      .optional(),
    nextCutoffDateTime: z.string().readonly().nullish(),
    unavailableDates: z
      .array(
        z.iso
          .date()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
          )
          .readonly(),
      )
      .readonly()
      .optional(),
  }),
});

export const outgoingTransfersBicUnresolvedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(422),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFERS.BIC_UNRESOLVED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const reachableSchemesResponseDtoOutput = z.object({
  routing: z.enum(['internal', 'external']),
  internalDestinationAccountId: z.string().optional(),
  schemes: z
    .array(
      z.enum([
        'swift',
        'local',
        'sepa',
        'sepa-instant',
        'sepa-direct-debit',
        'sepa-target-2',
        'sepa-target-2-pacs009',
        'chaps',
        'bacs',
        'faster-payments',
        'faster-payments-poo',
        'ach',
        'wire',
        'eft',
      ]),
    )
    .optional(),
  fidelity: z.enum(['provider', 'corridor-fallback']).optional(),
});

export const outgoingTransfersNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFERS.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const getOutgoingTransferResponseDtoOutput = z.object({
  data: z.object({
    id: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      )
      .readonly()
      .nullish(),
    transactionNumber: z.string().readonly().nullish(),
    amount: z.number().optional(),
    currency: z.string().length(3).optional(),
    status: z
      .enum(['pending', 'on-hold', 'processing', 'released', 'completed', 'cancelled', 'failed'])
      .nullish(),
    transferDate: z.iso
      .date()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
      )
      .optional(),
    originalTransferDate: z.iso
      .date()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
      )
      .readonly()
      .nullish(),
    beneficiary: z
      .object({
        fullName: z.string().optional(),
        identity: z
          .object({
            type: z.enum(['individual', 'corporate']),
            givenName: z.string().optional(),
            familyName: z.string().optional(),
            legalName: z.string().optional(),
          })
          .optional(),
        address: z
          .object({
            country: z
              .string()
              .length(2)
              .regex(/^[A-Z]{2}$/),
            region: z.string().optional(),
            postalCode: z.string().optional(),
            city: z.string(),
            street: z.string(),
            houseNumber: z.string().optional(),
            refinement: z.string().optional(),
          })
          .nullish(),
        account: z
          .object({
            accountHolderName: z.string().nullish(),
            bankName: z.string().nullish(),
            country: z.string().nullish(),
            currency: z.string().optional(),
            routingCodes: z.record(z.string(), z.unknown()).nullish(),
            accountNumber: z.string().nullish(),
            iban: z.string().nullish(),
            ledgerNumber: z.string().nullish(),
            alias: z.string().nullish(),
          })
          .optional(),
      })
      .optional(),
    description: z.string().nullish(),
    source: z
      .object({
        type: z.enum(['client-account', 'transaction-account']),
        accountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
      })
      .optional(),
    destination: z
      .object({
        type: z.enum(['client-account', 'transaction-account', 'beneficiary-bank-account']),
        accountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        beneficiaryBankAccountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        beneficiaryId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
      })
      .optional(),
    feeAmount: z.number().readonly().optional(),
    feeCurrency: z.string().length(3).readonly().optional(),
    totalAmount: z.number().readonly().optional(),
    transferReasonId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      )
      .nullish(),
    transferCustomReason: z.string().nullish(),
    scheme: z
      .enum([
        'swift',
        'local',
        'sepa',
        'sepa-instant',
        'sepa-target-2',
        'sepa-target-2-pacs009',
        'chaps',
        'bacs',
        'faster-payments',
        'faster-payments-poo',
        'ach',
        'wire',
        'eft',
      ])
      .nullish(),
    scope: z.enum(['internal', 'external']).optional(),
    returned: z.boolean().readonly().nullish(),
    initiatedBy: z
      .object({
        userId: z.string(),
        firstName: z.string().nullable(),
        lastName: z.string().nullable(),
      })
      .nullable(),
  }),
});

export const clientIpMissingErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['CLIENT_IP.MISSING']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransfersTransferDateUnavailableErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFERS.TRANSFER_DATE.UNAVAILABLE']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransfersDifferentBankMustRouteExternallyErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFERS.DIFFERENT_BANK_MUST_ROUTE_EXTERNALLY']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransfersCurrencyMismatchErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFERS.CURRENCY.MISMATCH']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransfersInsufficientFundsErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFERS.INSUFFICIENT_FUNDS']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransfersSingleTransferLimitExceededErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFERS.SINGLE_TRANSFER_LIMIT_EXCEEDED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransfersDailyTransferLimitExceededErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFERS.DAILY_TRANSFER_LIMIT_EXCEEDED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransfersLimitCheckInProgressErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFERS.LIMIT_CHECK_IN_PROGRESS']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransferDestinationAccountNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFER.DESTINATION_ACCOUNT.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const createInternalOutgoingTransferRequestDto = z.object({
  amount: z.number(),
  source: z.object({
    accountId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
  }),
  destination: z.object({
    accountId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
  }),
  description: z.string().max(140).optional(),
  transferDate: z.iso
    .date()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
    )
    .optional(),
});

export const createOutgoingTransferResponseDto = z.object({
  data: z.object({
    id: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    status: z.enum([
      'pending',
      'on-hold',
      'processing',
      'released',
      'completed',
      'cancelled',
      'failed',
      'returned',
    ]),
    amount: z.number(),
    currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
    description: z.string().optional(),
    transferDate: z.string(),
    totalAmount: z.number(),
    feeAmount: z.number(),
    feeCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
  }),
});

export const createOutgoingTransferChallengeResponseDto = z.object({
  data: z.object({
    challengeId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    status: z.enum(['pending', 'approved', 'denied', 'expired']),
    channel: z.enum(['ciba']),
    expiresAt: z.number(),
  }),
});

export const outgoingTransfersSameBankMustRouteInternallyErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFERS.SAME_BANK_MUST_ROUTE_INTERNALLY']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransfersSchemeNotReachableErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFERS.SCHEME_NOT_REACHABLE']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransfersReasonNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFERS.REASON.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransferSwiftBeneficiaryAccountRequiredErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFER.SWIFT_BENEFICIARY_ACCOUNT_REQUIRED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransferSwiftBeneficiaryAddressRequiredErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFER.SWIFT_BENEFICIARY_ADDRESS_REQUIRED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransferSwiftCurrencyNotSupportedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFER.SWIFT_CURRENCY_NOT_SUPPORTED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransferSwiftDebtorAddressRequiredErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFER.SWIFT_DEBTOR_ADDRESS_REQUIRED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const createExternalOutgoingTransferRequestDto = z.object({
  scheme: z.enum([
    'swift',
    'local',
    'sepa',
    'sepa-instant',
    'sepa-target-2',
    'sepa-target-2-pacs009',
    'chaps',
    'bacs',
    'faster-payments',
    'faster-payments-poo',
    'ach',
    'wire',
    'eft',
  ]),
  amount: z.number(),
  source: z.object({
    accountId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
  }),
  destination: z.object({
    beneficiaryId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    beneficiaryBankAccountId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
  }),
  description: z.string().max(140).optional(),
  transferReasonId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  transferCustomReason: z.string().optional(),
  transferDate: z.iso
    .date()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
    )
    .optional(),
});

export const dryRunOutgoingTransferResponseDtoOutput = z.object({
  data: z.object({
    amount: z.number(),
    currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
    description: z.string().optional(),
    transferDate: z.string(),
    totalAmount: z.number(),
    feeAmount: z.number(),
    feeCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
  }),
});

export const challengesAuthorizationPendingErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(422),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.AUTHORIZATION_PENDING']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const challengesTypeMismatchErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.TYPE_MISMATCH']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const challengesAuthorizationDeniedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.AUTHORIZATION_DENIED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const challengesInvalidTokenErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.INVALID_TOKEN']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const challengesValidationFailedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.VALIDATION_FAILED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransfersPayloadIntegrityFailedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFERS.PAYLOAD_INTEGRITY_FAILED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const challengesAuthorizationExpiredErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(410),
  error: z.object({
    message: z.string(),
    code: z.enum(['CHALLENGES.AUTHORIZATION_EXPIRED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const resolveChallengeRequestDto = z.object({
  challengeId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

export const createOutgoingTransferResponseDtoOutput = z.object({
  data: z.object({
    id: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    status: z.enum([
      'pending',
      'on-hold',
      'processing',
      'released',
      'completed',
      'cancelled',
      'failed',
      'returned',
    ]),
    amount: z.number(),
    currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
    description: z.string().optional(),
    transferDate: z.string(),
    totalAmount: z.number(),
    feeAmount: z.number(),
    feeCurrency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
  }),
});

export const sddBatchAccountNotSupportedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(422),
  error: z.object({
    message: z.string(),
    code: z.enum(['SDD_BATCH.ACCOUNT_NOT_SUPPORTED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const sddBatchAccountNotAllowedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(422),
  error: z.object({
    message: z.string(),
    code: z.enum(['SDD_BATCH.ACCOUNT_NOT_ALLOWED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const paymentBatchTransferReasonInvalidErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['PAYMENT_BATCH.TRANSFER_REASON_INVALID']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const paymentBatchTransferCustomReasonInvalidErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['PAYMENT_BATCH.TRANSFER_CUSTOM_REASON_INVALID']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const createPaymentBatchRequestDto = z.object({
  direction: z.enum(['incoming', 'outgoing']).optional().default('incoming'),
  name: z.string().max(140).optional(),
  reference: z.string().max(35).optional(),
  accountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  expectedItemCount: z.int().gte(0).lte(1000),
  submitAt: z.iso
    .datetime()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
    )
    .optional(),
  settlementDate: z.iso
    .date()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
    )
    .optional(),
  transferReasonId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    )
    .optional(),
  transferCustomReason: z.string().min(1).max(140).optional(),
});

export const paymentBatchResponseDtoOutput = z.object({
  data: z.object({
    id: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    name: z.string().nullable(),
    reference: z.string().nullable(),
    direction: z.enum(['incoming', 'outgoing']),
    status: z.enum([
      'loading',
      'draft',
      'verifying',
      'dry_running',
      'scheduled',
      'executing',
      'submitted',
      'completed',
      'partially_completed',
      'failed',
      'cancelled',
    ]),
    accountId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    transferReasonId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      )
      .nullable(),
    transferCustomReason: z.string().nullable(),
    submitAt: z.iso
      .datetime()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
      )
      .nullable(),
    settlementDate: z.iso
      .date()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
      )
      .nullable(),
    expectedItemCount: z.int().gte(0).lte(9007199254740991),
    summary: z.object({
      itemCount: z.int().gte(0).lte(9007199254740991),
      amountTotal: z.string(),
      dryRunFeeTotal: z.string(),
      dryRunGrandTotal: z.string(),
      dryRunFailedAmountTotal: z.string(),
      byStatus: z.object({
        pending: z.int().gte(0).lte(9007199254740991),
        invalid: z.int().gte(0).lte(9007199254740991),
        verified: z.int().gte(0).lte(9007199254740991),
        verificationFailed: z.int().gte(0).lte(9007199254740991),
        verificationOverridden: z.int().gte(0).lte(9007199254740991),
        dryRunCompleted: z.int().gte(0).lte(9007199254740991),
        dryRunFailed: z.int().gte(0).lte(9007199254740991),
        submitted: z.int().gte(0).lte(9007199254740991),
        onHold: z.int().gte(0).lte(9007199254740991),
        processing: z.int().gte(0).lte(9007199254740991),
        released: z.int().gte(0).lte(9007199254740991),
        failed: z.int().gte(0).lte(9007199254740991),
        completed: z.int().gte(0).lte(9007199254740991),
        cancelled: z.int().gte(0).lte(9007199254740991),
        returned: z.int().gte(0).lte(9007199254740991),
      }),
    }),
    createdAt: z.iso
      .datetime()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
      ),
    updatedAt: z.iso
      .datetime()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
      ),
  }),
});

export const listPaymentBatchesResponseDtoOutput = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
  data: z.array(
    z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      name: z.string().nullable(),
      reference: z.string().nullable(),
      direction: z.enum(['incoming', 'outgoing']),
      status: z.enum([
        'loading',
        'draft',
        'verifying',
        'dry_running',
        'scheduled',
        'executing',
        'submitted',
        'completed',
        'partially_completed',
        'failed',
        'cancelled',
      ]),
      accountId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      transferReasonId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .nullable(),
      transferCustomReason: z.string().nullable(),
      submitAt: z.iso
        .datetime()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
        )
        .nullable(),
      settlementDate: z.iso
        .date()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
        )
        .nullable(),
      expectedItemCount: z.int().gte(0).lte(9007199254740991),
      summary: z.object({
        itemCount: z.int().gte(0).lte(9007199254740991),
        amountTotal: z.string(),
        dryRunFeeTotal: z.string(),
        dryRunGrandTotal: z.string(),
        dryRunFailedAmountTotal: z.string(),
        byStatus: z.object({
          pending: z.int().gte(0).lte(9007199254740991),
          invalid: z.int().gte(0).lte(9007199254740991),
          verified: z.int().gte(0).lte(9007199254740991),
          verificationFailed: z.int().gte(0).lte(9007199254740991),
          verificationOverridden: z.int().gte(0).lte(9007199254740991),
          dryRunCompleted: z.int().gte(0).lte(9007199254740991),
          dryRunFailed: z.int().gte(0).lte(9007199254740991),
          submitted: z.int().gte(0).lte(9007199254740991),
          onHold: z.int().gte(0).lte(9007199254740991),
          processing: z.int().gte(0).lte(9007199254740991),
          released: z.int().gte(0).lte(9007199254740991),
          failed: z.int().gte(0).lte(9007199254740991),
          completed: z.int().gte(0).lte(9007199254740991),
          cancelled: z.int().gte(0).lte(9007199254740991),
          returned: z.int().gte(0).lte(9007199254740991),
        }),
      }),
      createdAt: z.iso
        .datetime()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
        ),
      updatedAt: z.iso
        .datetime()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
        ),
    }),
  ),
});

export const sddBatchAccountLimitsNotConfiguredErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(422),
  error: z.object({
    message: z.string(),
    code: z.enum(['SDD_BATCH.ACCOUNT_LIMITS_NOT_CONFIGURED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const getSddAccountLimitsResponseDtoOutput = z.object({
  data: z.object({
    accountId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    count: z.object({
      limit: z.int().lte(9007199254740991),
      used: z.int().gte(0).lte(9007199254740991),
      remaining: z.int().gte(0).lte(9007199254740991),
    }),
    volume: z.object({
      limit: z.string(),
      used: z.string(),
      remaining: z.string(),
      currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
    }),
  }),
});

export const paymentBatchNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['PAYMENT_BATCH.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const paymentBatchInvalidStateErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(422),
  error: z.object({
    message: z.string(),
    code: z.enum(['PAYMENT_BATCH.INVALID_STATE']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const updatePaymentBatchRequestDto = z.object({
  name: z.string().max(140).nullish(),
  reference: z.string().max(35).nullish(),
  accountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    )
    .optional(),
  submitAt: z.iso
    .datetime()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
    )
    .nullish(),
  settlementDate: z.iso
    .date()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
    )
    .nullish(),
  expectedItemCount: z.int().gte(0).lte(1000).optional(),
  transferReasonId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    )
    .nullish(),
  transferCustomReason: z.string().min(1).max(140).nullish(),
});

export const paymentBatchSizeExceededErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(422),
  error: z.object({
    message: z.string(),
    code: z.enum(['PAYMENT_BATCH.SIZE_EXCEEDED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const paymentBatchExpectedCountExceededErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(422),
  error: z.object({
    message: z.string(),
    code: z.enum(['PAYMENT_BATCH.EXPECTED_COUNT_EXCEEDED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const paymentBatchDuplicateRowIdErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['PAYMENT_BATCH.DUPLICATE_ROW_ID']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const idempotencyKeyReusedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['IDEMPOTENCY.KEY_REUSED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const addPaymentBatchItemsRequestDto = z.object({
  items: z
    .array(
      z.object({
        rowId: z.string().min(1).max(64),
        type: z.string().max(255).optional(),
        amount: z.string().max(255).optional(),
        currency: z.enum(['EUR']).optional().default('EUR'),
        counterparty: z
          .object({
            type: z.string().max(255).optional(),
            givenName: z.string().max(255).optional(),
            familyName: z.string().max(255).optional(),
            legalName: z.string().max(255).optional(),
            iban: z.string().max(255).optional(),
            bic: z.string().max(255).optional(),
            address: z
              .object({
                country: z.string().max(255).optional(),
                townName: z.string().max(255).optional(),
                streetName: z.string().max(255).optional(),
                buildingNumber: z.string().max(255).optional(),
                room: z.string().max(255).optional(),
                postCode: z.string().max(255).optional(),
              })
              .optional(),
          })
          .optional(),
        mandate: z
          .object({
            id: z.string().max(255).optional(),
            signatureDate: z.string().max(255).optional(),
          })
          .optional(),
        sequenceType: z.string().max(255).optional(),
        purpose: z.string().max(255).optional(),
      }),
    )
    .min(1)
    .max(500),
});

export const paymentBatchItemsResponseDtoOutput = z.object({
  data: z.array(
    z.union([
      z.object({
        id: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        batchId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        rowId: z.string(),
        amount: z.string().nullable(),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        counterparty: z.object({
          givenName: z.string().nullable(),
          familyName: z.string().nullable(),
          legalName: z.string().nullable(),
          type: z.enum(['individual', 'corporate']).nullable(),
          address: z
            .object({
              country: z.string().nullable(),
              townName: z.string().nullable(),
              streetName: z.string().nullable(),
              buildingNumber: z.string().nullable(),
              room: z.string().nullable(),
              postCode: z.string().nullable(),
            })
            .nullable(),
          iban: z.string().nullable(),
          bic: z.string().nullable(),
        }),
        purpose: z.string().nullable(),
        status: z.enum([
          'pending',
          'invalid',
          'verified',
          'verification_failed',
          'verification_overridden',
          'dry_run_completed',
          'dry_run_failed',
          'submitted',
          'on_hold',
          'processing',
          'released',
          'failed',
          'completed',
          'cancelled',
          'returned',
        ]),
        vop: z
          .object({
            matchResult: z.enum(['match', 'close-match', 'not-matched', 'not-applicable']),
            accountHolderName: z.string().nullable(),
            checkedAt: z.iso
              .datetime()
              .regex(
                /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
              ),
            overridden: z.boolean(),
          })
          .nullable(),
        validationErrors: z.array(
          z.enum([
            'payment_type_missing',
            'payment_type_invalid',
            'payment_type_not_allowed_for_direction',
            'payment_type_not_implemented',
            'payment_type_scheme_not_allowed',
            'amount_missing',
            'counterparty_type_missing',
            'counterparty_legal_name_missing',
            'counterparty_given_name_missing',
            'counterparty_family_name_missing',
            'iban_missing',
            'mandate_id_missing',
            'mandate_signature_date_missing',
            'sequence_type_missing',
            'amount_not_a_number',
            'amount_not_positive',
            'amount_too_large',
            'amount_too_many_decimals',
            'counterparty_given_name_too_long',
            'counterparty_family_name_too_long',
            'counterparty_name_too_long',
            'counterparty_given_name_invalid_characters',
            'counterparty_family_name_invalid_characters',
            'counterparty_legal_name_too_long',
            'counterparty_legal_name_invalid_characters',
            'iban_malformed',
            'iban_checksum_invalid',
            'bic_invalid',
            'mandate_id_too_long',
            'mandate_signature_date_not_a_date',
            'mandate_signature_date_in_future',
            'sequence_type_invalid',
            'purpose_too_long',
            'mandate_not_applicable',
            'counterparty_country_invalid',
            'counterparty_town_name_too_long',
            'counterparty_street_name_too_long',
            'counterparty_building_number_too_long',
            'counterparty_room_too_long',
            'counterparty_post_code_too_long',
          ]),
        ),
        dryRun: z
          .object({
            feeAmount: z.string().nullable(),
            totalAmount: z.string(),
            at: z.iso
              .datetime()
              .regex(
                /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
              ),
          })
          .nullable(),
        returnedAmount: z.string().nullable(),
        fees: z.object({
          total: z.string(),
          collection: z.string(),
          return: z.string(),
          externalBank: z.string(),
        }),
        serviceProvider: z.enum(['inventi']).nullable(),
        serviceProviderId: z.string().nullable(),
        errorCode: z.string().nullable(),
        error: z.string().nullable(),
        createdAt: z.iso
          .datetime()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
          ),
        updatedAt: z.iso
          .datetime()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
          ),
        type: z.enum(['sdd']),
        mandate: z
          .object({
            id: z.string().nullable(),
            signatureDate: z.string().nullable(),
          })
          .nullable(),
        sequenceType: z.string().nullable(),
        endToEndId: z.string(),
      }),
      z.object({
        id: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        batchId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        rowId: z.string(),
        amount: z.string().nullable(),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        counterparty: z.object({
          givenName: z.string().nullable(),
          familyName: z.string().nullable(),
          legalName: z.string().nullable(),
          type: z.enum(['individual', 'corporate']).nullable(),
          address: z
            .object({
              country: z.string().nullable(),
              townName: z.string().nullable(),
              streetName: z.string().nullable(),
              buildingNumber: z.string().nullable(),
              room: z.string().nullable(),
              postCode: z.string().nullable(),
            })
            .nullable(),
          iban: z.string().nullable(),
          bic: z.string().nullable(),
        }),
        purpose: z.string().nullable(),
        status: z.enum([
          'pending',
          'invalid',
          'verified',
          'verification_failed',
          'verification_overridden',
          'dry_run_completed',
          'dry_run_failed',
          'submitted',
          'on_hold',
          'processing',
          'released',
          'failed',
          'completed',
          'cancelled',
          'returned',
        ]),
        vop: z
          .object({
            matchResult: z.enum(['match', 'close-match', 'not-matched', 'not-applicable']),
            accountHolderName: z.string().nullable(),
            checkedAt: z.iso
              .datetime()
              .regex(
                /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
              ),
            overridden: z.boolean(),
          })
          .nullable(),
        validationErrors: z.array(
          z.enum([
            'payment_type_missing',
            'payment_type_invalid',
            'payment_type_not_allowed_for_direction',
            'payment_type_not_implemented',
            'payment_type_scheme_not_allowed',
            'amount_missing',
            'counterparty_type_missing',
            'counterparty_legal_name_missing',
            'counterparty_given_name_missing',
            'counterparty_family_name_missing',
            'iban_missing',
            'mandate_id_missing',
            'mandate_signature_date_missing',
            'sequence_type_missing',
            'amount_not_a_number',
            'amount_not_positive',
            'amount_too_large',
            'amount_too_many_decimals',
            'counterparty_given_name_too_long',
            'counterparty_family_name_too_long',
            'counterparty_name_too_long',
            'counterparty_given_name_invalid_characters',
            'counterparty_family_name_invalid_characters',
            'counterparty_legal_name_too_long',
            'counterparty_legal_name_invalid_characters',
            'iban_malformed',
            'iban_checksum_invalid',
            'bic_invalid',
            'mandate_id_too_long',
            'mandate_signature_date_not_a_date',
            'mandate_signature_date_in_future',
            'sequence_type_invalid',
            'purpose_too_long',
            'mandate_not_applicable',
            'counterparty_country_invalid',
            'counterparty_town_name_too_long',
            'counterparty_street_name_too_long',
            'counterparty_building_number_too_long',
            'counterparty_room_too_long',
            'counterparty_post_code_too_long',
          ]),
        ),
        dryRun: z
          .object({
            feeAmount: z.string().nullable(),
            totalAmount: z.string(),
            at: z.iso
              .datetime()
              .regex(
                /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
              ),
          })
          .nullable(),
        returnedAmount: z.string().nullable(),
        fees: z.object({
          total: z.string(),
          collection: z.string(),
          return: z.string(),
          externalBank: z.string(),
        }),
        serviceProvider: z.enum(['inventi']).nullable(),
        serviceProviderId: z.string().nullable(),
        errorCode: z.string().nullable(),
        error: z.string().nullable(),
        createdAt: z.iso
          .datetime()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
          ),
        updatedAt: z.iso
          .datetime()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
          ),
        type: z.enum(['sepa']),
      }),
      z.object({
        id: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        batchId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        rowId: z.string(),
        amount: z.string().nullable(),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        counterparty: z.object({
          givenName: z.string().nullable(),
          familyName: z.string().nullable(),
          legalName: z.string().nullable(),
          type: z.enum(['individual', 'corporate']).nullable(),
          address: z
            .object({
              country: z.string().nullable(),
              townName: z.string().nullable(),
              streetName: z.string().nullable(),
              buildingNumber: z.string().nullable(),
              room: z.string().nullable(),
              postCode: z.string().nullable(),
            })
            .nullable(),
          iban: z.string().nullable(),
          bic: z.string().nullable(),
        }),
        purpose: z.string().nullable(),
        status: z.enum([
          'pending',
          'invalid',
          'verified',
          'verification_failed',
          'verification_overridden',
          'dry_run_completed',
          'dry_run_failed',
          'submitted',
          'on_hold',
          'processing',
          'released',
          'failed',
          'completed',
          'cancelled',
          'returned',
        ]),
        vop: z
          .object({
            matchResult: z.enum(['match', 'close-match', 'not-matched', 'not-applicable']),
            accountHolderName: z.string().nullable(),
            checkedAt: z.iso
              .datetime()
              .regex(
                /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
              ),
            overridden: z.boolean(),
          })
          .nullable(),
        validationErrors: z.array(
          z.enum([
            'payment_type_missing',
            'payment_type_invalid',
            'payment_type_not_allowed_for_direction',
            'payment_type_not_implemented',
            'payment_type_scheme_not_allowed',
            'amount_missing',
            'counterparty_type_missing',
            'counterparty_legal_name_missing',
            'counterparty_given_name_missing',
            'counterparty_family_name_missing',
            'iban_missing',
            'mandate_id_missing',
            'mandate_signature_date_missing',
            'sequence_type_missing',
            'amount_not_a_number',
            'amount_not_positive',
            'amount_too_large',
            'amount_too_many_decimals',
            'counterparty_given_name_too_long',
            'counterparty_family_name_too_long',
            'counterparty_name_too_long',
            'counterparty_given_name_invalid_characters',
            'counterparty_family_name_invalid_characters',
            'counterparty_legal_name_too_long',
            'counterparty_legal_name_invalid_characters',
            'iban_malformed',
            'iban_checksum_invalid',
            'bic_invalid',
            'mandate_id_too_long',
            'mandate_signature_date_not_a_date',
            'mandate_signature_date_in_future',
            'sequence_type_invalid',
            'purpose_too_long',
            'mandate_not_applicable',
            'counterparty_country_invalid',
            'counterparty_town_name_too_long',
            'counterparty_street_name_too_long',
            'counterparty_building_number_too_long',
            'counterparty_room_too_long',
            'counterparty_post_code_too_long',
          ]),
        ),
        dryRun: z
          .object({
            feeAmount: z.string().nullable(),
            totalAmount: z.string(),
            at: z.iso
              .datetime()
              .regex(
                /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
              ),
          })
          .nullable(),
        returnedAmount: z.string().nullable(),
        fees: z.object({
          total: z.string(),
          collection: z.string(),
          return: z.string(),
          externalBank: z.string(),
        }),
        serviceProvider: z.enum(['inventi']).nullable(),
        serviceProviderId: z.string().nullable(),
        errorCode: z.string().nullable(),
        error: z.string().nullable(),
        createdAt: z.iso
          .datetime()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
          ),
        updatedAt: z.iso
          .datetime()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
          ),
        type: z.enum(['sepa_instant']),
      }),
    ]),
  ),
});

export const listPaymentBatchItemsResponseDtoOutput = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
  data: z.array(
    z.union([
      z.object({
        id: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        batchId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        rowId: z.string(),
        amount: z.string().nullable(),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        counterparty: z.object({
          givenName: z.string().nullable(),
          familyName: z.string().nullable(),
          legalName: z.string().nullable(),
          type: z.enum(['individual', 'corporate']).nullable(),
          address: z
            .object({
              country: z.string().nullable(),
              townName: z.string().nullable(),
              streetName: z.string().nullable(),
              buildingNumber: z.string().nullable(),
              room: z.string().nullable(),
              postCode: z.string().nullable(),
            })
            .nullable(),
          iban: z.string().nullable(),
          bic: z.string().nullable(),
        }),
        purpose: z.string().nullable(),
        status: z.enum([
          'pending',
          'invalid',
          'verified',
          'verification_failed',
          'verification_overridden',
          'dry_run_completed',
          'dry_run_failed',
          'submitted',
          'on_hold',
          'processing',
          'released',
          'failed',
          'completed',
          'cancelled',
          'returned',
        ]),
        vop: z
          .object({
            matchResult: z.enum(['match', 'close-match', 'not-matched', 'not-applicable']),
            accountHolderName: z.string().nullable(),
            checkedAt: z.iso
              .datetime()
              .regex(
                /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
              ),
            overridden: z.boolean(),
          })
          .nullable(),
        validationErrors: z.array(
          z.enum([
            'payment_type_missing',
            'payment_type_invalid',
            'payment_type_not_allowed_for_direction',
            'payment_type_not_implemented',
            'payment_type_scheme_not_allowed',
            'amount_missing',
            'counterparty_type_missing',
            'counterparty_legal_name_missing',
            'counterparty_given_name_missing',
            'counterparty_family_name_missing',
            'iban_missing',
            'mandate_id_missing',
            'mandate_signature_date_missing',
            'sequence_type_missing',
            'amount_not_a_number',
            'amount_not_positive',
            'amount_too_large',
            'amount_too_many_decimals',
            'counterparty_given_name_too_long',
            'counterparty_family_name_too_long',
            'counterparty_name_too_long',
            'counterparty_given_name_invalid_characters',
            'counterparty_family_name_invalid_characters',
            'counterparty_legal_name_too_long',
            'counterparty_legal_name_invalid_characters',
            'iban_malformed',
            'iban_checksum_invalid',
            'bic_invalid',
            'mandate_id_too_long',
            'mandate_signature_date_not_a_date',
            'mandate_signature_date_in_future',
            'sequence_type_invalid',
            'purpose_too_long',
            'mandate_not_applicable',
            'counterparty_country_invalid',
            'counterparty_town_name_too_long',
            'counterparty_street_name_too_long',
            'counterparty_building_number_too_long',
            'counterparty_room_too_long',
            'counterparty_post_code_too_long',
          ]),
        ),
        dryRun: z
          .object({
            feeAmount: z.string().nullable(),
            totalAmount: z.string(),
            at: z.iso
              .datetime()
              .regex(
                /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
              ),
          })
          .nullable(),
        returnedAmount: z.string().nullable(),
        fees: z.object({
          total: z.string(),
          collection: z.string(),
          return: z.string(),
          externalBank: z.string(),
        }),
        serviceProvider: z.enum(['inventi']).nullable(),
        serviceProviderId: z.string().nullable(),
        errorCode: z.string().nullable(),
        error: z.string().nullable(),
        createdAt: z.iso
          .datetime()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
          ),
        updatedAt: z.iso
          .datetime()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
          ),
        type: z.enum(['sdd']),
        mandate: z
          .object({
            id: z.string().nullable(),
            signatureDate: z.string().nullable(),
          })
          .nullable(),
        sequenceType: z.string().nullable(),
        endToEndId: z.string(),
      }),
      z.object({
        id: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        batchId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        rowId: z.string(),
        amount: z.string().nullable(),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        counterparty: z.object({
          givenName: z.string().nullable(),
          familyName: z.string().nullable(),
          legalName: z.string().nullable(),
          type: z.enum(['individual', 'corporate']).nullable(),
          address: z
            .object({
              country: z.string().nullable(),
              townName: z.string().nullable(),
              streetName: z.string().nullable(),
              buildingNumber: z.string().nullable(),
              room: z.string().nullable(),
              postCode: z.string().nullable(),
            })
            .nullable(),
          iban: z.string().nullable(),
          bic: z.string().nullable(),
        }),
        purpose: z.string().nullable(),
        status: z.enum([
          'pending',
          'invalid',
          'verified',
          'verification_failed',
          'verification_overridden',
          'dry_run_completed',
          'dry_run_failed',
          'submitted',
          'on_hold',
          'processing',
          'released',
          'failed',
          'completed',
          'cancelled',
          'returned',
        ]),
        vop: z
          .object({
            matchResult: z.enum(['match', 'close-match', 'not-matched', 'not-applicable']),
            accountHolderName: z.string().nullable(),
            checkedAt: z.iso
              .datetime()
              .regex(
                /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
              ),
            overridden: z.boolean(),
          })
          .nullable(),
        validationErrors: z.array(
          z.enum([
            'payment_type_missing',
            'payment_type_invalid',
            'payment_type_not_allowed_for_direction',
            'payment_type_not_implemented',
            'payment_type_scheme_not_allowed',
            'amount_missing',
            'counterparty_type_missing',
            'counterparty_legal_name_missing',
            'counterparty_given_name_missing',
            'counterparty_family_name_missing',
            'iban_missing',
            'mandate_id_missing',
            'mandate_signature_date_missing',
            'sequence_type_missing',
            'amount_not_a_number',
            'amount_not_positive',
            'amount_too_large',
            'amount_too_many_decimals',
            'counterparty_given_name_too_long',
            'counterparty_family_name_too_long',
            'counterparty_name_too_long',
            'counterparty_given_name_invalid_characters',
            'counterparty_family_name_invalid_characters',
            'counterparty_legal_name_too_long',
            'counterparty_legal_name_invalid_characters',
            'iban_malformed',
            'iban_checksum_invalid',
            'bic_invalid',
            'mandate_id_too_long',
            'mandate_signature_date_not_a_date',
            'mandate_signature_date_in_future',
            'sequence_type_invalid',
            'purpose_too_long',
            'mandate_not_applicable',
            'counterparty_country_invalid',
            'counterparty_town_name_too_long',
            'counterparty_street_name_too_long',
            'counterparty_building_number_too_long',
            'counterparty_room_too_long',
            'counterparty_post_code_too_long',
          ]),
        ),
        dryRun: z
          .object({
            feeAmount: z.string().nullable(),
            totalAmount: z.string(),
            at: z.iso
              .datetime()
              .regex(
                /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
              ),
          })
          .nullable(),
        returnedAmount: z.string().nullable(),
        fees: z.object({
          total: z.string(),
          collection: z.string(),
          return: z.string(),
          externalBank: z.string(),
        }),
        serviceProvider: z.enum(['inventi']).nullable(),
        serviceProviderId: z.string().nullable(),
        errorCode: z.string().nullable(),
        error: z.string().nullable(),
        createdAt: z.iso
          .datetime()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
          ),
        updatedAt: z.iso
          .datetime()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
          ),
        type: z.enum(['sepa']),
      }),
      z.object({
        id: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        batchId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
        rowId: z.string(),
        amount: z.string().nullable(),
        currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
        counterparty: z.object({
          givenName: z.string().nullable(),
          familyName: z.string().nullable(),
          legalName: z.string().nullable(),
          type: z.enum(['individual', 'corporate']).nullable(),
          address: z
            .object({
              country: z.string().nullable(),
              townName: z.string().nullable(),
              streetName: z.string().nullable(),
              buildingNumber: z.string().nullable(),
              room: z.string().nullable(),
              postCode: z.string().nullable(),
            })
            .nullable(),
          iban: z.string().nullable(),
          bic: z.string().nullable(),
        }),
        purpose: z.string().nullable(),
        status: z.enum([
          'pending',
          'invalid',
          'verified',
          'verification_failed',
          'verification_overridden',
          'dry_run_completed',
          'dry_run_failed',
          'submitted',
          'on_hold',
          'processing',
          'released',
          'failed',
          'completed',
          'cancelled',
          'returned',
        ]),
        vop: z
          .object({
            matchResult: z.enum(['match', 'close-match', 'not-matched', 'not-applicable']),
            accountHolderName: z.string().nullable(),
            checkedAt: z.iso
              .datetime()
              .regex(
                /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
              ),
            overridden: z.boolean(),
          })
          .nullable(),
        validationErrors: z.array(
          z.enum([
            'payment_type_missing',
            'payment_type_invalid',
            'payment_type_not_allowed_for_direction',
            'payment_type_not_implemented',
            'payment_type_scheme_not_allowed',
            'amount_missing',
            'counterparty_type_missing',
            'counterparty_legal_name_missing',
            'counterparty_given_name_missing',
            'counterparty_family_name_missing',
            'iban_missing',
            'mandate_id_missing',
            'mandate_signature_date_missing',
            'sequence_type_missing',
            'amount_not_a_number',
            'amount_not_positive',
            'amount_too_large',
            'amount_too_many_decimals',
            'counterparty_given_name_too_long',
            'counterparty_family_name_too_long',
            'counterparty_name_too_long',
            'counterparty_given_name_invalid_characters',
            'counterparty_family_name_invalid_characters',
            'counterparty_legal_name_too_long',
            'counterparty_legal_name_invalid_characters',
            'iban_malformed',
            'iban_checksum_invalid',
            'bic_invalid',
            'mandate_id_too_long',
            'mandate_signature_date_not_a_date',
            'mandate_signature_date_in_future',
            'sequence_type_invalid',
            'purpose_too_long',
            'mandate_not_applicable',
            'counterparty_country_invalid',
            'counterparty_town_name_too_long',
            'counterparty_street_name_too_long',
            'counterparty_building_number_too_long',
            'counterparty_room_too_long',
            'counterparty_post_code_too_long',
          ]),
        ),
        dryRun: z
          .object({
            feeAmount: z.string().nullable(),
            totalAmount: z.string(),
            at: z.iso
              .datetime()
              .regex(
                /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
              ),
          })
          .nullable(),
        returnedAmount: z.string().nullable(),
        fees: z.object({
          total: z.string(),
          collection: z.string(),
          return: z.string(),
          externalBank: z.string(),
        }),
        serviceProvider: z.enum(['inventi']).nullable(),
        serviceProviderId: z.string().nullable(),
        errorCode: z.string().nullable(),
        error: z.string().nullable(),
        createdAt: z.iso
          .datetime()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
          ),
        updatedAt: z.iso
          .datetime()
          .regex(
            /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
          ),
        type: z.enum(['sepa_instant']),
      }),
    ]),
  ),
});

export const removePaymentBatchItemsRequestDto = z.object({
  itemIds: z
    .array(
      z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
    )
    .min(1)
    .max(1000)
    .optional(),
  status: z
    .array(
      z.enum([
        'pending',
        'invalid',
        'verified',
        'verification_failed',
        'verification_overridden',
        'dry_run_completed',
        'dry_run_failed',
        'submitted',
        'on_hold',
        'processing',
        'released',
        'failed',
        'completed',
        'cancelled',
        'returned',
      ]),
    )
    .min(1)
    .optional(),
  all: z.literal(true).optional(),
});

export const removePaymentBatchItemsResponseDtoOutput = z.object({
  data: z.object({
    removed: z.int().gte(0).lte(9007199254740991),
  }),
});

export const paymentBatchItemNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['PAYMENT_BATCH_ITEM.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const paymentBatchRowIdImmutableErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(422),
  error: z.object({
    message: z.string(),
    code: z.enum(['PAYMENT_BATCH.ROW_ID_IMMUTABLE']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const updatePaymentBatchItemRequestDto = z.object({
  rowId: z.string().min(1).max(64).optional(),
  type: z.string().max(255).optional(),
  amount: z.string().max(255).optional(),
  currency: z.enum(['EUR']).optional().default('EUR'),
  counterparty: z
    .object({
      type: z.string().max(255).optional(),
      givenName: z.string().max(255).optional(),
      familyName: z.string().max(255).optional(),
      legalName: z.string().max(255).optional(),
      iban: z.string().max(255).optional(),
      bic: z.string().max(255).optional(),
      address: z
        .object({
          country: z.string().max(255).optional(),
          townName: z.string().max(255).optional(),
          streetName: z.string().max(255).optional(),
          buildingNumber: z.string().max(255).optional(),
          room: z.string().max(255).optional(),
          postCode: z.string().max(255).optional(),
        })
        .optional(),
    })
    .optional(),
  mandate: z
    .object({
      id: z.string().max(255).optional(),
      signatureDate: z.string().max(255).optional(),
    })
    .optional(),
  sequenceType: z.string().max(255).optional(),
  purpose: z.string().max(255).optional(),
});

export const paymentBatchItemResponseDtoOutput = z.object({
  data: z.union([
    z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      batchId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      rowId: z.string(),
      amount: z.string().nullable(),
      currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
      counterparty: z.object({
        givenName: z.string().nullable(),
        familyName: z.string().nullable(),
        legalName: z.string().nullable(),
        type: z.enum(['individual', 'corporate']).nullable(),
        address: z
          .object({
            country: z.string().nullable(),
            townName: z.string().nullable(),
            streetName: z.string().nullable(),
            buildingNumber: z.string().nullable(),
            room: z.string().nullable(),
            postCode: z.string().nullable(),
          })
          .nullable(),
        iban: z.string().nullable(),
        bic: z.string().nullable(),
      }),
      purpose: z.string().nullable(),
      status: z.enum([
        'pending',
        'invalid',
        'verified',
        'verification_failed',
        'verification_overridden',
        'dry_run_completed',
        'dry_run_failed',
        'submitted',
        'on_hold',
        'processing',
        'released',
        'failed',
        'completed',
        'cancelled',
        'returned',
      ]),
      vop: z
        .object({
          matchResult: z.enum(['match', 'close-match', 'not-matched', 'not-applicable']),
          accountHolderName: z.string().nullable(),
          checkedAt: z.iso
            .datetime()
            .regex(
              /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
            ),
          overridden: z.boolean(),
        })
        .nullable(),
      validationErrors: z.array(
        z.enum([
          'payment_type_missing',
          'payment_type_invalid',
          'payment_type_not_allowed_for_direction',
          'payment_type_not_implemented',
          'payment_type_scheme_not_allowed',
          'amount_missing',
          'counterparty_type_missing',
          'counterparty_legal_name_missing',
          'counterparty_given_name_missing',
          'counterparty_family_name_missing',
          'iban_missing',
          'mandate_id_missing',
          'mandate_signature_date_missing',
          'sequence_type_missing',
          'amount_not_a_number',
          'amount_not_positive',
          'amount_too_large',
          'amount_too_many_decimals',
          'counterparty_given_name_too_long',
          'counterparty_family_name_too_long',
          'counterparty_name_too_long',
          'counterparty_given_name_invalid_characters',
          'counterparty_family_name_invalid_characters',
          'counterparty_legal_name_too_long',
          'counterparty_legal_name_invalid_characters',
          'iban_malformed',
          'iban_checksum_invalid',
          'bic_invalid',
          'mandate_id_too_long',
          'mandate_signature_date_not_a_date',
          'mandate_signature_date_in_future',
          'sequence_type_invalid',
          'purpose_too_long',
          'mandate_not_applicable',
          'counterparty_country_invalid',
          'counterparty_town_name_too_long',
          'counterparty_street_name_too_long',
          'counterparty_building_number_too_long',
          'counterparty_room_too_long',
          'counterparty_post_code_too_long',
        ]),
      ),
      dryRun: z
        .object({
          feeAmount: z.string().nullable(),
          totalAmount: z.string(),
          at: z.iso
            .datetime()
            .regex(
              /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
            ),
        })
        .nullable(),
      returnedAmount: z.string().nullable(),
      fees: z.object({
        total: z.string(),
        collection: z.string(),
        return: z.string(),
        externalBank: z.string(),
      }),
      serviceProvider: z.enum(['inventi']).nullable(),
      serviceProviderId: z.string().nullable(),
      errorCode: z.string().nullable(),
      error: z.string().nullable(),
      createdAt: z.iso
        .datetime()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
        ),
      updatedAt: z.iso
        .datetime()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
        ),
      type: z.enum(['sdd']),
      mandate: z
        .object({
          id: z.string().nullable(),
          signatureDate: z.string().nullable(),
        })
        .nullable(),
      sequenceType: z.string().nullable(),
      endToEndId: z.string(),
    }),
    z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      batchId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      rowId: z.string(),
      amount: z.string().nullable(),
      currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
      counterparty: z.object({
        givenName: z.string().nullable(),
        familyName: z.string().nullable(),
        legalName: z.string().nullable(),
        type: z.enum(['individual', 'corporate']).nullable(),
        address: z
          .object({
            country: z.string().nullable(),
            townName: z.string().nullable(),
            streetName: z.string().nullable(),
            buildingNumber: z.string().nullable(),
            room: z.string().nullable(),
            postCode: z.string().nullable(),
          })
          .nullable(),
        iban: z.string().nullable(),
        bic: z.string().nullable(),
      }),
      purpose: z.string().nullable(),
      status: z.enum([
        'pending',
        'invalid',
        'verified',
        'verification_failed',
        'verification_overridden',
        'dry_run_completed',
        'dry_run_failed',
        'submitted',
        'on_hold',
        'processing',
        'released',
        'failed',
        'completed',
        'cancelled',
        'returned',
      ]),
      vop: z
        .object({
          matchResult: z.enum(['match', 'close-match', 'not-matched', 'not-applicable']),
          accountHolderName: z.string().nullable(),
          checkedAt: z.iso
            .datetime()
            .regex(
              /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
            ),
          overridden: z.boolean(),
        })
        .nullable(),
      validationErrors: z.array(
        z.enum([
          'payment_type_missing',
          'payment_type_invalid',
          'payment_type_not_allowed_for_direction',
          'payment_type_not_implemented',
          'payment_type_scheme_not_allowed',
          'amount_missing',
          'counterparty_type_missing',
          'counterparty_legal_name_missing',
          'counterparty_given_name_missing',
          'counterparty_family_name_missing',
          'iban_missing',
          'mandate_id_missing',
          'mandate_signature_date_missing',
          'sequence_type_missing',
          'amount_not_a_number',
          'amount_not_positive',
          'amount_too_large',
          'amount_too_many_decimals',
          'counterparty_given_name_too_long',
          'counterparty_family_name_too_long',
          'counterparty_name_too_long',
          'counterparty_given_name_invalid_characters',
          'counterparty_family_name_invalid_characters',
          'counterparty_legal_name_too_long',
          'counterparty_legal_name_invalid_characters',
          'iban_malformed',
          'iban_checksum_invalid',
          'bic_invalid',
          'mandate_id_too_long',
          'mandate_signature_date_not_a_date',
          'mandate_signature_date_in_future',
          'sequence_type_invalid',
          'purpose_too_long',
          'mandate_not_applicable',
          'counterparty_country_invalid',
          'counterparty_town_name_too_long',
          'counterparty_street_name_too_long',
          'counterparty_building_number_too_long',
          'counterparty_room_too_long',
          'counterparty_post_code_too_long',
        ]),
      ),
      dryRun: z
        .object({
          feeAmount: z.string().nullable(),
          totalAmount: z.string(),
          at: z.iso
            .datetime()
            .regex(
              /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
            ),
        })
        .nullable(),
      returnedAmount: z.string().nullable(),
      fees: z.object({
        total: z.string(),
        collection: z.string(),
        return: z.string(),
        externalBank: z.string(),
      }),
      serviceProvider: z.enum(['inventi']).nullable(),
      serviceProviderId: z.string().nullable(),
      errorCode: z.string().nullable(),
      error: z.string().nullable(),
      createdAt: z.iso
        .datetime()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
        ),
      updatedAt: z.iso
        .datetime()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
        ),
      type: z.enum(['sepa']),
    }),
    z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      batchId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      rowId: z.string(),
      amount: z.string().nullable(),
      currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
      counterparty: z.object({
        givenName: z.string().nullable(),
        familyName: z.string().nullable(),
        legalName: z.string().nullable(),
        type: z.enum(['individual', 'corporate']).nullable(),
        address: z
          .object({
            country: z.string().nullable(),
            townName: z.string().nullable(),
            streetName: z.string().nullable(),
            buildingNumber: z.string().nullable(),
            room: z.string().nullable(),
            postCode: z.string().nullable(),
          })
          .nullable(),
        iban: z.string().nullable(),
        bic: z.string().nullable(),
      }),
      purpose: z.string().nullable(),
      status: z.enum([
        'pending',
        'invalid',
        'verified',
        'verification_failed',
        'verification_overridden',
        'dry_run_completed',
        'dry_run_failed',
        'submitted',
        'on_hold',
        'processing',
        'released',
        'failed',
        'completed',
        'cancelled',
        'returned',
      ]),
      vop: z
        .object({
          matchResult: z.enum(['match', 'close-match', 'not-matched', 'not-applicable']),
          accountHolderName: z.string().nullable(),
          checkedAt: z.iso
            .datetime()
            .regex(
              /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
            ),
          overridden: z.boolean(),
        })
        .nullable(),
      validationErrors: z.array(
        z.enum([
          'payment_type_missing',
          'payment_type_invalid',
          'payment_type_not_allowed_for_direction',
          'payment_type_not_implemented',
          'payment_type_scheme_not_allowed',
          'amount_missing',
          'counterparty_type_missing',
          'counterparty_legal_name_missing',
          'counterparty_given_name_missing',
          'counterparty_family_name_missing',
          'iban_missing',
          'mandate_id_missing',
          'mandate_signature_date_missing',
          'sequence_type_missing',
          'amount_not_a_number',
          'amount_not_positive',
          'amount_too_large',
          'amount_too_many_decimals',
          'counterparty_given_name_too_long',
          'counterparty_family_name_too_long',
          'counterparty_name_too_long',
          'counterparty_given_name_invalid_characters',
          'counterparty_family_name_invalid_characters',
          'counterparty_legal_name_too_long',
          'counterparty_legal_name_invalid_characters',
          'iban_malformed',
          'iban_checksum_invalid',
          'bic_invalid',
          'mandate_id_too_long',
          'mandate_signature_date_not_a_date',
          'mandate_signature_date_in_future',
          'sequence_type_invalid',
          'purpose_too_long',
          'mandate_not_applicable',
          'counterparty_country_invalid',
          'counterparty_town_name_too_long',
          'counterparty_street_name_too_long',
          'counterparty_building_number_too_long',
          'counterparty_room_too_long',
          'counterparty_post_code_too_long',
        ]),
      ),
      dryRun: z
        .object({
          feeAmount: z.string().nullable(),
          totalAmount: z.string(),
          at: z.iso
            .datetime()
            .regex(
              /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
            ),
        })
        .nullable(),
      returnedAmount: z.string().nullable(),
      fees: z.object({
        total: z.string(),
        collection: z.string(),
        return: z.string(),
        externalBank: z.string(),
      }),
      serviceProvider: z.enum(['inventi']).nullable(),
      serviceProviderId: z.string().nullable(),
      errorCode: z.string().nullable(),
      error: z.string().nullable(),
      createdAt: z.iso
        .datetime()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
        ),
      updatedAt: z.iso
        .datetime()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
        ),
      type: z.enum(['sepa_instant']),
    }),
  ]),
});

export const paymentBatchItemInvalidStateErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(422),
  error: z.object({
    message: z.string(),
    code: z.enum(['PAYMENT_BATCH_ITEM.INVALID_STATE']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const forceApprovePaymentBatchItemsRequestDto = z.object({
  itemIds: z
    .array(
      z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
    )
    .min(1)
    .max(1000)
    .optional(),
  all: z.literal(true).optional(),
});

export const forceApprovePaymentBatchItemsResponseDtoOutput = z.object({
  data: z.object({
    approved: z.int().gte(0).lte(9007199254740991),
  }),
});

export const paymentBatchNotSubmittableErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(422),
  error: z.object({
    message: z.string(),
    code: z.enum(['PAYMENT_BATCH.NOT_SUBMITTABLE']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const outgoingTransferIpCountryUnresolvedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['OUTGOING_TRANSFER.IP_COUNTRY.UNRESOLVED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const paymentBatchEmptyErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(422),
  error: z.object({
    message: z.string(),
    code: z.enum(['PAYMENT_BATCH.EMPTY']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const sddBatchScheduleInvalidErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(422),
  error: z.object({
    message: z.string(),
    code: z.enum(['SDD_BATCH.SCHEDULE_INVALID']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const sddBatchAccountLimitExceededErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(422),
  error: z.object({
    message: z.string(),
    code: z.enum(['SDD_BATCH.ACCOUNT_LIMIT_EXCEEDED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const paymentBatchSubmitChallengeResponseDtoOutput = z.object({
  data: z.object({
    challengeId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      ),
    status: z.enum(['pending', 'approved', 'denied', 'expired']),
    channel: z.enum(['ciba']),
    expiresAt: z.number(),
  }),
});

export const resolvePaymentBatchSubmitChallengeRequestDto = z.object({
  challengeId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

export const clonePaymentBatchRequestDto = z
  .object({
    name: z.string().max(140).optional(),
  })
  .default({});

export const activeSessionListResponseDtoOutput = z.object({
  data: z.array(
    z.object({
      id: z.string(),
      createdAt: z.string().optional(),
      updatedAt: z.string().optional(),
      authenticatedAt: z.string().optional(),
      lastInteractedAt: z.string().optional(),
      idleExpiresAt: z.string().optional(),
      expiresAt: z.string().optional(),
      initialIp: z.string().nullish(),
      initialIpLocation: z
        .object({
          country: z.enum([
            'AD',
            'AE',
            'AF',
            'AG',
            'AI',
            'AL',
            'AM',
            'AO',
            'AQ',
            'AR',
            'AS',
            'AT',
            'AU',
            'AW',
            'AX',
            'AZ',
            'BA',
            'BB',
            'BD',
            'BE',
            'BF',
            'BG',
            'BH',
            'BI',
            'BJ',
            'BL',
            'BM',
            'BN',
            'BO',
            'BQ',
            'BR',
            'BS',
            'BT',
            'BV',
            'BW',
            'BY',
            'BZ',
            'CA',
            'CC',
            'CD',
            'CF',
            'CG',
            'CH',
            'CI',
            'CK',
            'CL',
            'CM',
            'CN',
            'CO',
            'CR',
            'CU',
            'CV',
            'CW',
            'CX',
            'CY',
            'CZ',
            'DE',
            'DJ',
            'DK',
            'DM',
            'DO',
            'DZ',
            'EC',
            'EE',
            'EG',
            'EH',
            'ER',
            'ES',
            'ET',
            'FI',
            'FJ',
            'FK',
            'FM',
            'FO',
            'FR',
            'GA',
            'GB',
            'GD',
            'GE',
            'GF',
            'GG',
            'GH',
            'GI',
            'GL',
            'GM',
            'GN',
            'GP',
            'GQ',
            'GR',
            'GS',
            'GT',
            'GU',
            'GW',
            'GY',
            'HK',
            'HM',
            'HN',
            'HR',
            'HT',
            'HU',
            'ID',
            'IE',
            'IL',
            'IM',
            'IN',
            'IO',
            'IQ',
            'IR',
            'IS',
            'IT',
            'JE',
            'JM',
            'JO',
            'JP',
            'KE',
            'KG',
            'KH',
            'KI',
            'KM',
            'KN',
            'KP',
            'KR',
            'KW',
            'KY',
            'KZ',
            'LA',
            'LB',
            'LC',
            'LI',
            'LK',
            'LR',
            'LS',
            'LT',
            'LU',
            'LV',
            'LY',
            'MA',
            'MC',
            'MD',
            'ME',
            'MF',
            'MG',
            'MH',
            'MK',
            'ML',
            'MM',
            'MN',
            'MO',
            'MP',
            'MQ',
            'MR',
            'MS',
            'MT',
            'MU',
            'MV',
            'MW',
            'MX',
            'MY',
            'MZ',
            'NA',
            'NC',
            'NE',
            'NF',
            'NG',
            'NI',
            'NL',
            'NO',
            'NP',
            'NR',
            'NU',
            'NZ',
            'OM',
            'PA',
            'PE',
            'PF',
            'PG',
            'PH',
            'PK',
            'PL',
            'PM',
            'PN',
            'PR',
            'PS',
            'PT',
            'PW',
            'PY',
            'QA',
            'RE',
            'RO',
            'RS',
            'RU',
            'RW',
            'SA',
            'SB',
            'SC',
            'SD',
            'SE',
            'SG',
            'SH',
            'SI',
            'SJ',
            'SK',
            'SL',
            'SM',
            'SN',
            'SO',
            'SR',
            'SS',
            'ST',
            'SV',
            'SX',
            'SY',
            'SZ',
            'TC',
            'TD',
            'TF',
            'TG',
            'TH',
            'TJ',
            'TK',
            'TL',
            'TM',
            'TN',
            'TO',
            'TR',
            'TT',
            'TV',
            'TW',
            'TZ',
            'UA',
            'UG',
            'UM',
            'US',
            'UY',
            'UZ',
            'VA',
            'VC',
            'VE',
            'VG',
            'VI',
            'VN',
            'VU',
            'WF',
            'WS',
            'XK',
            'YE',
            'YT',
            'ZA',
            'ZM',
            'ZW',
          ]),
          city: z.string(),
          isp: z.string().nullable(),
          timezone: z.string().nullable(),
          lat: z.number().nullable(),
          lon: z.number().nullable(),
        })
        .nullish(),
      lastIp: z.string().nullish(),
      lastIpLocation: z
        .object({
          country: z.enum([
            'AD',
            'AE',
            'AF',
            'AG',
            'AI',
            'AL',
            'AM',
            'AO',
            'AQ',
            'AR',
            'AS',
            'AT',
            'AU',
            'AW',
            'AX',
            'AZ',
            'BA',
            'BB',
            'BD',
            'BE',
            'BF',
            'BG',
            'BH',
            'BI',
            'BJ',
            'BL',
            'BM',
            'BN',
            'BO',
            'BQ',
            'BR',
            'BS',
            'BT',
            'BV',
            'BW',
            'BY',
            'BZ',
            'CA',
            'CC',
            'CD',
            'CF',
            'CG',
            'CH',
            'CI',
            'CK',
            'CL',
            'CM',
            'CN',
            'CO',
            'CR',
            'CU',
            'CV',
            'CW',
            'CX',
            'CY',
            'CZ',
            'DE',
            'DJ',
            'DK',
            'DM',
            'DO',
            'DZ',
            'EC',
            'EE',
            'EG',
            'EH',
            'ER',
            'ES',
            'ET',
            'FI',
            'FJ',
            'FK',
            'FM',
            'FO',
            'FR',
            'GA',
            'GB',
            'GD',
            'GE',
            'GF',
            'GG',
            'GH',
            'GI',
            'GL',
            'GM',
            'GN',
            'GP',
            'GQ',
            'GR',
            'GS',
            'GT',
            'GU',
            'GW',
            'GY',
            'HK',
            'HM',
            'HN',
            'HR',
            'HT',
            'HU',
            'ID',
            'IE',
            'IL',
            'IM',
            'IN',
            'IO',
            'IQ',
            'IR',
            'IS',
            'IT',
            'JE',
            'JM',
            'JO',
            'JP',
            'KE',
            'KG',
            'KH',
            'KI',
            'KM',
            'KN',
            'KP',
            'KR',
            'KW',
            'KY',
            'KZ',
            'LA',
            'LB',
            'LC',
            'LI',
            'LK',
            'LR',
            'LS',
            'LT',
            'LU',
            'LV',
            'LY',
            'MA',
            'MC',
            'MD',
            'ME',
            'MF',
            'MG',
            'MH',
            'MK',
            'ML',
            'MM',
            'MN',
            'MO',
            'MP',
            'MQ',
            'MR',
            'MS',
            'MT',
            'MU',
            'MV',
            'MW',
            'MX',
            'MY',
            'MZ',
            'NA',
            'NC',
            'NE',
            'NF',
            'NG',
            'NI',
            'NL',
            'NO',
            'NP',
            'NR',
            'NU',
            'NZ',
            'OM',
            'PA',
            'PE',
            'PF',
            'PG',
            'PH',
            'PK',
            'PL',
            'PM',
            'PN',
            'PR',
            'PS',
            'PT',
            'PW',
            'PY',
            'QA',
            'RE',
            'RO',
            'RS',
            'RU',
            'RW',
            'SA',
            'SB',
            'SC',
            'SD',
            'SE',
            'SG',
            'SH',
            'SI',
            'SJ',
            'SK',
            'SL',
            'SM',
            'SN',
            'SO',
            'SR',
            'SS',
            'ST',
            'SV',
            'SX',
            'SY',
            'SZ',
            'TC',
            'TD',
            'TF',
            'TG',
            'TH',
            'TJ',
            'TK',
            'TL',
            'TM',
            'TN',
            'TO',
            'TR',
            'TT',
            'TV',
            'TW',
            'TZ',
            'UA',
            'UG',
            'UM',
            'US',
            'UY',
            'UZ',
            'VA',
            'VC',
            'VE',
            'VG',
            'VI',
            'VN',
            'VU',
            'WF',
            'WS',
            'XK',
            'YE',
            'YT',
            'ZA',
            'ZM',
            'ZW',
          ]),
          city: z.string(),
          isp: z.string().nullable(),
          timezone: z.string().nullable(),
          lat: z.number().nullable(),
          lon: z.number().nullable(),
        })
        .nullish(),
      device: z.object({
        os: z.object({
          name: z.string().optional(),
          version: z.string().optional(),
        }),
        browser: z.object({
          name: z.string().optional(),
          version: z.string().optional(),
        }),
        type: z.enum([
          'unknown',
          'desktop',
          'mobile',
          'tablet',
          'smarttv',
          'console',
          'wearable',
          'embedded',
        ]),
      }),
      authMethods: z.array(z.string()),
      clients: z.array(z.string()),
    }),
  ),
});

export const sessionsCannotRevokeCurrentErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(403),
  error: z.object({
    message: z.string(),
    code: z.enum(['SESSIONS.CANNOT_REVOKE_CURRENT']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const sessionsNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['SESSIONS.NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const evaluateLoginRequestDto = z.object({
  userId: z.string().min(1),
  initialKycCompletedAt: z.iso
    .datetime()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
    )
    .nullish(),
  includeSessionExpiry: z.boolean().optional(),
  loginDetails: z.object({
    sessionExpiresAt: z.iso
      .datetime()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
      )
      .nullish(),
    riskAssessment: z
      .object({
        assessments: z
          .object({
            NewDevice: z
              .object({
                confidence: z.enum(['low', 'medium', 'high', 'neutral']),
                code: z.string().optional(),
                details: z
                  .object({
                    device: z.string().optional(),
                    useragent: z.string().optional(),
                  })
                  .optional(),
              })
              .optional(),
            ImpossibleTravel: z
              .object({
                confidence: z.enum(['low', 'medium', 'high', 'neutral']),
                code: z.string().optional(),
              })
              .optional(),
            UntrustedIP: z
              .object({
                confidence: z.enum(['low', 'medium', 'high', 'neutral']),
                code: z.string().optional(),
              })
              .optional(),
            PhoneNumber: z
              .object({
                confidence: z.enum(['low', 'medium', 'high', 'neutral']),
                code: z.string().optional(),
              })
              .optional(),
          })
          .optional(),
        confidence: z.enum(['low', 'medium', 'high', 'neutral']).optional(),
        version: z.string().optional(),
      })
      .nullish(),
    latestMfaCompletedAt: z.number().nullish(),
    clientId: z.string().nullish(),
    country: z
      .enum([
        'AD',
        'AE',
        'AF',
        'AG',
        'AI',
        'AL',
        'AM',
        'AO',
        'AQ',
        'AR',
        'AS',
        'AT',
        'AU',
        'AW',
        'AX',
        'AZ',
        'BA',
        'BB',
        'BD',
        'BE',
        'BF',
        'BG',
        'BH',
        'BI',
        'BJ',
        'BL',
        'BM',
        'BN',
        'BO',
        'BQ',
        'BR',
        'BS',
        'BT',
        'BV',
        'BW',
        'BY',
        'BZ',
        'CA',
        'CC',
        'CD',
        'CF',
        'CG',
        'CH',
        'CI',
        'CK',
        'CL',
        'CM',
        'CN',
        'CO',
        'CR',
        'CU',
        'CV',
        'CW',
        'CX',
        'CY',
        'CZ',
        'DE',
        'DJ',
        'DK',
        'DM',
        'DO',
        'DZ',
        'EC',
        'EE',
        'EG',
        'EH',
        'ER',
        'ES',
        'ET',
        'FI',
        'FJ',
        'FK',
        'FM',
        'FO',
        'FR',
        'GA',
        'GB',
        'GD',
        'GE',
        'GF',
        'GG',
        'GH',
        'GI',
        'GL',
        'GM',
        'GN',
        'GP',
        'GQ',
        'GR',
        'GS',
        'GT',
        'GU',
        'GW',
        'GY',
        'HK',
        'HM',
        'HN',
        'HR',
        'HT',
        'HU',
        'ID',
        'IE',
        'IL',
        'IM',
        'IN',
        'IO',
        'IQ',
        'IR',
        'IS',
        'IT',
        'JE',
        'JM',
        'JO',
        'JP',
        'KE',
        'KG',
        'KH',
        'KI',
        'KM',
        'KN',
        'KP',
        'KR',
        'KW',
        'KY',
        'KZ',
        'LA',
        'LB',
        'LC',
        'LI',
        'LK',
        'LR',
        'LS',
        'LT',
        'LU',
        'LV',
        'LY',
        'MA',
        'MC',
        'MD',
        'ME',
        'MF',
        'MG',
        'MH',
        'MK',
        'ML',
        'MM',
        'MN',
        'MO',
        'MP',
        'MQ',
        'MR',
        'MS',
        'MT',
        'MU',
        'MV',
        'MW',
        'MX',
        'MY',
        'MZ',
        'NA',
        'NC',
        'NE',
        'NF',
        'NG',
        'NI',
        'NL',
        'NO',
        'NP',
        'NR',
        'NU',
        'NZ',
        'OM',
        'PA',
        'PE',
        'PF',
        'PG',
        'PH',
        'PK',
        'PL',
        'PM',
        'PN',
        'PR',
        'PS',
        'PT',
        'PW',
        'PY',
        'QA',
        'RE',
        'RO',
        'RS',
        'RU',
        'RW',
        'SA',
        'SB',
        'SC',
        'SD',
        'SE',
        'SG',
        'SH',
        'SI',
        'SJ',
        'SK',
        'SL',
        'SM',
        'SN',
        'SO',
        'SR',
        'SS',
        'ST',
        'SV',
        'SX',
        'SY',
        'SZ',
        'TC',
        'TD',
        'TF',
        'TG',
        'TH',
        'TJ',
        'TK',
        'TL',
        'TM',
        'TN',
        'TO',
        'TR',
        'TT',
        'TV',
        'TW',
        'TZ',
        'UA',
        'UG',
        'UM',
        'US',
        'UY',
        'UZ',
        'VA',
        'VC',
        'VE',
        'VG',
        'VI',
        'VN',
        'VU',
        'WF',
        'WS',
        'XK',
        'YE',
        'YT',
        'ZA',
        'ZM',
        'ZW',
      ])
      .optional(),
  }),
});

export const evaluateLoginResponseDtoOutput = z.object({
  data: z.object({
    claims: z.object({
      livenessCheckAt: z.number().optional(),
    }),
    allowLogin: z.boolean(),
    requireMfa: z.boolean(),
    sessionExpiresAt: z.string().optional(),
  }),
});

export const evaluateRegistrationRequestDto = z.object({
  country: z
    .enum([
      'AD',
      'AE',
      'AF',
      'AG',
      'AI',
      'AL',
      'AM',
      'AO',
      'AQ',
      'AR',
      'AS',
      'AT',
      'AU',
      'AW',
      'AX',
      'AZ',
      'BA',
      'BB',
      'BD',
      'BE',
      'BF',
      'BG',
      'BH',
      'BI',
      'BJ',
      'BL',
      'BM',
      'BN',
      'BO',
      'BQ',
      'BR',
      'BS',
      'BT',
      'BV',
      'BW',
      'BY',
      'BZ',
      'CA',
      'CC',
      'CD',
      'CF',
      'CG',
      'CH',
      'CI',
      'CK',
      'CL',
      'CM',
      'CN',
      'CO',
      'CR',
      'CU',
      'CV',
      'CW',
      'CX',
      'CY',
      'CZ',
      'DE',
      'DJ',
      'DK',
      'DM',
      'DO',
      'DZ',
      'EC',
      'EE',
      'EG',
      'EH',
      'ER',
      'ES',
      'ET',
      'FI',
      'FJ',
      'FK',
      'FM',
      'FO',
      'FR',
      'GA',
      'GB',
      'GD',
      'GE',
      'GF',
      'GG',
      'GH',
      'GI',
      'GL',
      'GM',
      'GN',
      'GP',
      'GQ',
      'GR',
      'GS',
      'GT',
      'GU',
      'GW',
      'GY',
      'HK',
      'HM',
      'HN',
      'HR',
      'HT',
      'HU',
      'ID',
      'IE',
      'IL',
      'IM',
      'IN',
      'IO',
      'IQ',
      'IR',
      'IS',
      'IT',
      'JE',
      'JM',
      'JO',
      'JP',
      'KE',
      'KG',
      'KH',
      'KI',
      'KM',
      'KN',
      'KP',
      'KR',
      'KW',
      'KY',
      'KZ',
      'LA',
      'LB',
      'LC',
      'LI',
      'LK',
      'LR',
      'LS',
      'LT',
      'LU',
      'LV',
      'LY',
      'MA',
      'MC',
      'MD',
      'ME',
      'MF',
      'MG',
      'MH',
      'MK',
      'ML',
      'MM',
      'MN',
      'MO',
      'MP',
      'MQ',
      'MR',
      'MS',
      'MT',
      'MU',
      'MV',
      'MW',
      'MX',
      'MY',
      'MZ',
      'NA',
      'NC',
      'NE',
      'NF',
      'NG',
      'NI',
      'NL',
      'NO',
      'NP',
      'NR',
      'NU',
      'NZ',
      'OM',
      'PA',
      'PE',
      'PF',
      'PG',
      'PH',
      'PK',
      'PL',
      'PM',
      'PN',
      'PR',
      'PS',
      'PT',
      'PW',
      'PY',
      'QA',
      'RE',
      'RO',
      'RS',
      'RU',
      'RW',
      'SA',
      'SB',
      'SC',
      'SD',
      'SE',
      'SG',
      'SH',
      'SI',
      'SJ',
      'SK',
      'SL',
      'SM',
      'SN',
      'SO',
      'SR',
      'SS',
      'ST',
      'SV',
      'SX',
      'SY',
      'SZ',
      'TC',
      'TD',
      'TF',
      'TG',
      'TH',
      'TJ',
      'TK',
      'TL',
      'TM',
      'TN',
      'TO',
      'TR',
      'TT',
      'TV',
      'TW',
      'TZ',
      'UA',
      'UG',
      'UM',
      'US',
      'UY',
      'UZ',
      'VA',
      'VC',
      'VE',
      'VG',
      'VI',
      'VN',
      'VU',
      'WF',
      'WS',
      'XK',
      'YE',
      'YT',
      'ZA',
      'ZM',
      'ZW',
    ])
    .optional(),
  email: z
    .email()
    .regex(
      /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/,
    ),
});

export const evaluateRegistrationResponseDtoOutput = z.object({
  data: z.object({
    allow: z.boolean(),
  }),
});

export const userConflictBasicInfoAlreadySetErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['USER.CONFLICT.BASIC_INFO_ALREADY_SET']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const genericForbiddenErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(403),
  error: z.object({
    message: z.string(),
    code: z.enum(['GENERIC.FORBIDDEN']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const collectBasicInfoRequestDto = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
});

export const collectBasicInfoResponseDtoOutput = z.object({
  data: z.object({
    firstName: z.string(),
    lastName: z.string(),
  }),
});

export const getContextsResponseDtoOutput = z.object({
  data: z.object({
    organizations: z.array(
      z.object({
        id: z.string(),
        name: z.string().optional(),
        displayName: z.string().optional(),
        branding: z
          .object({
            logoUrl: z.string().optional(),
          })
          .optional(),
        isSupportedCountry: z.boolean(),
        sddCreditorIdStatus: z.enum([
          'NOT_STARTED',
          'IN_REVIEW',
          'RESUBMISSION_REQUESTED',
          'APPROVED',
          'REJECTED',
        ]),
      }),
    ),
  }),
});

export const getProfilePictureResponseDtoOutput = z.object({
  data: z.object({
    url: z.url().nullable(),
  }),
});

export const uploadProfilePictureResponseDtoOutput = z.object({
  data: z.object({
    url: z.url(),
    fields: z.record(z.string(), z.string()),
  }),
});

export const getUserResponseDtoOutput = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    )
    .readonly(),
  email: z.string(),
  givenName: z.string().optional(),
  familyName: z.string().optional(),
  category: z.enum(['external']),
  type: z.enum(['human']),
  profile: z
    .object({
      phone: z.string().optional(),
      residentialAddress: z
        .object({
          country: z
            .string()
            .length(2)
            .regex(/^[A-Z]{2}$/),
          region: z.string().optional(),
          postalCode: z.string().optional(),
          city: z.string(),
          street: z.string(),
          houseNumber: z.string().optional(),
          refinement: z.string().optional(),
        })
        .optional(),
    })
    .optional(),
  status: z.enum(['active', 'inactive']).optional(),
});

export const setLivenessLockResponseDtoOutput = z.object({
  data: z.object({
    ok: z.boolean(),
  }),
});

export const genericArgumentOutOfRangeErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(400),
  error: z.object({
    message: z.string(),
    code: z.enum(['GENERIC.ARGUMENT_OUT_OF_RANGE']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const verificationOnboardingCountryNotSupportedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(403),
  error: z.object({
    message: z.string(),
    code: z.enum(['VERIFICATION.ONBOARDING_COUNTRY_NOT_SUPPORTED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const generateKycLinkBodyDto = z.object({
  kycScope: z.enum(['CONSUMER', 'CORPORATE']),
});

export const generateVerificationLinkResponseDtoOutput = z.object({
  url: z.url(),
});

export const verificationIndividualApplicantNotFoundErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(404),
  error: z.object({
    message: z.string(),
    code: z.enum(['VERIFICATION.INDIVIDUAL_APPLICANT_NOT_FOUND']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const getKycStatusResponseDtoOutput = z.object({
  createdAt: z.string(),
  email: z.string().optional(),
  phone: z.string().optional(),
  type: z.enum(['individual', 'company']).optional(),
  info: z
    .object({
      firstName: z.string().optional(),
      lastName: z.string().optional(),
      middleName: z.string().optional(),
      firstNameEn: z.string().optional(),
      lastNameEn: z.string().optional(),
      middleNameEn: z.string().optional(),
      legalName: z.string().optional(),
      dob: z.string().optional(),
      gender: z.string().optional(),
      nationality: z
        .enum([
          'AD',
          'AE',
          'AF',
          'AG',
          'AI',
          'AL',
          'AM',
          'AO',
          'AQ',
          'AR',
          'AS',
          'AT',
          'AU',
          'AW',
          'AX',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BF',
          'BG',
          'BH',
          'BI',
          'BJ',
          'BL',
          'BM',
          'BN',
          'BO',
          'BQ',
          'BR',
          'BS',
          'BT',
          'BV',
          'BW',
          'BY',
          'BZ',
          'CA',
          'CC',
          'CD',
          'CF',
          'CG',
          'CH',
          'CI',
          'CK',
          'CL',
          'CM',
          'CN',
          'CO',
          'CR',
          'CU',
          'CV',
          'CW',
          'CX',
          'CY',
          'CZ',
          'DE',
          'DJ',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'EH',
          'ER',
          'ES',
          'ET',
          'FI',
          'FJ',
          'FK',
          'FM',
          'FO',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GF',
          'GG',
          'GH',
          'GI',
          'GL',
          'GM',
          'GN',
          'GP',
          'GQ',
          'GR',
          'GS',
          'GT',
          'GU',
          'GW',
          'GY',
          'HK',
          'HM',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IM',
          'IN',
          'IO',
          'IQ',
          'IR',
          'IS',
          'IT',
          'JE',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KP',
          'KR',
          'KW',
          'KY',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'LY',
          'MA',
          'MC',
          'MD',
          'ME',
          'MF',
          'MG',
          'MH',
          'MK',
          'ML',
          'MM',
          'MN',
          'MO',
          'MP',
          'MQ',
          'MR',
          'MS',
          'MT',
          'MU',
          'MV',
          'MW',
          'MX',
          'MY',
          'MZ',
          'NA',
          'NC',
          'NE',
          'NF',
          'NG',
          'NI',
          'NL',
          'NO',
          'NP',
          'NR',
          'NU',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PF',
          'PG',
          'PH',
          'PK',
          'PL',
          'PM',
          'PN',
          'PR',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RE',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SD',
          'SE',
          'SG',
          'SH',
          'SI',
          'SJ',
          'SK',
          'SL',
          'SM',
          'SN',
          'SO',
          'SR',
          'SS',
          'ST',
          'SV',
          'SX',
          'SY',
          'SZ',
          'TC',
          'TD',
          'TF',
          'TG',
          'TH',
          'TJ',
          'TK',
          'TL',
          'TM',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'UM',
          'US',
          'UY',
          'UZ',
          'VA',
          'VC',
          'VE',
          'VG',
          'VI',
          'VN',
          'VU',
          'WF',
          'WS',
          'XK',
          'YE',
          'YT',
          'ZA',
          'ZM',
          'ZW',
        ])
        .optional(),
      country: z
        .enum([
          'AD',
          'AE',
          'AF',
          'AG',
          'AI',
          'AL',
          'AM',
          'AO',
          'AQ',
          'AR',
          'AS',
          'AT',
          'AU',
          'AW',
          'AX',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BF',
          'BG',
          'BH',
          'BI',
          'BJ',
          'BL',
          'BM',
          'BN',
          'BO',
          'BQ',
          'BR',
          'BS',
          'BT',
          'BV',
          'BW',
          'BY',
          'BZ',
          'CA',
          'CC',
          'CD',
          'CF',
          'CG',
          'CH',
          'CI',
          'CK',
          'CL',
          'CM',
          'CN',
          'CO',
          'CR',
          'CU',
          'CV',
          'CW',
          'CX',
          'CY',
          'CZ',
          'DE',
          'DJ',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'EH',
          'ER',
          'ES',
          'ET',
          'FI',
          'FJ',
          'FK',
          'FM',
          'FO',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GF',
          'GG',
          'GH',
          'GI',
          'GL',
          'GM',
          'GN',
          'GP',
          'GQ',
          'GR',
          'GS',
          'GT',
          'GU',
          'GW',
          'GY',
          'HK',
          'HM',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IM',
          'IN',
          'IO',
          'IQ',
          'IR',
          'IS',
          'IT',
          'JE',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KP',
          'KR',
          'KW',
          'KY',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'LY',
          'MA',
          'MC',
          'MD',
          'ME',
          'MF',
          'MG',
          'MH',
          'MK',
          'ML',
          'MM',
          'MN',
          'MO',
          'MP',
          'MQ',
          'MR',
          'MS',
          'MT',
          'MU',
          'MV',
          'MW',
          'MX',
          'MY',
          'MZ',
          'NA',
          'NC',
          'NE',
          'NF',
          'NG',
          'NI',
          'NL',
          'NO',
          'NP',
          'NR',
          'NU',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PF',
          'PG',
          'PH',
          'PK',
          'PL',
          'PM',
          'PN',
          'PR',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RE',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SD',
          'SE',
          'SG',
          'SH',
          'SI',
          'SJ',
          'SK',
          'SL',
          'SM',
          'SN',
          'SO',
          'SR',
          'SS',
          'ST',
          'SV',
          'SX',
          'SY',
          'SZ',
          'TC',
          'TD',
          'TF',
          'TG',
          'TH',
          'TJ',
          'TK',
          'TL',
          'TM',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'UM',
          'US',
          'UY',
          'UZ',
          'VA',
          'VC',
          'VE',
          'VG',
          'VI',
          'VN',
          'VU',
          'WF',
          'WS',
          'XK',
          'YE',
          'YT',
          'ZA',
          'ZM',
          'ZW',
        ])
        .optional(),
      addresses: z
        .array(
          z.object({
            country: z
              .enum([
                'AD',
                'AE',
                'AF',
                'AG',
                'AI',
                'AL',
                'AM',
                'AO',
                'AQ',
                'AR',
                'AS',
                'AT',
                'AU',
                'AW',
                'AX',
                'AZ',
                'BA',
                'BB',
                'BD',
                'BE',
                'BF',
                'BG',
                'BH',
                'BI',
                'BJ',
                'BL',
                'BM',
                'BN',
                'BO',
                'BQ',
                'BR',
                'BS',
                'BT',
                'BV',
                'BW',
                'BY',
                'BZ',
                'CA',
                'CC',
                'CD',
                'CF',
                'CG',
                'CH',
                'CI',
                'CK',
                'CL',
                'CM',
                'CN',
                'CO',
                'CR',
                'CU',
                'CV',
                'CW',
                'CX',
                'CY',
                'CZ',
                'DE',
                'DJ',
                'DK',
                'DM',
                'DO',
                'DZ',
                'EC',
                'EE',
                'EG',
                'EH',
                'ER',
                'ES',
                'ET',
                'FI',
                'FJ',
                'FK',
                'FM',
                'FO',
                'FR',
                'GA',
                'GB',
                'GD',
                'GE',
                'GF',
                'GG',
                'GH',
                'GI',
                'GL',
                'GM',
                'GN',
                'GP',
                'GQ',
                'GR',
                'GS',
                'GT',
                'GU',
                'GW',
                'GY',
                'HK',
                'HM',
                'HN',
                'HR',
                'HT',
                'HU',
                'ID',
                'IE',
                'IL',
                'IM',
                'IN',
                'IO',
                'IQ',
                'IR',
                'IS',
                'IT',
                'JE',
                'JM',
                'JO',
                'JP',
                'KE',
                'KG',
                'KH',
                'KI',
                'KM',
                'KN',
                'KP',
                'KR',
                'KW',
                'KY',
                'KZ',
                'LA',
                'LB',
                'LC',
                'LI',
                'LK',
                'LR',
                'LS',
                'LT',
                'LU',
                'LV',
                'LY',
                'MA',
                'MC',
                'MD',
                'ME',
                'MF',
                'MG',
                'MH',
                'MK',
                'ML',
                'MM',
                'MN',
                'MO',
                'MP',
                'MQ',
                'MR',
                'MS',
                'MT',
                'MU',
                'MV',
                'MW',
                'MX',
                'MY',
                'MZ',
                'NA',
                'NC',
                'NE',
                'NF',
                'NG',
                'NI',
                'NL',
                'NO',
                'NP',
                'NR',
                'NU',
                'NZ',
                'OM',
                'PA',
                'PE',
                'PF',
                'PG',
                'PH',
                'PK',
                'PL',
                'PM',
                'PN',
                'PR',
                'PS',
                'PT',
                'PW',
                'PY',
                'QA',
                'RE',
                'RO',
                'RS',
                'RU',
                'RW',
                'SA',
                'SB',
                'SC',
                'SD',
                'SE',
                'SG',
                'SH',
                'SI',
                'SJ',
                'SK',
                'SL',
                'SM',
                'SN',
                'SO',
                'SR',
                'SS',
                'ST',
                'SV',
                'SX',
                'SY',
                'SZ',
                'TC',
                'TD',
                'TF',
                'TG',
                'TH',
                'TJ',
                'TK',
                'TL',
                'TM',
                'TN',
                'TO',
                'TR',
                'TT',
                'TV',
                'TW',
                'TZ',
                'UA',
                'UG',
                'UM',
                'US',
                'UY',
                'UZ',
                'VA',
                'VC',
                'VE',
                'VG',
                'VI',
                'VN',
                'VU',
                'WF',
                'WS',
                'XK',
                'YE',
                'YT',
                'ZA',
                'ZM',
                'ZW',
              ])
              .optional(),
            postCode: z.string().optional(),
            town: z.string().optional(),
            street: z.string().optional(),
            subStreet: z.string().optional(),
            state: z.string().optional(),
            buildingName: z.string().optional(),
            flatNumber: z.string().optional(),
            buildingNumber: z.string().optional(),
            startDate: z.string().optional(),
            endDate: z.string().optional(),
          }),
        )
        .optional(),
    })
    .optional(),
  idDocExpiresAt: z.string().nullable(),
  kycStatus: z.enum(['GREEN', 'RED', 'RETRY', 'YELLOW']).nullable(),
});

export const verificationOnlyOrgCreatorCanStartKybErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(403),
  error: z.object({
    message: z.string(),
    code: z.enum(['VERIFICATION.ONLY_ORG_CREATOR_CAN_START_KYB']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const verificationIndividualKycNotApprovedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['VERIFICATION.INDIVIDUAL_KYC_NOT_APPROVED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const verificationOrganizationRelationshipMetadataInvalidErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['VERIFICATION.ORGANIZATION_RELATIONSHIP_METADATA_INVALID']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const getKybStatusResponseDtoOutput = z.object({
  createdAt: z.string(),
  organizationId: z.string(),
  email: z.string().optional(),
  type: z.enum(['individual', 'company']).optional(),
  info: z
    .object({
      legalName: z.string().optional(),
      country: z
        .enum([
          'AD',
          'AE',
          'AF',
          'AG',
          'AI',
          'AL',
          'AM',
          'AO',
          'AQ',
          'AR',
          'AS',
          'AT',
          'AU',
          'AW',
          'AX',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BF',
          'BG',
          'BH',
          'BI',
          'BJ',
          'BL',
          'BM',
          'BN',
          'BO',
          'BQ',
          'BR',
          'BS',
          'BT',
          'BV',
          'BW',
          'BY',
          'BZ',
          'CA',
          'CC',
          'CD',
          'CF',
          'CG',
          'CH',
          'CI',
          'CK',
          'CL',
          'CM',
          'CN',
          'CO',
          'CR',
          'CU',
          'CV',
          'CW',
          'CX',
          'CY',
          'CZ',
          'DE',
          'DJ',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'EH',
          'ER',
          'ES',
          'ET',
          'FI',
          'FJ',
          'FK',
          'FM',
          'FO',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GF',
          'GG',
          'GH',
          'GI',
          'GL',
          'GM',
          'GN',
          'GP',
          'GQ',
          'GR',
          'GS',
          'GT',
          'GU',
          'GW',
          'GY',
          'HK',
          'HM',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IM',
          'IN',
          'IO',
          'IQ',
          'IR',
          'IS',
          'IT',
          'JE',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KP',
          'KR',
          'KW',
          'KY',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'LY',
          'MA',
          'MC',
          'MD',
          'ME',
          'MF',
          'MG',
          'MH',
          'MK',
          'ML',
          'MM',
          'MN',
          'MO',
          'MP',
          'MQ',
          'MR',
          'MS',
          'MT',
          'MU',
          'MV',
          'MW',
          'MX',
          'MY',
          'MZ',
          'NA',
          'NC',
          'NE',
          'NF',
          'NG',
          'NI',
          'NL',
          'NO',
          'NP',
          'NR',
          'NU',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PF',
          'PG',
          'PH',
          'PK',
          'PL',
          'PM',
          'PN',
          'PR',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RE',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SD',
          'SE',
          'SG',
          'SH',
          'SI',
          'SJ',
          'SK',
          'SL',
          'SM',
          'SN',
          'SO',
          'SR',
          'SS',
          'ST',
          'SV',
          'SX',
          'SY',
          'SZ',
          'TC',
          'TD',
          'TF',
          'TG',
          'TH',
          'TJ',
          'TK',
          'TL',
          'TM',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'UM',
          'US',
          'UY',
          'UZ',
          'VA',
          'VC',
          'VE',
          'VG',
          'VI',
          'VN',
          'VU',
          'WF',
          'WS',
          'XK',
          'YE',
          'YT',
          'ZA',
          'ZM',
          'ZW',
        ])
        .optional(),
      addresses: z
        .array(
          z.object({
            country: z
              .enum([
                'AD',
                'AE',
                'AF',
                'AG',
                'AI',
                'AL',
                'AM',
                'AO',
                'AQ',
                'AR',
                'AS',
                'AT',
                'AU',
                'AW',
                'AX',
                'AZ',
                'BA',
                'BB',
                'BD',
                'BE',
                'BF',
                'BG',
                'BH',
                'BI',
                'BJ',
                'BL',
                'BM',
                'BN',
                'BO',
                'BQ',
                'BR',
                'BS',
                'BT',
                'BV',
                'BW',
                'BY',
                'BZ',
                'CA',
                'CC',
                'CD',
                'CF',
                'CG',
                'CH',
                'CI',
                'CK',
                'CL',
                'CM',
                'CN',
                'CO',
                'CR',
                'CU',
                'CV',
                'CW',
                'CX',
                'CY',
                'CZ',
                'DE',
                'DJ',
                'DK',
                'DM',
                'DO',
                'DZ',
                'EC',
                'EE',
                'EG',
                'EH',
                'ER',
                'ES',
                'ET',
                'FI',
                'FJ',
                'FK',
                'FM',
                'FO',
                'FR',
                'GA',
                'GB',
                'GD',
                'GE',
                'GF',
                'GG',
                'GH',
                'GI',
                'GL',
                'GM',
                'GN',
                'GP',
                'GQ',
                'GR',
                'GS',
                'GT',
                'GU',
                'GW',
                'GY',
                'HK',
                'HM',
                'HN',
                'HR',
                'HT',
                'HU',
                'ID',
                'IE',
                'IL',
                'IM',
                'IN',
                'IO',
                'IQ',
                'IR',
                'IS',
                'IT',
                'JE',
                'JM',
                'JO',
                'JP',
                'KE',
                'KG',
                'KH',
                'KI',
                'KM',
                'KN',
                'KP',
                'KR',
                'KW',
                'KY',
                'KZ',
                'LA',
                'LB',
                'LC',
                'LI',
                'LK',
                'LR',
                'LS',
                'LT',
                'LU',
                'LV',
                'LY',
                'MA',
                'MC',
                'MD',
                'ME',
                'MF',
                'MG',
                'MH',
                'MK',
                'ML',
                'MM',
                'MN',
                'MO',
                'MP',
                'MQ',
                'MR',
                'MS',
                'MT',
                'MU',
                'MV',
                'MW',
                'MX',
                'MY',
                'MZ',
                'NA',
                'NC',
                'NE',
                'NF',
                'NG',
                'NI',
                'NL',
                'NO',
                'NP',
                'NR',
                'NU',
                'NZ',
                'OM',
                'PA',
                'PE',
                'PF',
                'PG',
                'PH',
                'PK',
                'PL',
                'PM',
                'PN',
                'PR',
                'PS',
                'PT',
                'PW',
                'PY',
                'QA',
                'RE',
                'RO',
                'RS',
                'RU',
                'RW',
                'SA',
                'SB',
                'SC',
                'SD',
                'SE',
                'SG',
                'SH',
                'SI',
                'SJ',
                'SK',
                'SL',
                'SM',
                'SN',
                'SO',
                'SR',
                'SS',
                'ST',
                'SV',
                'SX',
                'SY',
                'SZ',
                'TC',
                'TD',
                'TF',
                'TG',
                'TH',
                'TJ',
                'TK',
                'TL',
                'TM',
                'TN',
                'TO',
                'TR',
                'TT',
                'TV',
                'TW',
                'TZ',
                'UA',
                'UG',
                'UM',
                'US',
                'UY',
                'UZ',
                'VA',
                'VC',
                'VE',
                'VG',
                'VI',
                'VN',
                'VU',
                'WF',
                'WS',
                'XK',
                'YE',
                'YT',
                'ZA',
                'ZM',
                'ZW',
              ])
              .optional(),
            postCode: z.string().optional(),
            town: z.string().optional(),
            street: z.string().optional(),
            subStreet: z.string().optional(),
            state: z.string().optional(),
            buildingName: z.string().optional(),
            flatNumber: z.string().optional(),
            buildingNumber: z.string().optional(),
            startDate: z.string().optional(),
            endDate: z.string().optional(),
          }),
        )
        .optional(),
      companyName: z.string().optional(),
      registrationCountry: z
        .enum([
          'AD',
          'AE',
          'AF',
          'AG',
          'AI',
          'AL',
          'AM',
          'AO',
          'AQ',
          'AR',
          'AS',
          'AT',
          'AU',
          'AW',
          'AX',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BF',
          'BG',
          'BH',
          'BI',
          'BJ',
          'BL',
          'BM',
          'BN',
          'BO',
          'BQ',
          'BR',
          'BS',
          'BT',
          'BV',
          'BW',
          'BY',
          'BZ',
          'CA',
          'CC',
          'CD',
          'CF',
          'CG',
          'CH',
          'CI',
          'CK',
          'CL',
          'CM',
          'CN',
          'CO',
          'CR',
          'CU',
          'CV',
          'CW',
          'CX',
          'CY',
          'CZ',
          'DE',
          'DJ',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'EH',
          'ER',
          'ES',
          'ET',
          'FI',
          'FJ',
          'FK',
          'FM',
          'FO',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GF',
          'GG',
          'GH',
          'GI',
          'GL',
          'GM',
          'GN',
          'GP',
          'GQ',
          'GR',
          'GS',
          'GT',
          'GU',
          'GW',
          'GY',
          'HK',
          'HM',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IM',
          'IN',
          'IO',
          'IQ',
          'IR',
          'IS',
          'IT',
          'JE',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KP',
          'KR',
          'KW',
          'KY',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'LY',
          'MA',
          'MC',
          'MD',
          'ME',
          'MF',
          'MG',
          'MH',
          'MK',
          'ML',
          'MM',
          'MN',
          'MO',
          'MP',
          'MQ',
          'MR',
          'MS',
          'MT',
          'MU',
          'MV',
          'MW',
          'MX',
          'MY',
          'MZ',
          'NA',
          'NC',
          'NE',
          'NF',
          'NG',
          'NI',
          'NL',
          'NO',
          'NP',
          'NR',
          'NU',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PF',
          'PG',
          'PH',
          'PK',
          'PL',
          'PM',
          'PN',
          'PR',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RE',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SD',
          'SE',
          'SG',
          'SH',
          'SI',
          'SJ',
          'SK',
          'SL',
          'SM',
          'SN',
          'SO',
          'SR',
          'SS',
          'ST',
          'SV',
          'SX',
          'SY',
          'SZ',
          'TC',
          'TD',
          'TF',
          'TG',
          'TH',
          'TJ',
          'TK',
          'TL',
          'TM',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'UM',
          'US',
          'UY',
          'UZ',
          'VA',
          'VC',
          'VE',
          'VG',
          'VI',
          'VN',
          'VU',
          'WF',
          'WS',
          'XK',
          'YE',
          'YT',
          'ZA',
          'ZM',
          'ZW',
        ])
        .optional(),
      registrationNumber: z.string().optional(),
      companyAddress: z
        .object({
          country: z
            .enum([
              'AD',
              'AE',
              'AF',
              'AG',
              'AI',
              'AL',
              'AM',
              'AO',
              'AQ',
              'AR',
              'AS',
              'AT',
              'AU',
              'AW',
              'AX',
              'AZ',
              'BA',
              'BB',
              'BD',
              'BE',
              'BF',
              'BG',
              'BH',
              'BI',
              'BJ',
              'BL',
              'BM',
              'BN',
              'BO',
              'BQ',
              'BR',
              'BS',
              'BT',
              'BV',
              'BW',
              'BY',
              'BZ',
              'CA',
              'CC',
              'CD',
              'CF',
              'CG',
              'CH',
              'CI',
              'CK',
              'CL',
              'CM',
              'CN',
              'CO',
              'CR',
              'CU',
              'CV',
              'CW',
              'CX',
              'CY',
              'CZ',
              'DE',
              'DJ',
              'DK',
              'DM',
              'DO',
              'DZ',
              'EC',
              'EE',
              'EG',
              'EH',
              'ER',
              'ES',
              'ET',
              'FI',
              'FJ',
              'FK',
              'FM',
              'FO',
              'FR',
              'GA',
              'GB',
              'GD',
              'GE',
              'GF',
              'GG',
              'GH',
              'GI',
              'GL',
              'GM',
              'GN',
              'GP',
              'GQ',
              'GR',
              'GS',
              'GT',
              'GU',
              'GW',
              'GY',
              'HK',
              'HM',
              'HN',
              'HR',
              'HT',
              'HU',
              'ID',
              'IE',
              'IL',
              'IM',
              'IN',
              'IO',
              'IQ',
              'IR',
              'IS',
              'IT',
              'JE',
              'JM',
              'JO',
              'JP',
              'KE',
              'KG',
              'KH',
              'KI',
              'KM',
              'KN',
              'KP',
              'KR',
              'KW',
              'KY',
              'KZ',
              'LA',
              'LB',
              'LC',
              'LI',
              'LK',
              'LR',
              'LS',
              'LT',
              'LU',
              'LV',
              'LY',
              'MA',
              'MC',
              'MD',
              'ME',
              'MF',
              'MG',
              'MH',
              'MK',
              'ML',
              'MM',
              'MN',
              'MO',
              'MP',
              'MQ',
              'MR',
              'MS',
              'MT',
              'MU',
              'MV',
              'MW',
              'MX',
              'MY',
              'MZ',
              'NA',
              'NC',
              'NE',
              'NF',
              'NG',
              'NI',
              'NL',
              'NO',
              'NP',
              'NR',
              'NU',
              'NZ',
              'OM',
              'PA',
              'PE',
              'PF',
              'PG',
              'PH',
              'PK',
              'PL',
              'PM',
              'PN',
              'PR',
              'PS',
              'PT',
              'PW',
              'PY',
              'QA',
              'RE',
              'RO',
              'RS',
              'RU',
              'RW',
              'SA',
              'SB',
              'SC',
              'SD',
              'SE',
              'SG',
              'SH',
              'SI',
              'SJ',
              'SK',
              'SL',
              'SM',
              'SN',
              'SO',
              'SR',
              'SS',
              'ST',
              'SV',
              'SX',
              'SY',
              'SZ',
              'TC',
              'TD',
              'TF',
              'TG',
              'TH',
              'TJ',
              'TK',
              'TL',
              'TM',
              'TN',
              'TO',
              'TR',
              'TT',
              'TV',
              'TW',
              'TZ',
              'UA',
              'UG',
              'UM',
              'US',
              'UY',
              'UZ',
              'VA',
              'VC',
              'VE',
              'VG',
              'VI',
              'VN',
              'VU',
              'WF',
              'WS',
              'XK',
              'YE',
              'YT',
              'ZA',
              'ZM',
              'ZW',
            ])
            .optional(),
          postCode: z.string().optional(),
          town: z.string().optional(),
          street: z.string().optional(),
          subStreet: z.string().optional(),
          state: z.string().optional(),
          buildingName: z.string().optional(),
          flatNumber: z.string().optional(),
          buildingNumber: z.string().optional(),
          startDate: z.string().optional(),
          endDate: z.string().optional(),
        })
        .optional(),
    })
    .optional(),
  kybStatus: z.enum(['GREEN', 'RED', 'RETRY', 'YELLOW']).nullable(),
});

export const sddCreditorIdAlreadySetErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['SDD.CREDITOR_ID_ALREADY_SET']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const sddCreditorIdRejectedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['SDD.CREDITOR_ID_REJECTED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const sddApplicantNotOnboardedErrorDto = z.object({
  isSuccess: z.literal(false),
  statusCode: z.literal(409),
  error: z.object({
    message: z.string(),
    code: z.enum(['SDD.APPLICANT_NOT_ONBOARDED']),
  }),
  details: z.unknown().optional(),
  trace: z.object({
    requestId: z.string().optional(),
    correlationId: z.string().optional(),
    causationId: z.string().optional(),
  }),
});

export const startSddCreditorCollectionResponseDtoOutput = z.object({
  data: z.object({
    url: z.string(),
  }),
});

export const decodeRequestDto = z.object({
  payloads: z.array(
    z.object({
      metadata: z.record(z.string(), z.string()).optional(),
      data: z.string().optional(),
    }),
  ),
});

export const decodeResponseDtoOutput = z.object({
  payloads: z.array(
    z.object({
      metadata: z.record(z.string(), z.string()).optional(),
      data: z.string().optional(),
    }),
  ),
});

/**
 * Upstream API connectivity status.
 */
export const getUpstreamHealthResponseDtoOutput = z.object({
  status: z.enum(['ok']),
  upstreams: z.record(z.string(), z.enum(['up', 'down'])),
});

/**
 * User created Webhook input data
 */
export const userCreatedRequestDto = z.object({
  id: z.string(),
  source: z.string(),
  specversion: z.string(),
  time: z.string(),
  a0tenant: z.string(),
  a0stream: z.string(),
  type: z.enum(['user.created']),
  data: z.object({
    object: z.object({
      created_at: z.iso
        .datetime()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
        ),
      email: z
        .email()
        .regex(
          /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/,
        ),
      email_verified: z.boolean(),
      identities: z.array(
        z.object({
          connection: z.string(),
          isSocial: z.boolean(),
          provider: z.string(),
          user_id: z.string(),
        }),
      ),
      name: z.string(),
      nickname: z.string(),
      picture: z.url(),
      updated_at: z.iso
        .datetime()
        .regex(
          /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
        ),
      user_id: z.string().min(1).max(255),
    }),
  }),
});

export const auth0WebhookRequestDto = z.object({
  id: z.string(),
  source: z.string(),
  specversion: z.string(),
  time: z.string(),
  a0tenant: z.string(),
  a0stream: z.string(),
  type: z.enum([
    'user.created',
    'user.updated',
    'user.deleted',
    'organization.created',
    'organization.updated',
    'organization.deleted',
    'organization.member.added',
    'organization.member.deleted',
    'organization.member.role.assigned',
    'organization.member.role.deleted',
    'organization.connection.added',
    'organization.connection.updated',
    'organization.connection.removed',
  ]),
  data: z.unknown(),
});

/**
 * Integrated Finance client created webhook request
 */
export const clientCreatedRequestDto = z.object({
  connect: z.record(z.string(), z.unknown()),
  metadata: z.record(z.string(), z.unknown()),
  data: z.object({
    client: z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      status: z.string(),
      profile: z.union([
        z.object({
          email: z
            .email()
            .regex(
              /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/,
            ),
          phone: z.string().optional(),
          identityType: z.enum(['individual']),
        }),
        z.object({
          phone: z.string().optional(),
          identityType: z.enum(['corporate']),
        }),
      ]),
      fullName: z.string(),
      identity: z.object({
        type: z.enum(['individual', 'corporate']),
        country: z.enum([
          'AD',
          'AE',
          'AF',
          'AG',
          'AI',
          'AL',
          'AM',
          'AO',
          'AQ',
          'AR',
          'AS',
          'AT',
          'AU',
          'AW',
          'AX',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BF',
          'BG',
          'BH',
          'BI',
          'BJ',
          'BL',
          'BM',
          'BN',
          'BO',
          'BQ',
          'BR',
          'BS',
          'BT',
          'BV',
          'BW',
          'BY',
          'BZ',
          'CA',
          'CC',
          'CD',
          'CF',
          'CG',
          'CH',
          'CI',
          'CK',
          'CL',
          'CM',
          'CN',
          'CO',
          'CR',
          'CU',
          'CV',
          'CW',
          'CX',
          'CY',
          'CZ',
          'DE',
          'DJ',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'EH',
          'ER',
          'ES',
          'ET',
          'FI',
          'FJ',
          'FK',
          'FM',
          'FO',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GF',
          'GG',
          'GH',
          'GI',
          'GL',
          'GM',
          'GN',
          'GP',
          'GQ',
          'GR',
          'GS',
          'GT',
          'GU',
          'GW',
          'GY',
          'HK',
          'HM',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IM',
          'IN',
          'IO',
          'IQ',
          'IR',
          'IS',
          'IT',
          'JE',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KP',
          'KR',
          'KW',
          'KY',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'LY',
          'MA',
          'MC',
          'MD',
          'ME',
          'MF',
          'MG',
          'MH',
          'MK',
          'ML',
          'MM',
          'MN',
          'MO',
          'MP',
          'MQ',
          'MR',
          'MS',
          'MT',
          'MU',
          'MV',
          'MW',
          'MX',
          'MY',
          'MZ',
          'NA',
          'NC',
          'NE',
          'NF',
          'NG',
          'NI',
          'NL',
          'NO',
          'NP',
          'NR',
          'NU',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PF',
          'PG',
          'PH',
          'PK',
          'PL',
          'PM',
          'PN',
          'PR',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RE',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SD',
          'SE',
          'SG',
          'SH',
          'SI',
          'SJ',
          'SK',
          'SL',
          'SM',
          'SN',
          'SO',
          'SR',
          'SS',
          'ST',
          'SV',
          'SX',
          'SY',
          'SZ',
          'TC',
          'TD',
          'TF',
          'TG',
          'TH',
          'TJ',
          'TK',
          'TL',
          'TM',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'UM',
          'US',
          'UY',
          'UZ',
          'VA',
          'VC',
          'VE',
          'VG',
          'VI',
          'VN',
          'VU',
          'WF',
          'WS',
          'XK',
          'YE',
          'YT',
          'ZA',
          'ZM',
          'ZW',
        ]),
        birthDate: z.string().optional(),
        givenName: z.string().optional(),
        familyName: z.string().optional(),
        identifications: z.array(
          z.object({
            type: z
              .enum([
                'registration-number',
                'passport',
                'identity-card',
                'driving-licence',
                'foreign-identity-card',
                'tax-number',
              ])
              .optional(),
            identificationNumber: z.string().optional(),
            issuingCountry: z
              .string()
              .length(2)
              .regex(/^[A-Z]{2}$/)
              .nullish(),
            issueDate: z.iso
              .date()
              .regex(
                /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
              )
              .nullish(),
            expirationDate: z.iso
              .date()
              .regex(
                /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
              )
              .nullish(),
          }),
        ),
      }),
      clientNumber: z.string(),
    }),
  }),
  webhook: z.object({
    type: z.enum(['created']),
    module: z.enum(['clients']),
  }),
});

/**
 * Integrated Finance account activated webhook request
 */
export const accountActivatedRequestDto = z.object({
  connect: z.record(z.string(), z.unknown()),
  metadata: z.record(z.string(), z.unknown()),
  data: z.object({
    account: z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      clientId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      status: z.enum(['pending', 'active', 'inactive', 'suspended', 'closed', 'declined']),
      country: z.enum([
        'AD',
        'AE',
        'AF',
        'AG',
        'AI',
        'AL',
        'AM',
        'AO',
        'AQ',
        'AR',
        'AS',
        'AT',
        'AU',
        'AW',
        'AX',
        'AZ',
        'BA',
        'BB',
        'BD',
        'BE',
        'BF',
        'BG',
        'BH',
        'BI',
        'BJ',
        'BL',
        'BM',
        'BN',
        'BO',
        'BQ',
        'BR',
        'BS',
        'BT',
        'BV',
        'BW',
        'BY',
        'BZ',
        'CA',
        'CC',
        'CD',
        'CF',
        'CG',
        'CH',
        'CI',
        'CK',
        'CL',
        'CM',
        'CN',
        'CO',
        'CR',
        'CU',
        'CV',
        'CW',
        'CX',
        'CY',
        'CZ',
        'DE',
        'DJ',
        'DK',
        'DM',
        'DO',
        'DZ',
        'EC',
        'EE',
        'EG',
        'EH',
        'ER',
        'ES',
        'ET',
        'FI',
        'FJ',
        'FK',
        'FM',
        'FO',
        'FR',
        'GA',
        'GB',
        'GD',
        'GE',
        'GF',
        'GG',
        'GH',
        'GI',
        'GL',
        'GM',
        'GN',
        'GP',
        'GQ',
        'GR',
        'GS',
        'GT',
        'GU',
        'GW',
        'GY',
        'HK',
        'HM',
        'HN',
        'HR',
        'HT',
        'HU',
        'ID',
        'IE',
        'IL',
        'IM',
        'IN',
        'IO',
        'IQ',
        'IR',
        'IS',
        'IT',
        'JE',
        'JM',
        'JO',
        'JP',
        'KE',
        'KG',
        'KH',
        'KI',
        'KM',
        'KN',
        'KP',
        'KR',
        'KW',
        'KY',
        'KZ',
        'LA',
        'LB',
        'LC',
        'LI',
        'LK',
        'LR',
        'LS',
        'LT',
        'LU',
        'LV',
        'LY',
        'MA',
        'MC',
        'MD',
        'ME',
        'MF',
        'MG',
        'MH',
        'MK',
        'ML',
        'MM',
        'MN',
        'MO',
        'MP',
        'MQ',
        'MR',
        'MS',
        'MT',
        'MU',
        'MV',
        'MW',
        'MX',
        'MY',
        'MZ',
        'NA',
        'NC',
        'NE',
        'NF',
        'NG',
        'NI',
        'NL',
        'NO',
        'NP',
        'NR',
        'NU',
        'NZ',
        'OM',
        'PA',
        'PE',
        'PF',
        'PG',
        'PH',
        'PK',
        'PL',
        'PM',
        'PN',
        'PR',
        'PS',
        'PT',
        'PW',
        'PY',
        'QA',
        'RE',
        'RO',
        'RS',
        'RU',
        'RW',
        'SA',
        'SB',
        'SC',
        'SD',
        'SE',
        'SG',
        'SH',
        'SI',
        'SJ',
        'SK',
        'SL',
        'SM',
        'SN',
        'SO',
        'SR',
        'SS',
        'ST',
        'SV',
        'SX',
        'SY',
        'SZ',
        'TC',
        'TD',
        'TF',
        'TG',
        'TH',
        'TJ',
        'TK',
        'TL',
        'TM',
        'TN',
        'TO',
        'TR',
        'TT',
        'TV',
        'TW',
        'TZ',
        'UA',
        'UG',
        'UM',
        'US',
        'UY',
        'UZ',
        'VA',
        'VC',
        'VE',
        'VG',
        'VI',
        'VN',
        'VU',
        'WF',
        'WS',
        'XK',
        'YE',
        'YT',
        'ZA',
        'ZM',
        'ZW',
      ]),
      currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
      alias: z.string().optional(),
      routingCodes: z.record(z.string(), z.unknown()).optional(),
      iban: z.string().nullish(),
      accountNumber: z.string().nullish(),
      ledgerNumber: z.string(),
      availableBalance: z.number(),
      serviceProvider: z.string().nullish(),
      accountHolderName: z.string(),
      accountHolderIdentityType: z.enum(['individual', 'corporate']),
      connection: z
        .object({
          id: z.string().nullish(),
          method: z.enum(['built-in', 'plug-in']).optional(),
          serviceProvider: z.string().nullish(),
          reference: z.string().nullish(),
          state: z.string().optional(),
          status: z.string().nullish(),
          error: z
            .object({
              category: z.string().optional(),
              origin: z.string().optional(),
              code: z.string().optional(),
              message: z.string().optional(),
              attributes: z.record(z.string(), z.unknown()).optional(),
            })
            .nullish(),
        })
        .optional(),
    }),
  }),
  webhook: z.object({
    type: z.enum(['account-activated']),
    module: z.enum(['accounts']),
  }),
});

/**
 * Integrated Finance account inactivated webhook request
 */
export const accountInactivatedRequestDto = z.object({
  connect: z.record(z.string(), z.unknown()),
  metadata: z.record(z.string(), z.unknown()),
  data: z.object({
    account: z.object({
      id: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      clientId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      status: z.enum(['pending', 'active', 'inactive', 'suspended', 'closed', 'declined']),
      country: z.enum([
        'AD',
        'AE',
        'AF',
        'AG',
        'AI',
        'AL',
        'AM',
        'AO',
        'AQ',
        'AR',
        'AS',
        'AT',
        'AU',
        'AW',
        'AX',
        'AZ',
        'BA',
        'BB',
        'BD',
        'BE',
        'BF',
        'BG',
        'BH',
        'BI',
        'BJ',
        'BL',
        'BM',
        'BN',
        'BO',
        'BQ',
        'BR',
        'BS',
        'BT',
        'BV',
        'BW',
        'BY',
        'BZ',
        'CA',
        'CC',
        'CD',
        'CF',
        'CG',
        'CH',
        'CI',
        'CK',
        'CL',
        'CM',
        'CN',
        'CO',
        'CR',
        'CU',
        'CV',
        'CW',
        'CX',
        'CY',
        'CZ',
        'DE',
        'DJ',
        'DK',
        'DM',
        'DO',
        'DZ',
        'EC',
        'EE',
        'EG',
        'EH',
        'ER',
        'ES',
        'ET',
        'FI',
        'FJ',
        'FK',
        'FM',
        'FO',
        'FR',
        'GA',
        'GB',
        'GD',
        'GE',
        'GF',
        'GG',
        'GH',
        'GI',
        'GL',
        'GM',
        'GN',
        'GP',
        'GQ',
        'GR',
        'GS',
        'GT',
        'GU',
        'GW',
        'GY',
        'HK',
        'HM',
        'HN',
        'HR',
        'HT',
        'HU',
        'ID',
        'IE',
        'IL',
        'IM',
        'IN',
        'IO',
        'IQ',
        'IR',
        'IS',
        'IT',
        'JE',
        'JM',
        'JO',
        'JP',
        'KE',
        'KG',
        'KH',
        'KI',
        'KM',
        'KN',
        'KP',
        'KR',
        'KW',
        'KY',
        'KZ',
        'LA',
        'LB',
        'LC',
        'LI',
        'LK',
        'LR',
        'LS',
        'LT',
        'LU',
        'LV',
        'LY',
        'MA',
        'MC',
        'MD',
        'ME',
        'MF',
        'MG',
        'MH',
        'MK',
        'ML',
        'MM',
        'MN',
        'MO',
        'MP',
        'MQ',
        'MR',
        'MS',
        'MT',
        'MU',
        'MV',
        'MW',
        'MX',
        'MY',
        'MZ',
        'NA',
        'NC',
        'NE',
        'NF',
        'NG',
        'NI',
        'NL',
        'NO',
        'NP',
        'NR',
        'NU',
        'NZ',
        'OM',
        'PA',
        'PE',
        'PF',
        'PG',
        'PH',
        'PK',
        'PL',
        'PM',
        'PN',
        'PR',
        'PS',
        'PT',
        'PW',
        'PY',
        'QA',
        'RE',
        'RO',
        'RS',
        'RU',
        'RW',
        'SA',
        'SB',
        'SC',
        'SD',
        'SE',
        'SG',
        'SH',
        'SI',
        'SJ',
        'SK',
        'SL',
        'SM',
        'SN',
        'SO',
        'SR',
        'SS',
        'ST',
        'SV',
        'SX',
        'SY',
        'SZ',
        'TC',
        'TD',
        'TF',
        'TG',
        'TH',
        'TJ',
        'TK',
        'TL',
        'TM',
        'TN',
        'TO',
        'TR',
        'TT',
        'TV',
        'TW',
        'TZ',
        'UA',
        'UG',
        'UM',
        'US',
        'UY',
        'UZ',
        'VA',
        'VC',
        'VE',
        'VG',
        'VI',
        'VN',
        'VU',
        'WF',
        'WS',
        'XK',
        'YE',
        'YT',
        'ZA',
        'ZM',
        'ZW',
      ]),
      currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
      alias: z.string().optional(),
      routingCodes: z.record(z.string(), z.unknown()).optional(),
      iban: z.string().nullish(),
      accountNumber: z.string().nullish(),
      ledgerNumber: z.string(),
      availableBalance: z.number(),
      serviceProvider: z.string().nullish(),
      accountHolderName: z.string(),
      accountHolderIdentityType: z.enum(['individual', 'corporate']),
      connection: z
        .object({
          id: z.string().nullish(),
          method: z.enum(['built-in', 'plug-in']).optional(),
          serviceProvider: z.string().nullish(),
          reference: z.string().nullish(),
          state: z.string().optional(),
          status: z.string().nullish(),
          error: z
            .object({
              category: z.string().optional(),
              origin: z.string().optional(),
              code: z.string().optional(),
              message: z.string().optional(),
              attributes: z.record(z.string(), z.unknown()).optional(),
            })
            .nullish(),
        })
        .optional(),
    }),
  }),
  webhook: z.object({
    type: z.enum(['account-inactivated']),
    module: z.enum(['accounts']),
  }),
});

export const ifWebhookRequestDto = z.object({
  data: z.unknown(),
  connect: z.record(z.string(), z.unknown()),
  metadata: z.record(z.string(), z.unknown()),
  webhook: z.object({
    type: z.enum([
      'created',
      'connection-created',
      'account-activated',
      'account-inactivated',
      'account-suspended',
      'account-closed',
      'account-declined',
      'account-information-updated',
      'connection-creation-instructed',
      'connection-creation-failed',
      'connection-update-instructed',
      'connection-updated',
      'connection-update-failed',
      'incoming-transfer-completed',
      'incoming-transfer-pending',
      'incoming-transfer-compliance-in-review',
      'incoming-transfer-failed',
      'incoming-transfer-updated',
      'outgoing-transfer-completed',
      'outgoing-transfer-cancelled',
      'outgoing-transfer-failed',
      'outgoing-transfer-returned',
      'outgoing-transfer-created',
      'outgoing-transfer-compliance-in-review',
      'outgoing-transfer-processing',
      'outgoing-transfer-released',
      'exchange-completed',
      'exchange-failed',
      'exchange-cancelled',
      'bank-account-migrated',
      'transaction-account-created',
      'transaction-account-activated',
      'transaction-account-inactivated',
      'card-transaction-created',
      'card-transaction-settled',
      'card-transaction-reversed',
      'card-transaction-authorisation-updated',
      'card-transaction-declined',
      'generic-transaction-created',
      'card-instructed',
      'card-activated',
      'card-inactivated',
      'card-suspended',
      'card-declined',
      'card-terminated',
      'token-activation-request-accepted',
      'token-activation-request-declined',
      'token-activation-code-created',
      'token-activation-request-completed',
      'card-transaction-authentication-created',
      'card-transaction-authentication-approved',
      'card-transaction-authentication-rejected',
      'card-transaction-authentication-cancelled',
    ]),
    module: z.enum([
      'clients',
      'accounts',
      'incoming-transfers',
      'exchange-transactions',
      'outgoing-transfers',
      'bank-accounts',
      'transaction-accounts',
      'card-transactions',
      'generic-transactions',
      'cards',
      'card-transaction-authentications',
    ]),
  }),
});

export const augmentedZodDtoOutput = z.string();

export const getHealthResponseDtoOutput = z.object({
  status: z.string(),
  info: z
    .object({
      database: z
        .object({
          status: z.string(),
        })
        .optional(),
      redis: z
        .object({
          status: z.string(),
        })
        .optional(),
      uptime: z
        .object({
          status: z.string(),
        })
        .optional(),
    })
    .optional(),
  error: z
    .object({
      database: z.unknown().optional(),
      redis: z.unknown().optional(),
      uptime: z.unknown().optional(),
    })
    .optional(),
  details: z
    .object({
      database: z
        .object({
          status: z.string(),
        })
        .optional(),
      redis: z
        .object({
          status: z.string(),
        })
        .optional(),
      uptime: z
        .object({
          status: z.string(),
        })
        .optional(),
    })
    .optional(),
});

export const tooManyRequestsErrorResponse = z.object({
  isSuccess: z.boolean().optional(),
  statusCode: z.int().optional(),
  error: z
    .object({
      message: z.string().optional(),
      code: z.string().optional(),
    })
    .optional(),
  trace: z.record(z.string(), z.unknown()).optional(),
});

/**
 * Keys used in WebSocket client_data_updated (stale_data_update) events to tell the frontend which data to refetch.
 */
export const frontendDataUpdateKeys = z.enum([
  'KYC_STATUS',
  'KYB_STATUS',
  'AUTH_JWT',
  'CHALLENGE_CONSUMED',
  'ACCOUNTS',
  'INCOMING_TRANSFER',
  'EXCHANGE',
  'OUTGOING_TRANSFERS',
  'GENERIC_TRANSACTION',
  'PAYMENT_BATCHES',
  'ORGANIZATION_MEMBERS',
  'REPORTS',
  'SDD_CREDITOR_ID_STATUS',
]);

export const listAccountStatementsResponseDtoWritable = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
});

export const createAccountResponseDtoOutputWritable = z.object({
  data: z.object({
    account: z.object({
      clientId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        ),
      status: z
        .enum(['pending', 'active', 'inactive', 'suspended', 'closed', 'declined'])
        .optional(),
      currency: z.string().length(3),
      alias: z.string().max(30).optional(),
      accountHolderName: z.string().optional(),
      accountHolderIdentityType: z.enum(['corporate', 'individual']),
      attributes: z.record(z.string(), z.unknown()).optional(),
      createdAt: z.string().nullable(),
    }),
  }),
});

export const listAccountsResponseDtoOutputWritable = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
});

export const listAccountStatementsResponseDtoOutputWritable = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
});

export const updateAccountResponseDtoOutputWritable = z.object({
  data: z.object({
    account: z.object({
      status: z
        .enum(['pending', 'active', 'inactive', 'suspended', 'closed', 'declined'])
        .optional(),
      alias: z.string().max(30).optional(),
      routingCodes: z.record(z.string(), z.unknown()).optional(),
      iban: z
        .string()
        .min(15)
        .max(31)
        .regex(
          /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{4}([a-zA-Z0-9]?){3,19}$|^[A-Z]{2}\d{5}[0-9A-Z]{13}$/,
        )
        .nullish(),
      accountNumber: z
        .string()
        .min(8)
        .max(20)
        .regex(/^[0-9]{8,20}$/)
        .nullish(),
      accountHolderIdentityType: z.enum(['corporate', 'individual']).optional(),
      attributes: z.record(z.string(), z.unknown()).optional(),
      createdAt: z.string().nullable(),
    }),
  }),
});

export const listBeneficiariesResponseDtoOutputWritable = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
});

export const listBeneficiaryBankAccountsResponseDtoOutputWritable = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
});

export const createBeneficiaryBankAccountResponseDtoOutputWritable = z.object({
  data: z.object({
    bankAccount: z.object({
      routingCodes: z.record(z.string(), z.unknown()).optional(),
      iban: z.string().optional(),
      currency: z.string(),
      country: z.string(),
      beneficiaryId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      accountHolderType: z.enum(['corporate', 'individual']).optional(),
      paymentRail: z.enum(['sepa', 'sepa-instant', 'swift']),
    }),
  }),
});

export const updateBeneficiaryBankAccountResponseDtoOutputWritable = z.object({
  data: z.object({
    bankAccount: z.object({
      routingCodes: z.record(z.string(), z.unknown()).optional(),
      iban: z.string().optional(),
      currency: z.string(),
      country: z.string(),
      beneficiaryId: z
        .uuid()
        .regex(
          /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
        )
        .optional(),
      accountHolderType: z.enum(['corporate', 'individual']).optional(),
      paymentRail: z.enum(['sepa', 'sepa-instant', 'swift']),
    }),
  }),
});

export const listClientRelationsResponseDtoOutputWritable = z.object({
  total: z.int().gte(0).lte(9007199254740991).optional(),
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
});

export const listGenericTransactionsResponseDtoOutputWritable = z.object({
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
});

export const listIncomingTransfersResponseDtoOutputWritable = z.object({
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
});

export const getOutgoingTransferResponseDtoWritable = z.object({
  data: z.object({
    amount: z.number().optional(),
    currency: z.string().length(3).optional(),
    status: z
      .enum(['pending', 'on-hold', 'processing', 'released', 'completed', 'cancelled', 'failed'])
      .nullish(),
    transferDate: z.iso
      .date()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
      )
      .optional(),
    beneficiary: z
      .object({
        fullName: z.string().optional(),
        identity: z
          .object({
            type: z.enum(['individual', 'corporate']),
            givenName: z.string().optional(),
            familyName: z.string().optional(),
            legalName: z.string().optional(),
          })
          .optional(),
        address: z
          .object({
            country: z
              .string()
              .length(2)
              .regex(/^[A-Z]{2}$/),
            region: z.string().optional(),
            postalCode: z.string().optional(),
            city: z.string(),
            street: z.string(),
            houseNumber: z.string().optional(),
            refinement: z.string().optional(),
          })
          .nullish(),
        account: z
          .object({
            accountHolderName: z.string().nullish(),
            bankName: z.string().nullish(),
            country: z.string().nullish(),
            currency: z.string().optional(),
            routingCodes: z.record(z.string(), z.unknown()).nullish(),
            accountNumber: z.string().nullish(),
            iban: z.string().nullish(),
            ledgerNumber: z.string().nullish(),
            alias: z.string().nullish(),
          })
          .optional(),
      })
      .optional(),
    description: z.string().nullish(),
    source: z
      .object({
        type: z.enum(['client-account', 'transaction-account']),
        accountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
      })
      .optional(),
    destination: z
      .object({
        type: z.enum(['client-account', 'transaction-account', 'beneficiary-bank-account']),
        accountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        beneficiaryBankAccountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        beneficiaryId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
      })
      .optional(),
    transferReasonId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      )
      .nullish(),
    transferCustomReason: z.string().nullish(),
    scheme: z
      .enum([
        'swift',
        'local',
        'sepa',
        'sepa-instant',
        'sepa-target-2',
        'sepa-target-2-pacs009',
        'chaps',
        'bacs',
        'faster-payments',
        'faster-payments-poo',
        'ach',
        'wire',
        'eft',
      ])
      .nullish(),
    scope: z.enum(['internal', 'external']).optional(),
    initiatedBy: z
      .object({
        userId: z.string(),
        firstName: z.string().nullable(),
        lastName: z.string().nullable(),
      })
      .nullable(),
  }),
});

export const listOutgoingTransfersResponseDtoOutputWritable = z.object({
  offset: z.int().gte(0).lte(9007199254740991),
  limit: z.int().lte(9007199254740991),
});

export const getOutgoingTransferDateMetadataResponseDtoOutputWritable = z.object({
  data: z.record(z.string(), z.never()),
});

export const getOutgoingTransferResponseDtoOutputWritable = z.object({
  data: z.object({
    amount: z.number().optional(),
    currency: z.string().length(3).optional(),
    status: z
      .enum(['pending', 'on-hold', 'processing', 'released', 'completed', 'cancelled', 'failed'])
      .nullish(),
    transferDate: z.iso
      .date()
      .regex(
        /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
      )
      .optional(),
    beneficiary: z
      .object({
        fullName: z.string().optional(),
        identity: z
          .object({
            type: z.enum(['individual', 'corporate']),
            givenName: z.string().optional(),
            familyName: z.string().optional(),
            legalName: z.string().optional(),
          })
          .optional(),
        address: z
          .object({
            country: z
              .string()
              .length(2)
              .regex(/^[A-Z]{2}$/),
            region: z.string().optional(),
            postalCode: z.string().optional(),
            city: z.string(),
            street: z.string(),
            houseNumber: z.string().optional(),
            refinement: z.string().optional(),
          })
          .nullish(),
        account: z
          .object({
            accountHolderName: z.string().nullish(),
            bankName: z.string().nullish(),
            country: z.string().nullish(),
            currency: z.string().optional(),
            routingCodes: z.record(z.string(), z.unknown()).nullish(),
            accountNumber: z.string().nullish(),
            iban: z.string().nullish(),
            ledgerNumber: z.string().nullish(),
            alias: z.string().nullish(),
          })
          .optional(),
      })
      .optional(),
    description: z.string().nullish(),
    source: z
      .object({
        type: z.enum(['client-account', 'transaction-account']),
        accountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          ),
      })
      .optional(),
    destination: z
      .object({
        type: z.enum(['client-account', 'transaction-account', 'beneficiary-bank-account']),
        accountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        beneficiaryBankAccountId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
        beneficiaryId: z
          .uuid()
          .regex(
            /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
          )
          .optional(),
      })
      .optional(),
    transferReasonId: z
      .uuid()
      .regex(
        /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
      )
      .nullish(),
    transferCustomReason: z.string().nullish(),
    scheme: z
      .enum([
        'swift',
        'local',
        'sepa',
        'sepa-instant',
        'sepa-target-2',
        'sepa-target-2-pacs009',
        'chaps',
        'bacs',
        'faster-payments',
        'faster-payments-poo',
        'ach',
        'wire',
        'eft',
      ])
      .nullish(),
    scope: z.enum(['internal', 'external']).optional(),
    initiatedBy: z
      .object({
        userId: z.string(),
        firstName: z.string().nullable(),
        lastName: z.string().nullable(),
      })
      .nullable(),
  }),
});

export const getUserResponseDtoOutputWritable = z.object({
  email: z.string(),
  givenName: z.string().optional(),
  familyName: z.string().optional(),
  category: z.enum(['external']),
  type: z.enum(['human']),
  profile: z
    .object({
      phone: z.string().optional(),
      residentialAddress: z
        .object({
          country: z
            .string()
            .length(2)
            .regex(/^[A-Z]{2}$/),
          region: z.string().optional(),
          postalCode: z.string().optional(),
          city: z.string(),
          street: z.string(),
          houseNumber: z.string().optional(),
          refinement: z.string().optional(),
        })
        .optional(),
    })
    .optional(),
  status: z.enum(['active', 'inactive']).optional(),
});

export const zListAccountsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zListAccountsQuery = z.object({
  offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
  limit: z.int().lte(100).optional().default(20),
});

/**
 * List of accounts successfully retrieved
 */
export const listAccountsResponse = listAccountsResponseDtoOutput;

export const zCreateAccountBody = createAccountRequestDto;

export const zCreateAccountHeaders = z.object({
  'X-Id-Token': z.string(),
  'idempotency-key': z.string(),
});

/**
 * Account successfully created
 */
export const createAccountResponse = createAccountResponseDtoOutput;

export const zGetAccountStatementsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetAccountStatementsPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

export const zGetAccountStatementsQuery = z.object({
  offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
  limit: z.int().lte(100).optional().default(20),
  transactionNumber: z
    .string()
    .regex(/^[0-9]{8}-[A-Z0-9]+$/)
    .optional(),
});

/**
 * Account statements list
 */
export const getAccountStatementsResponse = listAccountStatementsResponseDtoOutput;

export const zGetAccountDepositInformationHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetAccountDepositInformationPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Per-scheme account deposit information
 */
export const getAccountDepositInformationResponse = getAccountDepositInformationResponseDtoOutput;

export const zExportAccountStatementBody = generateStatementRequestDto;

export const zExportAccountStatementHeaders = z.object({
  'X-Id-Token': z.string(),
  accept: z.enum(['application/pdf']),
});

export const zExportAccountStatementPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Account statement PDF successfully generated
 */
export const exportAccountStatementResponse = z.string();

export const zSetAccountAliasBody = setAccountAliasRequestDto;

export const zSetAccountAliasHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zSetAccountAliasPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Account alias successfully updated
 */
export const setAccountAliasResponse = updateAccountResponseDtoOutput;

export const zSetAccountStatusBody = setAccountStatusRequestDto;

export const zSetAccountStatusHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zSetAccountStatusPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Account status successfully updated
 */
export const setAccountStatusResponse = updateAccountResponseDtoOutput;

export const zListBeneficiariesHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zListBeneficiariesQuery = z.object({
  offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
  limit: z.int().lte(100).optional().default(20),
  title: z.string().optional(),
});

export const listBeneficiariesResponse = listBeneficiariesResponseDtoOutput;

export const zCreateIndividualBeneficiaryBody = createIndividualBeneficiaryRequestDto;

export const zCreateIndividualBeneficiaryHeaders = z.object({
  'X-Id-Token': z.string(),
  'idempotency-key': z.string(),
});

export const createIndividualBeneficiaryResponse = createBeneficiaryResponseDtoOutput;

export const zCreateCorporateBeneficiaryBody = createCorporateBeneficiaryRequestDto;

export const zCreateCorporateBeneficiaryHeaders = z.object({
  'X-Id-Token': z.string(),
  'idempotency-key': z.string(),
});

export const createCorporateBeneficiaryResponse = createBeneficiaryResponseDtoOutput;

export const zVerifyBeneficiaryDataBody = verifyBeneficiaryDataRequestDto;

export const zVerifyBeneficiaryDataHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const verifyBeneficiaryDataResponse = verifyBeneficiaryDataResponseDtoOutput;

export const zGetBeneficiaryBankAccountRequirementsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetBeneficiaryBankAccountRequirementsQuery = z.object({
  currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']),
  country: z.enum([
    'AD',
    'AE',
    'AF',
    'AG',
    'AI',
    'AL',
    'AM',
    'AO',
    'AQ',
    'AR',
    'AS',
    'AT',
    'AU',
    'AW',
    'AX',
    'AZ',
    'BA',
    'BB',
    'BD',
    'BE',
    'BF',
    'BG',
    'BH',
    'BI',
    'BJ',
    'BL',
    'BM',
    'BN',
    'BO',
    'BQ',
    'BR',
    'BS',
    'BT',
    'BV',
    'BW',
    'BY',
    'BZ',
    'CA',
    'CC',
    'CD',
    'CF',
    'CG',
    'CH',
    'CI',
    'CK',
    'CL',
    'CM',
    'CN',
    'CO',
    'CR',
    'CU',
    'CV',
    'CW',
    'CX',
    'CY',
    'CZ',
    'DE',
    'DJ',
    'DK',
    'DM',
    'DO',
    'DZ',
    'EC',
    'EE',
    'EG',
    'EH',
    'ER',
    'ES',
    'ET',
    'FI',
    'FJ',
    'FK',
    'FM',
    'FO',
    'FR',
    'GA',
    'GB',
    'GD',
    'GE',
    'GF',
    'GG',
    'GH',
    'GI',
    'GL',
    'GM',
    'GN',
    'GP',
    'GQ',
    'GR',
    'GS',
    'GT',
    'GU',
    'GW',
    'GY',
    'HK',
    'HM',
    'HN',
    'HR',
    'HT',
    'HU',
    'ID',
    'IE',
    'IL',
    'IM',
    'IN',
    'IO',
    'IQ',
    'IR',
    'IS',
    'IT',
    'JE',
    'JM',
    'JO',
    'JP',
    'KE',
    'KG',
    'KH',
    'KI',
    'KM',
    'KN',
    'KP',
    'KR',
    'KW',
    'KY',
    'KZ',
    'LA',
    'LB',
    'LC',
    'LI',
    'LK',
    'LR',
    'LS',
    'LT',
    'LU',
    'LV',
    'LY',
    'MA',
    'MC',
    'MD',
    'ME',
    'MF',
    'MG',
    'MH',
    'MK',
    'ML',
    'MM',
    'MN',
    'MO',
    'MP',
    'MQ',
    'MR',
    'MS',
    'MT',
    'MU',
    'MV',
    'MW',
    'MX',
    'MY',
    'MZ',
    'NA',
    'NC',
    'NE',
    'NF',
    'NG',
    'NI',
    'NL',
    'NO',
    'NP',
    'NR',
    'NU',
    'NZ',
    'OM',
    'PA',
    'PE',
    'PF',
    'PG',
    'PH',
    'PK',
    'PL',
    'PM',
    'PN',
    'PR',
    'PS',
    'PT',
    'PW',
    'PY',
    'QA',
    'RE',
    'RO',
    'RS',
    'RU',
    'RW',
    'SA',
    'SB',
    'SC',
    'SD',
    'SE',
    'SG',
    'SH',
    'SI',
    'SJ',
    'SK',
    'SL',
    'SM',
    'SN',
    'SO',
    'SR',
    'SS',
    'ST',
    'SV',
    'SX',
    'SY',
    'SZ',
    'TC',
    'TD',
    'TF',
    'TG',
    'TH',
    'TJ',
    'TK',
    'TL',
    'TM',
    'TN',
    'TO',
    'TR',
    'TT',
    'TV',
    'TW',
    'TZ',
    'UA',
    'UG',
    'UM',
    'US',
    'UY',
    'UZ',
    'VA',
    'VC',
    'VE',
    'VG',
    'VI',
    'VN',
    'VU',
    'WF',
    'WS',
    'XK',
    'YE',
    'YT',
    'ZA',
    'ZM',
    'ZW',
  ]),
});

export const getBeneficiaryBankAccountRequirementsResponse =
  getBeneficiaryBankAccountRequirementsResponseDtoOutput;

export const zListBeneficiaryBankAccountsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zListBeneficiaryBankAccountsPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

export const zListBeneficiaryBankAccountsQuery = z.object({
  offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
  limit: z.int().lte(100).optional().default(20),
  country: z
    .enum([
      'AD',
      'AE',
      'AF',
      'AG',
      'AI',
      'AL',
      'AM',
      'AO',
      'AQ',
      'AR',
      'AS',
      'AT',
      'AU',
      'AW',
      'AX',
      'AZ',
      'BA',
      'BB',
      'BD',
      'BE',
      'BF',
      'BG',
      'BH',
      'BI',
      'BJ',
      'BL',
      'BM',
      'BN',
      'BO',
      'BQ',
      'BR',
      'BS',
      'BT',
      'BV',
      'BW',
      'BY',
      'BZ',
      'CA',
      'CC',
      'CD',
      'CF',
      'CG',
      'CH',
      'CI',
      'CK',
      'CL',
      'CM',
      'CN',
      'CO',
      'CR',
      'CU',
      'CV',
      'CW',
      'CX',
      'CY',
      'CZ',
      'DE',
      'DJ',
      'DK',
      'DM',
      'DO',
      'DZ',
      'EC',
      'EE',
      'EG',
      'EH',
      'ER',
      'ES',
      'ET',
      'FI',
      'FJ',
      'FK',
      'FM',
      'FO',
      'FR',
      'GA',
      'GB',
      'GD',
      'GE',
      'GF',
      'GG',
      'GH',
      'GI',
      'GL',
      'GM',
      'GN',
      'GP',
      'GQ',
      'GR',
      'GS',
      'GT',
      'GU',
      'GW',
      'GY',
      'HK',
      'HM',
      'HN',
      'HR',
      'HT',
      'HU',
      'ID',
      'IE',
      'IL',
      'IM',
      'IN',
      'IO',
      'IQ',
      'IR',
      'IS',
      'IT',
      'JE',
      'JM',
      'JO',
      'JP',
      'KE',
      'KG',
      'KH',
      'KI',
      'KM',
      'KN',
      'KP',
      'KR',
      'KW',
      'KY',
      'KZ',
      'LA',
      'LB',
      'LC',
      'LI',
      'LK',
      'LR',
      'LS',
      'LT',
      'LU',
      'LV',
      'LY',
      'MA',
      'MC',
      'MD',
      'ME',
      'MF',
      'MG',
      'MH',
      'MK',
      'ML',
      'MM',
      'MN',
      'MO',
      'MP',
      'MQ',
      'MR',
      'MS',
      'MT',
      'MU',
      'MV',
      'MW',
      'MX',
      'MY',
      'MZ',
      'NA',
      'NC',
      'NE',
      'NF',
      'NG',
      'NI',
      'NL',
      'NO',
      'NP',
      'NR',
      'NU',
      'NZ',
      'OM',
      'PA',
      'PE',
      'PF',
      'PG',
      'PH',
      'PK',
      'PL',
      'PM',
      'PN',
      'PR',
      'PS',
      'PT',
      'PW',
      'PY',
      'QA',
      'RE',
      'RO',
      'RS',
      'RU',
      'RW',
      'SA',
      'SB',
      'SC',
      'SD',
      'SE',
      'SG',
      'SH',
      'SI',
      'SJ',
      'SK',
      'SL',
      'SM',
      'SN',
      'SO',
      'SR',
      'SS',
      'ST',
      'SV',
      'SX',
      'SY',
      'SZ',
      'TC',
      'TD',
      'TF',
      'TG',
      'TH',
      'TJ',
      'TK',
      'TL',
      'TM',
      'TN',
      'TO',
      'TR',
      'TT',
      'TV',
      'TW',
      'TZ',
      'UA',
      'UG',
      'UM',
      'US',
      'UY',
      'UZ',
      'VA',
      'VC',
      'VE',
      'VG',
      'VI',
      'VN',
      'VU',
      'WF',
      'WS',
      'XK',
      'YE',
      'YT',
      'ZA',
      'ZM',
      'ZW',
    ])
    .optional(),
  currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']).optional(),
});

export const listBeneficiaryBankAccountsResponse = listBeneficiaryBankAccountsResponseDtoOutput;

export const zCreateBeneficiaryBankAccountBody = createBeneficiaryBankAccountRequestDto;

export const zCreateBeneficiaryBankAccountHeaders = z.object({
  'X-Id-Token': z.string(),
  'idempotency-key': z.string(),
});

export const zCreateBeneficiaryBankAccountPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

export const createBeneficiaryBankAccountResponse = createBeneficiaryBankAccountResponseDtoOutput;

export const zUpdateBeneficiaryDetailsBody = updateBeneficiaryDetailsRequestDto;

export const zUpdateBeneficiaryDetailsHeaders = z.object({
  'X-Id-Token': z.string(),
  'idempotency-key': z.string(),
});

export const zUpdateBeneficiaryDetailsPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

export const updateBeneficiaryDetailsResponse = updateBeneficiaryResponseDtoOutput;

export const zDeleteBeneficiaryHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zDeleteBeneficiaryPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Beneficiary deleted. Also returned when it was already deleted (idempotent).
 */
export const deleteBeneficiaryResponse = z.void();

export const zUpdateBeneficiaryBankAccountBody = updateBeneficiaryBankAccountRequestDto;

export const zUpdateBeneficiaryBankAccountHeaders = z.object({
  'X-Id-Token': z.string(),
  'idempotency-key': z.string(),
});

export const zUpdateBeneficiaryBankAccountPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  bankAccountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

export const updateBeneficiaryBankAccountResponse = updateBeneficiaryBankAccountResponseDtoOutput;

export const zDeleteBeneficiaryBankAccountHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zDeleteBeneficiaryBankAccountPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  bankAccountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Bank account deleted. Also returned when this route already deleted it (idempotent). An account removed by deleting its beneficiary is not reachable here: the beneficiary is inactive, so the route answers 409.
 */
export const deleteBeneficiaryBankAccountResponse = z.void();

export const zListDocumentsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zListDocumentsPath = z.object({
  entity: z.enum(['beneficiary', 'incoming-transfer', 'outgoing-transfer']),
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

export const listDocumentsResponse = listDocumentsResponseDtoOutput;

export const zGetDocumentUploadUrlHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetDocumentUploadUrlPath = z.object({
  entity: z.enum(['beneficiary', 'incoming-transfer', 'outgoing-transfer']),
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

export const zGetDocumentUploadUrlQuery = z.object({
  documentName: z.string().min(1).max(255),
});

export const getDocumentUploadUrlResponse = uploadDocumentResponseDtoOutput;

export const zDeleteDocumentHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zDeleteDocumentPath = z.object({
  entity: z.enum(['beneficiary', 'incoming-transfer', 'outgoing-transfer']),
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  documentName: z.string().min(1).max(255),
});

export const zGetChallengeStatusHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetChallengeStatusPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Challenge status retrieved
 */
export const getChallengeStatusResponse = getChallengeResponseDtoOutput;

export const zInitiateEmailChangeChallengeBody = initiateEmailChangeChallengeRequestDto;

export const zInitiateEmailChangeChallengeHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zVerifyEmailChangeChallengeBody = verifyEmailChangeChallengeRequestDto;

export const zVerifyEmailChangeChallengeHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zResendEmailChallengeHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Verification email dispatch enqueued
 */
export const resendEmailChallengeResponse = resendEmailChallengeResponseDtoOutput;

export const zStartLivenessChallengeBody = startLivenessChallengeRequestDto;

export const zStartLivenessChallengeHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Liveness challenge started
 */
export const startLivenessChallengeResponse = startLivenessChallengeResponseDtoOutput;

export const zGetLivenessChallengeStatusHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetLivenessChallengeStatusPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Liveness challenge status retrieved
 */
export const getLivenessChallengeStatusResponse = getLivenessChallengeResponseDtoOutput;

export const zInitiatePhoneChallengeBody = initiatePhoneChallengeRequestDto;

export const zInitiatePhoneChallengeHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Phone challenge initiated, OTP sent
 */
export const initiatePhoneChallengeResponse = initiatePhoneChallengeResponseDtoOutput;

export const zVerifyPhoneChallengeBody = verifyPhoneChallengeRequestDto;

export const zVerifyPhoneChallengeHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Phone number verified and persisted
 */
export const verifyPhoneChallengeResponse = verifyPhoneChallengeResponseDtoOutput;

export const zGetClientHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetClientPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Client details successfully retrieved
 */
export const getClientResponse = getClientResponseDtoOutput;

export const zListClientRelationsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zListClientRelationsPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

export const zListClientRelationsQuery = z.object({
  offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
  limit: z.int().lte(100).optional().default(20),
});

/**
 * Client relations successfully retrieved
 */
export const listClientRelationsResponse = listClientRelationsResponseDtoOutput;

export const zCreateExchangeQuoteBody = createExchangeQuoteRequestDto;

export const zCreateExchangeQuoteHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Exchange quote created
 */
export const createExchangeQuoteResponse = exchangeQuoteResponseDtoOutput;

export const zRefreshExchangeQuoteBody = refreshExchangeQuoteRequestDto;

export const zRefreshExchangeQuoteHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zRefreshExchangeQuotePath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Exchange quote refreshed
 */
export const refreshExchangeQuoteResponse = exchangeQuoteResponseDtoOutput;

export const zCreateExchangeTransactionBody = createExchangeTransactionRequestDto;

export const zCreateExchangeTransactionHeaders = z.object({
  'X-Id-Token': z.string(),
  'idempotency-key': z.string(),
});

/**
 * Exchange transaction created
 */
export const createExchangeTransactionResponse = exchangeTransactionResponseDtoOutput;

export const zGetExchangeTransactionHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetExchangeTransactionPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Exchange transaction retrieved
 */
export const getExchangeTransactionResponse = exchangeTransactionResponseDtoOutput;

export const zListGenericTransactionsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zListGenericTransactionsQuery = z.object({
  offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
  limit: z.int().lte(100).optional().default(20),
  accountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    )
    .optional(),
  type: z.string().optional(),
  transactionNumber: z.string().optional(),
  creationDateTimeFrom: z.iso
    .datetime()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
    )
    .optional(),
  creationDateTimeTo: z.iso
    .datetime()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
    )
    .optional(),
});

/**
 * List of generic transactions successfully retrieved
 */
export const listGenericTransactionsResponse = listGenericTransactionsResponseDtoOutput;

export const zGetGenericTransactionByIdHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetGenericTransactionByIdPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Generic transaction successfully retrieved
 */
export const getGenericTransactionByIdResponse = getGenericTransactionResponseDtoOutput;

export const zExportGenericTransactionConfirmationHeaders = z.object({
  'X-Id-Token': z.string(),
  accept: z.enum(['application/pdf']),
});

export const zExportGenericTransactionConfirmationPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Generic transaction confirmation PDF successfully generated
 */
export const exportGenericTransactionConfirmationResponse = z.string();

export const zListIncomingTransfersHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zListIncomingTransfersQuery = z.object({
  offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
  limit: z.int().lte(100).optional().default(20),
  status: z.enum(['pending', 'on-hold', 'completed', 'failed']).optional(),
  transactionNumber: z.string().optional(),
  senderName: z.string().optional(),
  transferDateFrom: z.iso
    .date()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
    )
    .optional(),
  transferDateTo: z.iso
    .date()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
    )
    .optional(),
  senderInformation: z.string().optional(),
  accountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    )
    .optional(),
});

/**
 * List of incoming transfers successfully retrieved
 */
export const listIncomingTransfersResponse = listIncomingTransfersResponseDtoOutput;

export const zGetIncomingTransferByIdHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetIncomingTransferByIdPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Transfer successfully retrieved
 */
export const getIncomingTransferByIdResponse = getIncomingTransferResponseDtoOutput;

export const zExportIncomingTransferConfirmationHeaders = z.object({
  'X-Id-Token': z.string(),
  accept: z.enum(['application/pdf']),
});

export const zExportIncomingTransferConfirmationPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Incoming transfer confirmation PDF successfully generated
 */
export const exportIncomingTransferConfirmationResponse = z.string();

export const zGetGuardianStatusHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Guardian MFA status retrieved successfully.
 */
export const getGuardianStatusResponse = guardianStatusResponseDtoOutput;

export const zGetNovuBootstrapInfoHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const getNovuBootstrapInfoResponse = bootstrapResponseDtoOutput;

export const zIdentifyNovuSubscriberBody = identifySubscriberRequestDto;

export const zIdentifyNovuSubscriberHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const identifyNovuSubscriberResponse = subscriberResponseDtoOutput;

export const zGetNotificationPreferencesHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Subscriber preferences retrieved successfully
 */
export const getNotificationPreferencesResponse = subscriberPreferencesResponseDtoOutput;

export const zUpdateNotificationPreferencesBody = updateSubscriberPreferencesRequestDto;

export const zUpdateNotificationPreferencesHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zRemoveDeviceTokenBody = removeDeviceTokenRequestDto;

export const zRemoveDeviceTokenHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zSetDeviceTokenBody = deviceTokenRequestDto;

export const zSetDeviceTokenHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zTriggerNotificationBody = triggerNotificationRequestDto;

export const zTriggerNotificationHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const triggerNotificationResponse = triggerNotificationResponseDtoOutput;

export const zCreateOrganizationBody = createOrganizationRequestDto;

export const zCreateOrganizationHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Organization successfully created
 */
export const createOrganizationResponse = createOrganizationResponseDtoOutput;

export const zListOrganizationMembersHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zListOrganizationMembersPath = z.object({
  organizationId: z.string().regex(/^org_/),
});

/**
 * Organization members successfully retrieved
 */
export const listOrganizationMembersResponse = listOrganizationMembersResponseDtoOutput;

export const zDeactivateOrganizationMemberHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zDeactivateOrganizationMemberPath = z.object({
  organizationId: z.string().regex(/^org_/),
  userId: z.string().min(1),
});

/**
 * Member deactivated. Also returned when the user is already not a member (idempotent).
 */
export const deactivateOrganizationMemberResponse = z.void();

export const zInviteOrganizationMemberBody = inviteOrganizationMemberRequestDto;

export const zInviteOrganizationMemberHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zInviteOrganizationMemberPath = z.object({
  organizationId: z.string().regex(/^org_/),
});

/**
 * Invitation successfully created
 */
export const inviteOrganizationMemberResponse = organizationInvitationResponseDtoOutput;

export const zRevokeOrganizationInvitationHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zRevokeOrganizationInvitationPath = z.object({
  organizationId: z.string().regex(/^org_/),
  invitationId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Invitation revoked. Also returned when it was already revoked (idempotent).
 */
export const revokeOrganizationInvitationResponse = z.void();

export const zResendOrganizationInvitationHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zResendOrganizationInvitationPath = z.object({
  organizationId: z.string().regex(/^org_/),
  invitationId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * A new invitation email was sent; any previously sent link is now invalid.
 */
export const resendOrganizationInvitationResponse = z.void();

export const zListReportsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zListReportsQuery = z.object({
  offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
  limit: z.int().lte(100).optional().default(20),
  type: z.enum(['ACCOUNT_TRANSACTIONS_CSV']).optional(),
  accountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    )
    .optional(),
  status: z.enum(['PENDING', 'RUNNING', 'COMPLETED', 'FAILED']).optional(),
});

/**
 * Reports for this client
 */
export const listReportsResponse = listReportsResponseDtoOutput;

export const zCreateReportBody = createReportRequestDto;

export const zCreateReportHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const createReportResponse = z.union([reportResponseDto, reportResponseDtoOutput]);

export const zGetReportDownloadUrlHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetReportDownloadUrlPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Presigned download URL
 */
export const getReportDownloadUrlResponse = downloadReportResponseDtoOutput;

export const zReceiveInventiWebhookBody = inventiWebhookEnvelopeDto;

export const zReceiveInventiWebhookHeaders = z.object({
  'finventi-signature-1': z.string(),
  'finventi-signature-timestamp': z.string(),
  'finventi-receiver-tenant-id': z.string(),
});

export const receiveInventiWebhookResponse = z.union([apiOkResponseDtoOutput, apiOkResponseDto]);

export const zReceiveInventiLiquidityWebhookBody = inventiLiquidityWebhookDto;

export const zReceiveInventiLiquidityWebhookHeaders = z.object({
  'finventi-signature-1': z.string(),
  'finventi-signature-timestamp': z.string(),
  'finventi-receiver-tenant-id': z.string(),
});

export const receiveInventiLiquidityWebhookResponse = apiOkResponseDtoOutput;

export const zGetOutgoingTransferLimitsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetOutgoingTransferLimitsQuery = z.object({
  accountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    )
    .optional(),
});

/**
 * Transfer limits successfully retrieved
 */
export const getOutgoingTransferLimitsResponse = getTransferLimitsResponseDtoOutput;

export const zSetTransferLimitsBody = setTransferLimitRequestDto;

export const zSetTransferLimitsHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Challenge initiated for limit change authorization
 */
export const setTransferLimitsResponse = setTransferLimitResponseDtoOutput;

export const zListOutgoingTransfersHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zListOutgoingTransfersQuery = z.object({
  offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
  limit: z.int().lte(100).optional().default(20),
  accountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    )
    .optional(),
  userId: z.string().optional(),
  transactionNumber: z.string().optional(),
  transferDateFrom: z.iso
    .date()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
    )
    .optional(),
  transferDateTo: z.iso
    .date()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/,
    )
    .optional(),
  amountFrom: z.number().gte(0).optional(),
  amountTo: z.number().gte(0).optional(),
  currency: z.enum(['EUR', 'GBP', 'JPY', 'BHD', 'KWD', 'OMR', 'USD']).optional(),
  status: z
    .enum(['pending', 'processing', 'released', 'completed', 'cancelled', 'failed'])
    .optional(),
});

/**
 * List of outgoing transfers successfully retrieved
 */
export const listOutgoingTransfersResponse = listOutgoingTransfersResponseDtoOutput;

export const zListTransferReasonsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zListTransferReasonsQuery = z.object({
  accountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  country: z.enum([
    'AD',
    'AE',
    'AF',
    'AG',
    'AI',
    'AL',
    'AM',
    'AO',
    'AQ',
    'AR',
    'AS',
    'AT',
    'AU',
    'AW',
    'AX',
    'AZ',
    'BA',
    'BB',
    'BD',
    'BE',
    'BF',
    'BG',
    'BH',
    'BI',
    'BJ',
    'BL',
    'BM',
    'BN',
    'BO',
    'BQ',
    'BR',
    'BS',
    'BT',
    'BV',
    'BW',
    'BY',
    'BZ',
    'CA',
    'CC',
    'CD',
    'CF',
    'CG',
    'CH',
    'CI',
    'CK',
    'CL',
    'CM',
    'CN',
    'CO',
    'CR',
    'CU',
    'CV',
    'CW',
    'CX',
    'CY',
    'CZ',
    'DE',
    'DJ',
    'DK',
    'DM',
    'DO',
    'DZ',
    'EC',
    'EE',
    'EG',
    'EH',
    'ER',
    'ES',
    'ET',
    'FI',
    'FJ',
    'FK',
    'FM',
    'FO',
    'FR',
    'GA',
    'GB',
    'GD',
    'GE',
    'GF',
    'GG',
    'GH',
    'GI',
    'GL',
    'GM',
    'GN',
    'GP',
    'GQ',
    'GR',
    'GS',
    'GT',
    'GU',
    'GW',
    'GY',
    'HK',
    'HM',
    'HN',
    'HR',
    'HT',
    'HU',
    'ID',
    'IE',
    'IL',
    'IM',
    'IN',
    'IO',
    'IQ',
    'IR',
    'IS',
    'IT',
    'JE',
    'JM',
    'JO',
    'JP',
    'KE',
    'KG',
    'KH',
    'KI',
    'KM',
    'KN',
    'KP',
    'KR',
    'KW',
    'KY',
    'KZ',
    'LA',
    'LB',
    'LC',
    'LI',
    'LK',
    'LR',
    'LS',
    'LT',
    'LU',
    'LV',
    'LY',
    'MA',
    'MC',
    'MD',
    'ME',
    'MF',
    'MG',
    'MH',
    'MK',
    'ML',
    'MM',
    'MN',
    'MO',
    'MP',
    'MQ',
    'MR',
    'MS',
    'MT',
    'MU',
    'MV',
    'MW',
    'MX',
    'MY',
    'MZ',
    'NA',
    'NC',
    'NE',
    'NF',
    'NG',
    'NI',
    'NL',
    'NO',
    'NP',
    'NR',
    'NU',
    'NZ',
    'OM',
    'PA',
    'PE',
    'PF',
    'PG',
    'PH',
    'PK',
    'PL',
    'PM',
    'PN',
    'PR',
    'PS',
    'PT',
    'PW',
    'PY',
    'QA',
    'RE',
    'RO',
    'RS',
    'RU',
    'RW',
    'SA',
    'SB',
    'SC',
    'SD',
    'SE',
    'SG',
    'SH',
    'SI',
    'SJ',
    'SK',
    'SL',
    'SM',
    'SN',
    'SO',
    'SR',
    'SS',
    'ST',
    'SV',
    'SX',
    'SY',
    'SZ',
    'TC',
    'TD',
    'TF',
    'TG',
    'TH',
    'TJ',
    'TK',
    'TL',
    'TM',
    'TN',
    'TO',
    'TR',
    'TT',
    'TV',
    'TW',
    'TZ',
    'UA',
    'UG',
    'UM',
    'US',
    'UY',
    'UZ',
    'VA',
    'VC',
    'VE',
    'VG',
    'VI',
    'VN',
    'VU',
    'WF',
    'WS',
    'XK',
    'YE',
    'YT',
    'ZA',
    'ZM',
    'ZW',
  ]),
});

/**
 * Transfer reasons successfully retrieved
 */
export const listTransferReasonsResponse = listTransferReasonsResponseDtoOutput;

export const zListCommonTransferReasonsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zListCommonTransferReasonsQuery = z.object({
  accountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  countries: z.string(),
});

/**
 * Common transfer reasons successfully retrieved
 */
export const listCommonTransferReasonsResponse = listTransferReasonsResponseDtoOutput;

export const zGetTransferDateMetadataHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetTransferDateMetadataQuery = z.object({
  accountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  scheme: z.enum([
    'swift',
    'local',
    'sepa',
    'sepa-instant',
    'sepa-target-2',
    'sepa-target-2-pacs009',
    'chaps',
    'bacs',
    'faster-payments',
    'faster-payments-poo',
    'ach',
    'wire',
    'eft',
  ]),
});

/**
 * Transfer date metadata successfully retrieved
 */
export const getTransferDateMetadataResponse = getOutgoingTransferDateMetadataResponseDtoOutput;

export const zGetReachableTransferSchemesHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetReachableTransferSchemesQuery = z.object({
  sourceAccountId: z.string(),
  beneficiaryIban: z.string().optional(),
  beneficiaryAccountNumber: z.string().optional(),
});

export const getReachableTransferSchemesResponse = reachableSchemesResponseDtoOutput;

export const zGetOutgoingTransferByIdHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetOutgoingTransferByIdPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Transfer successfully retrieved
 */
export const getOutgoingTransferByIdResponse = getOutgoingTransferResponseDtoOutput;

export const zExportOutgoingTransferConfirmationHeaders = z.object({
  'X-Id-Token': z.string(),
  accept: z.enum(['application/pdf']),
});

export const zExportOutgoingTransferConfirmationPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Outgoing transfer confirmation PDF successfully generated
 */
export const exportOutgoingTransferConfirmationResponse = z.string();

export const zCreateInternalTransferBody = createInternalOutgoingTransferRequestDto;

export const zCreateInternalTransferHeaders = z.object({
  'X-Id-Token': z.string(),
  'idempotency-key': z.string(),
});

export const createInternalTransferResponse = z.union([
  createOutgoingTransferResponseDto,
  createOutgoingTransferChallengeResponseDto,
]);

export const zCreateExternalTransferBody = createExternalOutgoingTransferRequestDto;

export const zCreateExternalTransferHeaders = z.object({
  'X-Id-Token': z.string(),
  'idempotency-key': z.string(),
});

export const createExternalTransferResponse = z.union([
  createOutgoingTransferResponseDto,
  createOutgoingTransferChallengeResponseDto,
]);

export const zDryRunInternalTransferBody = createInternalOutgoingTransferRequestDto;

export const zDryRunInternalTransferHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Dry run transfer successfully validated
 */
export const dryRunInternalTransferResponse = dryRunOutgoingTransferResponseDtoOutput;

export const zDryRunExternalTransferBody = createExternalOutgoingTransferRequestDto;

export const zDryRunExternalTransferHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Dry run transfer successfully validated
 */
export const dryRunExternalTransferResponse = dryRunOutgoingTransferResponseDtoOutput;

export const zResolveOutgoingTransferChallengeBody = resolveChallengeRequestDto;

export const zResolveOutgoingTransferChallengeHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Challenge resolved and transfer executed successfully
 */
export const resolveOutgoingTransferChallengeResponse = createOutgoingTransferResponseDtoOutput;

export const zListPaymentBatchesHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zListPaymentBatchesQuery = z.object({
  offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
  limit: z.int().lte(100).optional().default(20),
  direction: z.enum(['incoming', 'outgoing']).optional(),
  status: z.string().optional(),
  reference: z.string().max(35).optional(),
  createdFrom: z.iso
    .datetime()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
    )
    .optional(),
  createdTo: z.iso
    .datetime()
    .regex(
      /^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/,
    )
    .optional(),
});

/**
 * Batches retrieved
 */
export const listPaymentBatchesResponse = listPaymentBatchesResponseDtoOutput;

export const zCreatePaymentBatchBody = createPaymentBatchRequestDto;

export const zCreatePaymentBatchHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Batch created — `loading`, or `draft` when no rows are expected
 */
export const createPaymentBatchResponse = paymentBatchResponseDtoOutput;

export const zGetSddAccountLimitsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetSddAccountLimitsQuery = z.object({
  accountId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Limits and usage retrieved
 */
export const getSddAccountLimitsResponse = getSddAccountLimitsResponseDtoOutput;

export const zDeletePaymentBatchHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zDeletePaymentBatchPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Batch deleted
 */
export const deletePaymentBatchResponse = z.void();

export const zGetPaymentBatchHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetPaymentBatchPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Batch retrieved
 */
export const getPaymentBatchResponse = paymentBatchResponseDtoOutput;

export const zUpdatePaymentBatchBody = updatePaymentBatchRequestDto;

export const zUpdatePaymentBatchHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zUpdatePaymentBatchPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Batch updated
 */
export const updatePaymentBatchResponse = paymentBatchResponseDtoOutput;

export const zRemovePaymentBatchItemsBody = removePaymentBatchItemsRequestDto;

export const zRemovePaymentBatchItemsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zRemovePaymentBatchItemsPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Rows removed
 */
export const removePaymentBatchItemsResponse = removePaymentBatchItemsResponseDtoOutput;

export const zListPaymentBatchItemsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zListPaymentBatchItemsPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

export const zListPaymentBatchItemsQuery = z.object({
  offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
  limit: z.int().lte(100).optional().default(20),
  status: z.string().optional(),
});

/**
 * Items retrieved
 */
export const listPaymentBatchItemsResponse = listPaymentBatchItemsResponseDtoOutput;

export const zAddPaymentBatchItemsBody = addPaymentBatchItemsRequestDto;

export const zAddPaymentBatchItemsHeaders = z.object({
  'X-Id-Token': z.string(),
  'idempotency-key': z.string(),
});

export const zAddPaymentBatchItemsPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Items created — pending and invalid alike, in request order
 */
export const addPaymentBatchItemsResponse = paymentBatchItemsResponseDtoOutput;

export const zUpdatePaymentBatchItemBody = updatePaymentBatchItemRequestDto;

export const zUpdatePaymentBatchItemHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zUpdatePaymentBatchItemPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  itemId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Item updated
 */
export const updatePaymentBatchItemResponse = paymentBatchItemResponseDtoOutput;

export const zForceApprovePaymentBatchItemHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zForceApprovePaymentBatchItemPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  itemId: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Item force-approved
 */
export const forceApprovePaymentBatchItemResponse = paymentBatchItemResponseDtoOutput;

export const zForceApprovePaymentBatchItemsBody = forceApprovePaymentBatchItemsRequestDto;

export const zForceApprovePaymentBatchItemsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zForceApprovePaymentBatchItemsPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Rows force-approved
 */
export const forceApprovePaymentBatchItemsResponse = forceApprovePaymentBatchItemsResponseDtoOutput;

export const zVerifyPaymentBatchHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zVerifyPaymentBatchPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Verification started, or the batch unchanged for a no-op
 */
export const verifyPaymentBatchResponse = paymentBatchResponseDtoOutput;

export const zDryRunPaymentBatchHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zDryRunPaymentBatchPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Dry run started, or the batch unchanged for a no-op
 */
export const dryRunPaymentBatchResponse = paymentBatchResponseDtoOutput;

export const zInitiatePaymentBatchSubmitChallengeHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zInitiatePaymentBatchSubmitChallengePath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Challenge initiated for the submission
 */
export const initiatePaymentBatchSubmitChallengeResponse =
  paymentBatchSubmitChallengeResponseDtoOutput;

export const zResolvePaymentBatchSubmitChallengeBody = resolvePaymentBatchSubmitChallengeRequestDto;

export const zResolvePaymentBatchSubmitChallengeHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zResolvePaymentBatchSubmitChallengePath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Batch scheduled for execution
 */
export const resolvePaymentBatchSubmitChallengeResponse = paymentBatchResponseDtoOutput;

export const zCancelPaymentBatchHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zCancelPaymentBatchPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Batch cancelled
 */
export const cancelPaymentBatchResponse = paymentBatchResponseDtoOutput;

export const zClonePaymentBatchBody = clonePaymentBatchRequestDto;

export const zClonePaymentBatchHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zClonePaymentBatchPath = z.object({
  id: z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
});

/**
 * Draft clone created
 */
export const clonePaymentBatchResponse = paymentBatchResponseDtoOutput;

export const zDeleteAllOtherSessionsHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * All other sessions revoked
 */
export const deleteAllOtherSessionsResponse = z.void();

export const zGetActiveSessionsHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Active sessions retrieved successfully.
 */
export const getActiveSessionsResponse = activeSessionListResponseDtoOutput;

export const zDeleteCurrentSessionHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Current session revoked
 */
export const deleteCurrentSessionResponse = z.void();

export const zDeleteSessionHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zDeleteSessionPath = z.object({
  sid: z.string().min(1),
});

/**
 * Session revoked
 */
export const deleteSessionResponse = z.void();

export const zEvaluateLoginBody = evaluateLoginRequestDto;

export const zEvaluateLoginPath = z.object({
  id: z.string().min(1),
});

/**
 * Risk evaluation, additional claims to set in the JWT and metadata.
 */
export const evaluateLoginResponse = evaluateLoginResponseDtoOutput;

export const zEvaluateRegistrationBody = evaluateRegistrationRequestDto;

/**
 * Allow / deny decision.
 */
export const evaluateRegistrationResponse = evaluateRegistrationResponseDtoOutput;

export const zCollectBasicInfoBody = collectBasicInfoRequestDto;

export const zCollectBasicInfoHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zCollectBasicInfoPath = z.object({
  id: z.string().min(1).max(255),
});

export const collectBasicInfoResponse = collectBasicInfoResponseDtoOutput;

export const zGetUserContextsHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const getUserContextsResponse = getContextsResponseDtoOutput;

export const zGetProfilePictureUrlHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetProfilePictureUrlPath = z.object({
  id: z.string().min(1).max(255),
});

/**
 * Presigned URL for accessing profile picture.
 */
export const getProfilePictureUrlResponse = getProfilePictureResponseDtoOutput;

export const zGetProfilePictureUploadUrlHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Presigned URL for uploading profile picture.
 */
export const getProfilePictureUploadUrlResponse = uploadProfilePictureResponseDtoOutput;

export const zGetUserByIdHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetUserByIdPath = z.object({
  id: z.string().min(1).max(255),
});

export const getUserByIdResponse = getUserResponseDtoOutput;

export const zSetAccountLivenessLockPath = z.object({
  id: z.string().min(1).max(255),
});

/**
 * Liveness lock set successfully.
 */
export const setAccountLivenessLockResponse = setLivenessLockResponseDtoOutput;

export const zGetKycStatusHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetKycStatusPath = z.object({
  id: z.string().min(1).max(255),
});

/**
 * KYC status successfully retrieved with verification details and computed fields.
 */
export const getKycStatusResponse = getKycStatusResponseDtoOutput;

export const zGenerateKycLinkBody = generateKycLinkBodyDto;

export const zGenerateKycLinkHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGenerateKycLinkPath = z.object({
  id: z.string().min(1).max(255),
});

/**
 * KYC verification link successfully generated. Use the returned URL to redirect the user.
 */
export const generateKycLinkResponse = generateVerificationLinkResponseDtoOutput;

export const zGetKybStatusHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGetKybStatusPath = z.object({
  organizationId: z.string().min(1).max(255),
});

/**
 * KYB status successfully retrieved with verification details and computed fields.
 */
export const getKybStatusResponse = getKybStatusResponseDtoOutput;

export const zGenerateKybLinkHeaders = z.object({
  'X-Id-Token': z.string(),
});

export const zGenerateKybLinkPath = z.object({
  organizationId: z.string().min(1).max(255),
});

/**
 * KYB verification link successfully generated. Use the returned URL to redirect the user.
 */
export const generateKybLinkResponse = generateVerificationLinkResponseDtoOutput;

export const zStartSddCreditorCollectionHeaders = z.object({
  'X-Id-Token': z.string(),
});

/**
 * Collection started
 */
export const startSddCreditorCollectionResponse = startSddCreditorCollectionResponseDtoOutput;

export const zDecodeTemporalPayloadsBody = decodeRequestDto;

/**
 * Decoded payloads
 */
export const decodeTemporalPayloadsResponse = decodeResponseDtoOutput;

/**
 * Upstream API connectivity status
 */
export const checkUpstreamHealthResponse = getUpstreamHealthResponseDtoOutput;

/**
 * Auth0 webhook payload. Structure varies by event type.
 */
export const zReceiveAuth0WebhookBody = z.union([userCreatedRequestDto, auth0WebhookRequestDto]);

export const receiveAuth0WebhookResponse = z.union([apiOkResponseDtoOutput, apiOkResponseDto]);

export const zReceiveAuth0LogStreamBody = z.array(z.string());

export const receiveAuth0LogStreamResponse = apiOkResponseDtoOutput;

/**
 * Integrated Finance webhook payload. Structure varies by module and event type.
 */
export const zReceiveIntegratedFinanceWebhookBody = z.union([
  clientCreatedRequestDto,
  accountActivatedRequestDto,
  accountInactivatedRequestDto,
]);

export const zReceiveIntegratedFinanceWebhookHeaders = z.object({
  'x-webhook-signature': z.string(),
  'x-webhook-content-digest': z.string(),
  'x-webhook-event-id': z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  'x-webhook-event-timestamp': z.string(),
  'x-webhook-request-id': z
    .uuid()
    .regex(
      /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/,
    ),
  'x-webhook-request-timestamp': z.string(),
  'x-webhook-key-version': z.string(),
});

export const receiveIntegratedFinanceWebhookResponse = z.union([
  apiOkResponseDtoOutput,
  apiOkResponseDto,
]);

export const zReceiveSumsubWebhookHeaders = z.object({
  'x-payload-digest': z.string(),
  'x-payload-digest-alg': z.enum(['HMAC_SHA256_HEX', 'HMAC_SHA512_HEX']),
  'idempotency-key': z.string(),
});

export const receiveSumsubWebhookResponse = z.union([apiOkResponseDtoOutput, apiOkResponseDto]);

/**
 * NestJS application metrics retrieved successfully
 */
export const getDefaultMetricsResponse = augmentedZodDtoOutput;

/**
 * Express HTTP metrics retrieved successfully
 */
export const getExpressMetricsResponse = augmentedZodDtoOutput;

/**
 * Application health check
 */
export const checkHealthResponse = getHealthResponseDtoOutput;
